var bodyScrollLockOptions = {
  reserveScrollBarGap: false,
};

/* eslint-disable */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}


const trapFocusHandlers = {};

function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button, button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
   console.log(container)
  // console.log(elements)
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
      if (
          event.target !== container &&
          event.target !== last &&
          event.target !== first
      )
          return;

      document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
          (event.target === container || event.target === first) &&
          event.shiftKey
      ) {
          event.preventDefault();
          last.focus();
      }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

document.querySelectorAll('[role="button"]').forEach(el => {
  el.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      el.click();
    }
  });
});

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (
      var _i = arr[Symbol.iterator](), _s;
      !(_n = (_s = _i.next()).done);
      _n = true
    ) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}

function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter))
    return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(receiver);
      }
      return desc.value;
    };
  }
  return _get(target, property, receiver || target);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true },
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj;
    };
  }
  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

(function ($) {
  var $ = (jQuery = $);
  var cc = {
    sections: [],
  };
  theme.Shopify = {
    formatMoney: function formatMoney(t, r) {
      function e(t, r) {
        return void 0 === t ? r : t;
      }

      function a(t, r, a, o) {
        if (
          ((r = e(r, 2)),
          (a = e(a, ",")),
          (o = e(o, ".")),
          isNaN(t) || null == t)
        )
          return 0;

        // t = (t / 100).toFixed(r);
        t = `${Math.round(t / 100)}`;
        var n = t.split(".");
        return (
          n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
          (n[1] ? o + n[1] : "")
        );
      }

      "string" == typeof t && (t = t.replace(".", ""));
      var o = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        i = r || this.money_format;

      switch (i.match(n)[1]) {
        case "amount":
          o = a(t, 2);
          break;

        case "amount_no_decimals":
          o = a(t, 0, "", ".");
          break;

        case "amount_with_comma_separator":
          o = a(t, 2, ".", ",");
          break;

        case "amount_with_space_separator":
          o = a(t, 2, " ", ",");
          break;

        case "amount_with_period_and_space_separator":
          o = a(t, 2, " ", ".");
          break;

        case "amount_no_decimals_with_comma_separator":
          o = a(t, 0, ".", ",");
          break;

        case "amount_no_decimals_with_space_separator":
          o = a(t, 0, " ", "");
          break;

        case "amount_with_apostrophe_separator":
          o = a(t, 2, "'", ".");
          break;

        case "amount_with_decimal_separator":
          o = a(t, 2, ".", ".");
      }

      let final = i.replace(n, o);
      let includesCurrency = false
      if (final.includes(window.theme.currencySymbol) || final.includes(window.theme.currencyIso)) {
        includesCurrency = true;
      }

      final = final.replace(".", "").replace(window.theme.currencySymbol, "").replace(window.theme.currencyIso, "");      
      if (includesCurrency) final = final + " " + window.theme.currencyIso;

      return final;
    },
    formatImage: function formatImage(originalImageUrl, format) {
      return originalImageUrl.replace(
        /^(.*)\.([^\.]*)$/g,
        "$1_" + format + ".$2"
      );
    },
    Image: {
      imageSize: function imageSize(t) {
        var e = t.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );
        return null !== e ? e[1] : null;
      },
      getSizedImageUrl: function getSizedImageUrl(t, e) {
        if (null == e) return t;
        if ("master" == e) return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (null != o) {
          var i = t.split(o[0]),
            r = o[0];
          return this.removeProtocol(i[0] + "_" + e + r);
        }

        return null;
      },
      removeProtocol: function removeProtocol(t) {
        return t.replace(/http(s)?:/, "");
      },
    },
  };

  var ccComponent = /*#__PURE__*/ (function () {
    "use strict";

    function ccComponent(name) {
      var cssSelector =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : ".cc-".concat(name);

      _classCallCheck(this, ccComponent);

      var _this = this; // Initialize any instance of this component within a section

      $(document).on("cc:component:load", function (event, component, target) {
        if (
          component === name &&
          $(target).find("".concat(cssSelector, ":not(.cc-initialized)"))
            .length > 0
        ) {
          _this.init($(target).find(cssSelector));
        }
      }); // Destroy any instance of this component within a section

      $(document).on(
        "cc:component:unload",
        function (event, component, target) {
          if (component === name) {
            _this.destroy($(target).find(cssSelector));
          }
        }
      ); // Initialize any other instance of this component

      $("".concat(cssSelector, ":not(.cc-initialized)")).each(function () {
        _this.init($(this));
      });
    }

    _createClass(ccComponent, [
      {
        key: "init",
        value: function init($container) {
          $container.addClass("cc-initialized");
        },
      },
      {
        key: "destroy",
        value: function destroy($container) {
          $container.removeClass("cc-initialized");
        },
      },
    ]);

    return ccComponent;
  })(); // requires: throttled-scroll, debouncedresize

  theme.Sections = new (function () {
    var _ = this;

    _._instances = [];
    _._deferredSectionTargets = [];
    _._sections = [];
    _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport

    _._deferredWatcherRunning = false;

    _.init = function () {
      $(document)
        .on("shopify:section:load", function (e) {
          // load a new section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);

          if (target) {
            _.sectionLoad(target);
          }
        })
        .on("shopify:section:unload", function (e) {
          // unload existing section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);

          if (target) {
            _.sectionUnload(target);
          }
        });
      $(window).on(
        "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
        _._processDeferredSections
      );
      _._deferredWatcherRunning = true;
    }; // register a type of section

    _.register = function (type, section, options) {
      _._sections.push({
        type: type,
        section: section,
        afterSectionLoadCallback: options ? options.afterLoad : null,
        afterSectionUnloadCallback: options ? options.afterUnload : null,
      }); // load now

      $('[data-section-type="' + type + '"]').each(function () {
        if (
          Shopify.designMode ||
          (options && options.deferredLoad === false) ||
          !_._deferredWatcherRunning
        ) {
          _.sectionLoad(this);
        } else {
          _.sectionDeferredLoad(this, options);
        }
      });
    }; // prepare a section to load later

    _.sectionDeferredLoad = function (target, options) {
      _._deferredSectionTargets.push({
        target: target,
        deferredLoadViewportExcess:
          options && options.deferredLoadViewportExcess
            ? options.deferredLoadViewportExcess
            : _._deferredLoadViewportExcess,
      });

      _._processDeferredSections(true);
    }; // load deferred sections if in/near viewport

    _._processDeferredSections = function (firstRunCheck) {
      if (_._deferredSectionTargets.length) {
        var viewportTop = $(window).scrollTop(),
          viewportBottom = viewportTop + $(window).height(),
          loopStart =
            firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;

        for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {
          var target = _._deferredSectionTargets[i].target,
            viewportExcess =
              _._deferredSectionTargets[i].deferredLoadViewportExcess,
            sectionTop = $(target).offset().top - viewportExcess,
            doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;

          if (!doLoad) {
            var sectionBottom =
              sectionTop + $(target).outerHeight() + viewportExcess * 2;
            doLoad =
              sectionBottom > viewportTop && sectionBottom < viewportBottom;
          }

          if (
            doLoad ||
            (sectionTop < viewportTop && sectionBottom > viewportBottom)
          ) {
            // in viewport, load
            _.sectionLoad(target); // remove from deferred queue and resume checks

            _._deferredSectionTargets.splice(i, 1);

            i--;
          }
        }
      } // remove event if no more deferred targets left, if not on first run

      if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {
        _._deferredWatcherRunning = false;
        $(window).off(".themeSectionDeferredLoader");
      }
    }; // load in a section

    _.sectionLoad = function (target) {
      var target = target,
        sectionObj = _._sectionForTarget(target),
        section = false;

      if (sectionObj.section) {
        section = sectionObj.section;
      } else {
        section = sectionObj;
      }

      if (section !== false) {
        var instance = {
          target: target,
          section: section,
          $shopifySectionContainer: $(target).closest(".shopify-section"),
          thisContext: {
            functions: section.functions,
          },
        };

        _._instances.push(instance); //Initialise any components

        if ($(target).data("components")) {
          //Init each component
          var components = $(target).data("components").split(",");
          components.forEach(function (component) {
            $(document).trigger("cc:component:load", [component, target]);
          });
        }

        _._callWith(section, "onSectionLoad", target, instance.thisContext);

        _._callWith(
          section,
          "afterSectionLoadCallback",
          target,
          instance.thisContext
        ); // attach additional UI events if defined

        if (section.onSectionSelect) {
          instance.$shopifySectionContainer.on(
            "shopify:section:select",
            function (e) {
              _._callWith(
                section,
                "onSectionSelect",
                e.target,
                instance.thisContext
              );
            }
          );
        }

        if (section.onSectionDeselect) {
          instance.$shopifySectionContainer.on(
            "shopify:section:deselect",
            function (e) {
              _._callWith(
                section,
                "onSectionDeselect",
                e.target,
                instance.thisContext
              );
            }
          );
        }

        if (section.onBlockSelect) {
          $(target).on("shopify:block:select", function (e) {
            _._callWith(
              section,
              "onBlockSelect",
              e.target,
              instance.thisContext
            );
          });
        }

        if (section.onBlockDeselect) {
          $(target).on("shopify:block:deselect", function (e) {
            _._callWith(
              section,
              "onBlockDeselect",
              e.target,
              instance.thisContext
            );
          });
        }
      }
    }; // unload a section

    _.sectionUnload = function (target) {
      var sectionObj = _._sectionForTarget(target);

      var instanceIndex = -1;

      for (var i = 0; i < _._instances.length; i++) {
        if (_._instances[i].target == target) {
          instanceIndex = i;
        }
      }

      if (instanceIndex > -1) {
        var instance = _._instances[instanceIndex]; // remove events and call unload, if loaded

        $(target).off("shopify:block:select shopify:block:deselect");
        instance.$shopifySectionContainer.off(
          "shopify:section:select shopify:section:deselect"
        );

        _._callWith(
          instance.section,
          "onSectionUnload",
          target,
          instance.thisContext
        );

        _._callWith(
          sectionObj,
          "afterSectionUnloadCallback",
          target,
          instance.thisContext
        );

        _._instances.splice(instanceIndex); //Destroy any components

        if ($(target).data("components")) {
          //Init each component
          var components = $(target).data("components").split(",");
          components.forEach(function (component) {
            $(document).trigger("cc:component:unload", [component, target]);
          });
        }
      } else {
        // check if it was a deferred section
        for (var i = 0; i < _._deferredSectionTargets.length; i++) {
          if (_._deferredSectionTargets[i].target == target) {
            _._deferredSectionTargets[i].splice(i, 1);

            break;
          }
        }
      }
    }; // helpers

    _._callWith = function (object, method, param, thisContext) {
      if (typeof object[method] === "function") {
        if (thisContext) {
          object[method].bind(thisContext)(param);
        } else {
          object[method](param);
        }
      }
    };

    _._themeSectionTargetFromShopifySectionTarget = function (target) {
      var $target = $("[data-section-type]:first", target);

      if ($target.length > 0) {
        return $target[0];
      } else {
        return false;
      }
    };

    _._sectionForTarget = function (target) {
      var type = $(target).attr("data-section-type");

      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return _._sections[i];
        }
      }

      return false;
    };

    _._sectionAlreadyRegistered = function (type) {
      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return true;
        }
      }

      return false;
    };
  })(); // Loading third party scripts

  theme.scriptsLoaded = {};

  theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
    if (typeof theme.scriptsLoaded[src] === "undefined") {
      theme.scriptsLoaded[src] = [];
      var tag = document.createElement("script");
      tag.src = src;

      if (sync || beforeRun) {
        tag.async = false;
      }

      if (beforeRun) {
        beforeRun();
      }

      if (typeof callback === "function") {
        theme.scriptsLoaded[src].push(callback);

        if (tag.readyState) {
          // IE, incl. IE9
          tag.onreadystatechange = function () {
            if (tag.readyState == "loaded" || tag.readyState == "complete") {
              tag.onreadystatechange = null;

              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }

              theme.scriptsLoaded[this] = true;
            }
          }.bind(src);
        } else {
          tag.onload = function () {
            // Other browsers
            for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }

            theme.scriptsLoaded[this] = true;
          }.bind(src);
        }
      }

      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      return true;
    } else if (
      _typeof(theme.scriptsLoaded[src]) === "object" &&
      typeof callback === "function"
    ) {
      theme.scriptsLoaded[src].push(callback);
    } else {
      if (typeof callback === "function") {
        callback();
      }

      return false;
    }
  };

  theme.loadStyleOnce = function (src) {
    var srcWithoutProtocol = src.replace(/^https?:/, "");

    if (
      !document.querySelector(
        'link[href="' + encodeURI(srcWithoutProtocol) + '"]'
      )
    ) {
      var tag = document.createElement("link");
      tag.href = srcWithoutProtocol;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      var firstTag = document.getElementsByTagName("link")[0];
      firstTag.parentNode.insertBefore(tag, firstTag);
    }
  };

  theme.Disclosure = (function () {
    var selectors = {
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };
    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};

      this._cacheSelectors();

      this._connectOptions();

      this._connectToggle();

      this._onFocusOut();
    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function _cacheSelectors() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions),
        };
      },
      _connectToggle: function _connectToggle() {
        this.cache.$disclosureToggle.on(
          "click",
          function (evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr("aria-expanded") === "true";
            $(evt.currentTarget).attr("aria-expanded", !ariaExpanded);
            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },
      _connectOptions: function _connectOptions() {
        this.cache.$disclosureOptions.on(
          "click",
          function (evt) {
            evt.preventDefault();

            this._submitForm($(evt.currentTarget).data("value"));
          }.bind(this)
        );
      },
      _onFocusOut: function _onFocusOut() {
        this.cache.$disclosureToggle.on(
          "focusout",
          function (evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;

            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );
        this.cache.$disclosureList.on(
          "focusout",
          function (evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );

            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );
        this.$container.on(
          "keyup",
          function (evt) {
            if (evt.which !== 27) return; // escape

            this._hideList();

            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );

        this.bodyOnClick = function (evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this);

        $("body").on("click", this.bodyOnClick);
      },
      _submitForm: function _submitForm(value) {
        this.cache.$disclosureInput.val(value);
        this.$container.parents("form").submit();
      },
      _hideList: function _hideList() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr("aria-expanded", false);
      },
      unload: function unload() {
        $("body").off("click", this.bodyOnClick);
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      },
    });
    return Disclosure;
  })(); /// Show a short-lived text popup above an element

  theme.showQuickPopup = function (message, $origin) {
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup
      .html(message)
      .css({
        left: offs.left,
        top: offs.top,
      })
      .hide();
    $("body").append($popup);
    $popup.css({
      marginTop: -$popup.outerHeight() - 10,
      marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2,
    });
    $popup
      .fadeIn(200)
      .delay(3500)
      .fadeOut(400, function () {
        $(this).remove();
      });
  }; //v1.0

  $.fn.sort = [].sort; // v1.0

  $.fn.fadeOutAndRemove = function (speed, callback) {
    $(this).fadeOut(speed, function () {
      $(this).remove();
      typeof callback == "function" && callback();
    });
  }; // Turn a <select> tag into clicky boxes
  // Use with: $('select').clickyBoxes()

  $.fn.clickyBoxes = function (prefix) {
    if (prefix == "destroy") {
      $(this).off(".clickyboxes");
      $(this).next(".clickyboxes").off(".clickyboxes");
    } else {
      return $(this)
        .filter("select:not(.clickybox-replaced)")
        .addClass("clickybox-replaced")
        .each(function () {
          //Make sure rows are unique
          var prefix = prefix || $(this).attr("id"); //Create container

          var $optCont = $('<ul class="clickyboxes"/>')
            .attr("id", "clickyboxes-" + prefix)
            .data("select", $(this))
            .insertAfter(this);
          var $label;

          if ($(this).is("[id]")) {
            $label = $('label[for="' + $(this).attr("id") + '"]'); // Grab real label
          } else {
            $label = $(this).siblings("label"); // Rough guess
          }

          if ($label.length > 0) {
            $optCont.addClass(
              "options-" +
                removeDiacritics($label.text())
                  .toLowerCase()
                  .replace(/'/g, "")
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-+/g, "-")
                  .replace(/-*$/, "")
            );
          } //Add options to container

          $(this)
            .find("option")
            .each(function () {
              $("<li/>")
                .appendTo($optCont)
                .append(
                  $('<a href="#"/>')
                    .attr("data-value", $(this).val())
                    .html($(this).html())
                    .addClass(
                      "opt--" +
                        removeDiacritics($(this).text())
                          .toLowerCase()
                          .replace(/'/g, "")
                          .replace(/[^a-z0-9]+/g, "-")
                          .replace(/-+/g, "-")
                          .replace(/-*$/, "")
                    )
                );
            }); //Select change event

          $(this)
            .hide()
            .addClass("replaced")
            .on("change.clickyboxes keyup.clickyboxes", function () {
              //Choose the right option to show
              var val = $(this).val();
              $optCont
                .find("a")
                .removeClass("active")
                .filter(function () {
                  return $(this).attr("data-value") == val;
                })
                .addClass("active");
            })
            .trigger("keyup"); //Initial value
          //Button click event

          $optCont.on("click.clickyboxes", "a", function () {
            if (!$(this).hasClass("active")) {
              var $clicky = $(this).closest(".clickyboxes");
              $clicky
                .data("select")
                .val($(this).data("value"))
                .trigger("change");
              $clicky.trigger("change");
            }

            return false;
          });
        });
    }
  }; // v1.0
  //Find out how wide scrollbars are on this browser

  $.scrollBarWidth = function () {
    var $temp = $("<div/>")
      .css({
        width: 100,
        height: 100,
        overflow: "scroll",
        position: "absolute",
        top: -9999,
      })
      .prependTo("body");
    var w = $temp[0].offsetWidth - $temp[0].clientWidth;
    $temp.remove();
    return w;
  }; //Restyle all select dropdowns
  //NOTE: Only for us on showcase until this can be replaced with jquery.selectreplace.v1.0.js

  var chevronDownIcon =
    '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>';

  $.fn.selectReplace = function (leaveLabel) {
    return $(this)
      .filter("select:not(.replaced, .noreplace)")
      .each(function () {
        //Add formatting containers
        var $opts = $(this).find("option");
        var initialText =
          $opts.filter(":selected").length > 0
            ? $opts.filter(":selected").text()
            : $opts.first().text();
        var $cont = $(this)
          .addClass("replaced")
          .wrap('<div class="pretty-select">')
          .parent()
          .addClass("id-" + $(this).attr("id"))
          .append(
            '<span class="text"><span class="value">' +
              initialText +
              "</span></span>" +
              chevronDownIcon
          ); //Label? Move inside

        if ($(this).attr("id")) {
          //Find label
          var $label = $('label[for="' + $(this).attr("id") + '"]'); //If table cells used for layout, do not move the label

          var $selectTD = $(this).closest("td");
          var $labelTD = $label.closest("td");

          if (
            !leaveLabel &&
            ($selectTD.length == 0 ||
              $labelTD.length == 0 ||
              $selectTD[0] == $labelTD[0])
          ) {
            //Add to dropdown
            var $labelSpan = $('<span class="label">')
              .html($label.html())
              .prependTo($cont.find(".text")); //Add colon, if it doesn't exist

            // if ($labelSpan.slice(-1) != ":") {
            //   $labelSpan.append(":");
            // } // remove label element and use aria

            $cont.find("select").attr("aria-label", $label.text());
            $label.remove();
          }
        }
      })
      .on("change keyup", function () {
        $(this)
          .siblings(".text")
          .find(".value")
          .html($(this).find(":selected").html());
      });
  };

  $.fn.ccHoverLine = function (opts) {
    $(this).each(function () {
      var $this = $(this);

      if (!$this.hasClass("cc-init")) {
        var updateLine = function updateLine() {
          var $link =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : $this.find('li a[aria-selected="true"], li a.active');

          if ($link.length === 1) {
            $hoverLine.css({
              width: $link.width(),
              top: $link.position().top + $link.outerHeight(),
              left: $link.position().left,
            });
          }
        };

        $this.append("<li class='cc-hover-line'></li>").addClass("cc-init");
        var $hoverLine = $(this).find(".cc-hover-line");

        if (opts && opts.lineCss) {
          $hoverLine.css(opts.lineCss);
        }

        updateLine();

        if ($(window).outerWidth() < 768) {
          $(this)
            .find("li")
            .click(function () {
              var $link = $(this).find("a");

              if ($link.length === 1) {
                updateLine($link);
              }
            });
        } else {
          $(this)
            .find("li")
            .hover(
              function () {
                var $link = $(this).find("a");

                if ($link.length === 1) {
                  updateLine($link);
                }
              },
              function () {
                updateLine();
              }
            );
        }

        $(window).on("debouncedresizewidth", function () {
          updateLine();
        });
      }
    });
  };

  (function () {
    function throttle(callback, threshold) {
      var debounceTimeoutId = -1;
      var tick = false;
      return function () {
        clearTimeout(debounceTimeoutId);
        debounceTimeoutId = setTimeout(callback, threshold);

        if (!tick) {
          callback.call();
          tick = true;
          setTimeout(function () {
            tick = false;
          }, threshold);
        }
      };
    }

    var scrollEvent = document.createEvent("Event");
    scrollEvent.initEvent("throttled-scroll", true, true);
    window.addEventListener(
      "scroll",
      throttle(function () {
        window.dispatchEvent(scrollEvent);
      }, 200)
    );
  })();

  theme.cartNoteMonitor = {
    load: function load($notes) {
      $notes.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        }
      );
    },
    unload: function unload($notes) {
      $notes.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function postUpdate(val) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId);
      theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
        $.post(
          theme.routes.cart_url + "/update.js",
          {
            note: val,
          },
          function (data) {},
          "json"
        );
      }, theme.cartNoteMonitor.updateThrottleInterval);
    },
  };
  new /*#__PURE__*/ ((function (_ccComponent) {
    "use strict";

    _inherits(_class, _ccComponent);

    var _super = _createSuper(_class);

    function _class() {
      _classCallCheck(this, _class);

      return _super.apply(this, arguments);
    }

    _createClass(_class, [
      {
        key: "init",
        value: function init($container) {
          _get(_getPrototypeOf(_class.prototype), "init", this).call(
            this,
            $container
          ); //Emit's an event to indicate a tab is being changed. Also includes the difference in height
          //between the closing and opening tab

          function dispatchTabChangedEvent() {
            var event = new CustomEvent("cc-tab-changed");
            window.dispatchEvent(event);
          }

          $container.on("click", "[data-cc-toggle-panel]", function () {
            var $tabs = $(this).closest(".cc-tabs");
            var tabIndexToShow = $(this).data("cc-toggle-panel");
            var $tabToClose = $tabs.find(".cc-tabs__tab__panel:visible");
            var $tabToOpen = $tabs.find(
              '.cc-tabs__tab .cc-tabs__tab__panel[aria-labelledby="product-tab-panel'.concat(
                tabIndexToShow,
                '"]'
              )
            );
            var openAllTabs = $(this).closest(
              '.cc-tabs[data-cc-tab-allow-multi-open="true"]'
            ).length;

            if ($tabs.hasClass("cc-tabs--tab-mode")) {
              $tabToClose.attr("hidden", "");
              $tabToOpen.removeAttr("hidden");
              $tabs
                .find('[role="tab"] [aria-selected="true"]')
                .removeAttr("aria-selected");
              $tabs
                .find('[data-cc-toggle-panel="'.concat(tabIndexToShow, '"]'))
                .attr("aria-selected", "true");
            } else {
              var accordionSpeed = 300;

              if (!openAllTabs) {
                var tabNeedsClosing = $tabToClose.length;
                var tabNeedsOpening =
                  $tabToOpen.attr("id") !== $tabToClose.attr("id") &&
                  $tabToOpen.length;
              } else {
                if ($tabToOpen.is(":visible")) {
                  var tabNeedsClosing = true;
                  var tabNeedsOpening = false;
                  $tabToClose = $tabToOpen;
                } else {
                  var tabNeedsClosing = false;
                  var tabNeedsOpening = true;
                }
              } // On mobile, all accordions can be open at once

              if ($(window).outerWidth() < 768) {
                if ($tabToOpen.is(":visible")) {
                  tabNeedsClosing = true;
                  tabNeedsOpening = false;
                  $tabToClose = $tabToOpen;
                } else {
                  tabNeedsClosing = false;
                }
              }

              if (tabNeedsClosing) {
                $tabToClose.slideUp(accordionSpeed, function () {
                  $(this).attr("hidden", "");

                  if (!tabNeedsOpening) {
                    dispatchTabChangedEvent();
                  }
                });
                $tabToClose.prev().removeAttr("aria-selected");
              }

              if (tabNeedsOpening) {
                $tabToOpen
                  .css("display", "none")
                  .removeAttr("hidden")
                  .slideDown(accordionSpeed, dispatchTabChangedEvent);
                $tabToOpen.prev().attr("aria-selected", "true");
              }
            }

            return false;
          });

          if ($container.hasClass("cc-tabs--tab-mode")) {
            $container.find(".cc-tabs__tab-headers").ccHoverLine();
          }
        },
      },
      {
        key: "destroy",
        value: function destroy($container) {
          _get(_getPrototypeOf(_class.prototype), "destroy", this).call(
            this,
            $container
          );

          $container.off("click", "[data-cc-toggle-panel]");
        },
      },
    ]);

    return _class;
  })(ccComponent))("tabs");

  (function ($) {
    $.fn.initAnimateOnScroll = function () {
      if (Waypoint) {
        Waypoint.refreshAll();
      }

      if (
        ($(".cc-animate-enabled").length && $(window).outerWidth() >= 768) ||
        ($(".cc-animate-enabled-mobile").length && $(window).outerWidth() < 768)
      ) {
        //Animates all of the children in an element (staggered)
        $("[data-cc-animate-children]:not(.cc-animate-init)").each(function () {
          var animation = $(this).data("cc-animate-children")
            ? $(this).data("cc-animate-children")
            : "cc-fade-in";
          $(this)
            .find("> *")
            .each(function (index) {
              $(this)
                .attr("data-cc-animate", animation)
                .attr("data-cc-animate-delay", (index + 1) / 10 + "s");
            });
          $(this).addClass("cc-animate-init");
        });

        $("[data-cc-animate]:not(.cc-animate-init)").each(function () {
          //Allows you to set the animation delay
          if ($(this).attr("data-cc-animate-delay")) {
            $(this).css("transition-delay", $(this).data("cc-animate-delay"));
          } //Allows you to set the animation duration

          if ($(this).attr("data-cc-animate-duration")) {
            $(this).css(
              "transition-duration",
              $(this).data("cc-animate-duration")
            );
          } //Get the animation type if any (e.g. cc-fade-in-up)

          var animation = $(this).data("cc-animate"); //Init the waypoint

          $(this)
            .addClass(animation)
            .addClass("cc-animate-init")
            .waypoint({
              handler: function handler(direction) {
                var $elem = $(this.element);

                if (!$elem.hasClass("cc-animate-complete")) {
                  // console.log($elem.attr('class'));
                  setTimeout(function () {
                    $elem.addClass("-in").addClass("cc-animate-complete");
                  }, 200);
                  setTimeout(function () {
                    //Once the animation is complete (assume 5 seconds), remove the animate attribute
                    //to remove all css
                    $elem
                      .removeAttr("data-cc-animate")
                      .css("transition-duration", "")
                      .css("transition-delay", "");
                  }, 5000);
                }
              },
              offset: $(this).data("cc-animate-offset")
                ? $(this).data("cc-animate-offset")
                : "100%",
            });
        });
      }
    };

    $.fn.initAnimateOnScroll();
    $(window).on("debouncedresizewidth", $.fn.initAnimateOnScroll);
    $(document).on("shopify:section:load shopify:section:unload", function () {
      setTimeout($.fn.initAnimateOnScroll, 100);
    });
    $(window).on('load', $.fn.initAnimateOnScroll);
  })(theme.jQuery);

  var ccPopup = /*#__PURE__*/ (function () {
    "use strict";

    function ccPopup($container, namespace) {
      _classCallCheck(this, ccPopup);

      this.$container = $container;
      this.namespace = namespace;
      this.cssClasses = {
        visible: "cc-popup--visible",
        bodyNoScroll: "cc-popup-no-scroll",
        bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
      };
    }
    /**
     * Open popup on timer / local storage - move focus to input ensure you can tab to submit and close
     * Add the cc-popup--visible class
     * Update aria to visible
     */

    _createClass(ccPopup, [
      {
        key: "open",
        value: function open(callback) {
          var _this2 = this;

          // Prevent the body from scrolling
          if (this.$container.data("freeze-scroll")) {
            $("body").addClass(this.cssClasses.bodyNoScroll); // Add any padding necessary to the body to compensate for the scrollbar that just disappeared

            var scrollDiv = document.createElement("div");
            scrollDiv.className = "popup-scrollbar-measure";
            document.body.appendChild(scrollDiv);
            var scrollbarWidth =
              scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);

            if (scrollbarWidth > 0) {
              $("body")
                .css("padding-right", scrollbarWidth + "px")
                .addClass(this.cssClasses.bodyNoScrollPadRight);
            }
          } // Add reveal class

          this.$container.addClass(this.cssClasses.visible); // Track previously focused element

          this.previouslyActiveElement = document.activeElement; // Focus on the close button after the animation in has completed

          setTimeout(function () {
            _this2.$container.find(".cc-popup-close")[0].focus();
          }, 500); // Pressing escape closes the modal

          $(window).on("keydown" + this.namespace, function (event) {
            if (event.keyCode === 27) {
              _this2.close();
            }
          });

          if (callback) {
            callback();
          }
        },
      },
      {
        key: "close",

        /**
         * Close popup on click of close button or background - where does the focus go back to?
         * Remove the cc-popup--visible class
         */
        value: function close(callback) {
          var _this3 = this;

          // Remove reveal class
          this.$container.removeClass(this.cssClasses.visible); // Revert focus

          if (this.previouslyActiveElement) {
            $(this.previouslyActiveElement).focus();
          } // Destroy the escape event listener

          $(window).off("keydown" + this.namespace); // Allow the body to scroll and remove any scrollbar-compensating padding

          if (this.$container.data("freeze-scroll")) {
            var transitionDuration = 500;
            var $innerModal = this.$container.find(".cc-popup-modal");

            if ($innerModal.length) {
              transitionDuration = parseFloat(
                getComputedStyle($innerModal[0])["transitionDuration"]
              );

              if (transitionDuration && transitionDuration > 0) {
                transitionDuration *= 1000;
              }
            }

            setTimeout(function () {
              $("body")
                .removeClass(_this3.cssClasses.bodyNoScroll)
                .removeClass(_this3.cssClasses.bodyNoScrollPadRight)
                .css("padding-right", "0");
            }, transitionDuration);
          }

          if (callback) {
            callback();
          }
        },
      },
    ]);

    return ccPopup;
  })(); // Manage videos

  theme.VideoManager = new (function () {
    var _ = this;

    _._permitPlayback = function (container) {
      return !(
        $(container).hasClass("video-container--background") &&
        $(window).outerWidth() < 768
      );
    }; // Youtube

    _.youtubeVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector:
        '.video-container[data-video-type="youtube"]:not(.video--init)',
    };

    _.youtubeApiReady = function () {
      _.youtubeVars.apiReady = true;

      _._loadYoutubeVideos();
    };

    _._loadYoutubeVideos = function (container) {
      if ($(_.youtubeVars.toProcessSelector, container).length) {
        if (_.youtubeVars.apiReady) {
          // play those videos
          $(_.youtubeVars.toProcessSelector, container).each(function () {
            // Don't init background videos on mobile
            if (_._permitPlayback($(this))) {
              $(this).addClass("video--init");
              _.youtubeVars.incrementor++;
              var containerId = "theme-yt-video-" + _.youtubeVars.incrementor;
              $(this).data("video-container-id", containerId);
              var videoElement = $(
                '<div class="video-container__video-element">'
              )
                .attr("id", containerId)
                .appendTo($(".video-container__video", this));
              var autoplay = $(this).data("video-autoplay");
              var loop = $(this).data("video-loop");
              var player = new YT.Player(containerId, {
                height: "360",
                width: "640",
                videoId: $(this).data("video-id"),
                playerVars: {
                  iv_load_policy: 3,
                  modestbranding: 1,
                  autoplay: autoplay ? 1 : 0,
                  loop: loop ? 1 : 0,
                  playlist: $(this).data("video-id"),
                  rel: 0,
                  showinfo: 0,
                },
                events: {
                  onReady: _._onYoutubePlayerReady.bind({
                    autoplay: autoplay,
                    loop: loop,
                    $container: $(this),
                  }),
                  onStateChange: _._onYoutubePlayerStateChange.bind({
                    autoplay: autoplay,
                    loop: loop,
                    $container: $(this),
                  }),
                },
              });
              _.youtubeVars.videoData[containerId] = {
                id: containerId,
                container: this,
                videoElement: videoElement,
                player: player,
              };
            }
          });
        } else {
          // load api
          theme.loadScriptOnce("https://www.youtube.com/iframe_api");
        }
      }
    };

    _._onYoutubePlayerReady = function (event) {
      event.target.setPlaybackQuality("hd1080");

      if (this.autoplay) {
        event.target.mute();
        event.target.playVideo();
      }

      _._initBackgroundVideo(this.$container);
    };

    _._onYoutubePlayerStateChange = function (event) {
      if (event.data == YT.PlayerState.PLAYING) {
        this.$container.addClass("video--play-started");

        if (this.autoplay) {
          event.target.mute();
        }

        if (this.loop) {
          // 4 times a second, check if we're in the final second of the video. If so, loop it for a more seamless loop
          var finalSecond = event.target.getDuration() - 1;

          if (finalSecond > 2) {
            var loopTheVideo = function loopTheVideo() {
              if (event.target.getCurrentTime() > finalSecond) {
                event.target.seekTo(0);
              }

              setTimeout(loopTheVideo, 250);
            };

            loopTheVideo();
          }
        }
      }
    };

    _._unloadYoutubeVideos = function (container) {
      for (var dataKey in _.youtubeVars.videoData) {
        var data = _.youtubeVars.videoData[dataKey];

        if ($(container).find(data.container).length) {
          data.player.destroy();
          delete _.youtubeVars.videoData[dataKey];
          return;
        }
      }
    }; // Vimeo

    _.vimeoVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector:
        '.video-container[data-video-type="vimeo"]:not(.video--init)',
    };

    _.vimeoApiReady = function () {
      _.vimeoVars.apiReady = true;

      _._loadVimeoVideos();
    };

    _._loadVimeoVideos = function (container) {
      if ($(_.vimeoVars.toProcessSelector, container).length) {
        if (_.vimeoVars.apiReady) {
          // play those videos
          $(_.vimeoVars.toProcessSelector, container).each(function () {
            // Don't init background videos on mobile
            if (_._permitPlayback($(this))) {
              $(this).addClass("video--init");
              _.vimeoVars.incrementor++;
              var $this = $(this);
              var containerId = "theme-vi-video-" + _.vimeoVars.incrementor;
              $(this).data("video-container-id", containerId);
              var videoElement = $(
                '<div class="video-container__video-element">'
              )
                .attr("id", containerId)
                .appendTo($(".video-container__video", this));
              var autoplay = !!$(this).data("video-autoplay");
              var player = new Vimeo.Player(containerId, {
                url: $(this).data("video-url"),
                width: 640,
                loop: $(this).data("video-autoplay"),
                autoplay: autoplay,
              });
              player.on(
                "playing",
                function () {
                  $(this).addClass("video--play-started");
                }.bind(this)
              );
              player.ready().then(function () {
                if (autoplay) {
                  player.setVolume(0);
                  player.play();
                }

                if (
                  player.element &&
                  player.element.width &&
                  player.element.height
                ) {
                  var ratio =
                    parseInt(player.element.height) /
                    parseInt(player.element.width);
                  $this
                    .find(".video-container__video")
                    .css("padding-bottom", ratio * 100 + "%");
                }

                _._initBackgroundVideo($this);
              });
              _.vimeoVars.videoData[containerId] = {
                id: containerId,
                container: this,
                videoElement: videoElement,
                player: player,
                autoPlay: autoplay,
              };
            }
          });
        } else {
          // load api
          if (window.define) {
            // workaround for third parties using RequireJS
            theme.loadScriptOnce(
              "https://player.vimeo.com/api/player.js",
              function () {
                _.vimeoVars.apiReady = true;

                _._loadVimeoVideos();

                window.define = window.tempDefine;
              },
              function () {
                window.tempDefine = window.define;
                window.define = null;
              }
            );
          } else {
            theme.loadScriptOnce(
              "https://player.vimeo.com/api/player.js",
              function () {
                _.vimeoVars.apiReady = true;

                _._loadVimeoVideos();
              }
            );
          }
        }
      }
    };

    _._unloadVimeoVideos = function (container) {
      for (var dataKey in _.vimeoVars.videoData) {
        var data = _.vimeoVars.videoData[dataKey];

        if ($(container).find(data.container).length) {
          data.player.unload();
          delete _.vimeoVars.videoData[dataKey];
          return;
        }
      }
    }; // Init third party apis - Youtube and Vimeo

    _._loadThirdPartyApis = function (container) {
      //Don't init youtube or vimeo background videos on mobile
      if (_._permitPlayback($(".video-container", container))) {
        _._loadYoutubeVideos(container);

        _._loadVimeoVideos(container);
      }
    }; // Mp4

    _.mp4Vars = {
      incrementor: 0,
      videoData: {},
      toProcessSelector:
        '.video-container[data-video-type="mp4"]:not(.video--init)',
    };

    _._loadMp4Videos = function (container) {
      if ($(_.mp4Vars.toProcessSelector, container).length) {
        // play those videos
        $(_.mp4Vars.toProcessSelector, container)
          .addClass("video--init")
          .each(function () {
            _.mp4Vars.incrementor++;
            var $this = $(this);
            var containerId = "theme-mp-video-" + _.mp4Vars.incrementor;
            $(this).data("video-container-id", containerId);
            var videoElement = $('<div class="video-container__video-element">')
              .attr("id", containerId)
              .appendTo($(".video-container__video", this));
            var $video = $("<video playsinline>");

            if ($(this).data("video-loop")) {
              $video.attr("loop", "loop");
            }

            if ($(this).data("video-autoplay")) {
              $video.attr({
                autoplay: "autoplay",
                muted: "muted",
              });
              $video[0].muted = true; // required by Chrome - ignores attribute

              $video.one("loadeddata", function () {
                this.play();
              });
            }

            $video.on(
              "playing",
              function () {
                $(this).addClass("video--play-started");
              }.bind(this)
            );
            const width = $(window).width();
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
              navigator.userAgent
            )
              ? true
              : width < 1025;
            console.log($(this).attr("data-video-url-mobile"));

            if (isMobile && $(this).attr("data-video-url-mobile")) {
              console.log("here");
              $video
                .attr("src", $(this).attr("data-video-url-mobile"))
                .appendTo(videoElement);
            } else {
              $video
                .attr("src", $(this).data("video-url"))
                .appendTo(videoElement);
            }
          });
      }
    };

    _._unloadMp4Videos = function (container) {}; // background video placement for iframes

    _._initBackgroundVideo = function ($container) {
      if (
        $container.hasClass("video-container--background") &&
        $container.find(".video-container__video iframe").length
      ) {
        var assessBackgroundVideo = function assessBackgroundVideo() {
          var $container = this,
            cw = $container.width(),
            ch = $container.height(),
            cr = cw / ch,
            $frame = $(".video-container__video iframe", this),
            vr = $frame.attr("width") / $frame.attr("height"),
            $pan = $(".video-container__video", this),
            vCrop = 75; // pushes video outside container to hide controls

          if (cr > vr) {
            var vh = cw / vr + vCrop * 2;
            $pan.css({
              marginTop: (ch - vh) / 2 - vCrop,
              marginLeft: "",
              height: vh + vCrop * 2,
              width: "",
            });
          } else {
            var vw = cw * vr + vCrop * 2 * vr;
            $pan.css({
              marginTop: -vCrop,
              marginLeft: (cw - vw) / 2,
              height: ch + vCrop * 2,
              width: vw,
            });
          }
        };

        assessBackgroundVideo.bind($container)();
        $(window).on(
          "debouncedresize." + $container.data("video-container-id"),
          assessBackgroundVideo.bind($container)
        );
      }
    }; // Compatibility with Sections

    this.onSectionLoad = function (container) {
      // url only - infer type
      $(".video-container[data-video-url]:not([data-video-type])").each(
        function () {
          var url = $(this).data("video-url");

          if (url.indexOf(".mp4") > -1) {
            $(this).attr("data-video-type", "mp4");
          }

          if (url.indexOf("vimeo.com") > -1) {
            $(this).attr("data-video-type", "vimeo");
            $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
          }

          if (url.indexOf("youtu.be") > -1 || url.indexOf("youtube.com") > -1) {
            $(this).attr("data-video-type", "youtube");

            if (url.indexOf("v=") > -1) {
              $(this).attr(
                "data-video-id",
                url.split("v=").pop().split("&")[0]
              );
            } else {
              $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
            }
          }
        }
      );

      _._loadThirdPartyApis(container);

      _._loadMp4Videos(container);

      $(window).on("debouncedresize.video-manager-resize", function () {
        _._loadThirdPartyApis(container);
      }); // play button

      $(".video-container__play", container).on("click", function (evt) {
        evt.preventDefault();
        var $container = $(this).closest(".video-container"); // reveal

        $container.addClass("video-container--playing"); // broadcast a play event on the section container

        $(container).trigger("cc:video:play"); // play

        var id = $container.data("video-container-id");

        if (id.indexOf("theme-yt-video") === 0) {
          _.youtubeVars.videoData[id].player.playVideo();
        } else {
          _.vimeoVars.videoData[id].player.play();
        }
      }); // modal close button

      $(".video-container__stop", container).on("click", function (evt) {
        evt.preventDefault();
        var $container = $(this).closest(".video-container"); // hide

        $container.removeClass("video-container--playing"); // broadcast a stop event on the section container

        $(container).trigger("cc:video:stop"); // play

        var id = $container.data("video-container-id");

        if (id.indexOf("theme-yt-video") === 0) {
          _.youtubeVars.videoData[id].player.stopVideo();
        } else {
          _.vimeoVars.videoData[id].player.pause();

          _.vimeoVars.videoData[id].player.setCurrentTime(0);
        }
      });
    };

    this.onSectionUnload = function (container) {
      $(".video-container__play, .video-container__stop", container).off(
        "click"
      );
      $(window).off("." + $(".video-container").data("video-container-id"));
      $(window).off("debouncedresize.video-manager-resize");

      _._unloadYoutubeVideos(container);

      _._unloadVimeoVideos(container);

      _._unloadMp4Videos(container);

      $(container).trigger("cc:video:stop");
    };
  })(); // Youtube API callback

  window.onYouTubeIframeAPIReady = function () {
    theme.VideoManager.youtubeApiReady();
  }; // Register the section

  cc.sections.push({
    name: "video",
    section: theme.VideoManager,
  });
  theme.MapSection = new (function () {
    var _ = this;

    _.config = {
      zoom: 14,
      styles: {
        default: [],
        silver: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
        retro: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#ebe3cd",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#523735",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f1e6",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#c9b2a6",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#dcd2be",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#ae9e90",
              },
            ],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [
              {
                color: "#dfd2ae",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#dfd2ae",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#93817c",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#a5b076",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#447530",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f1e6",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#fdfcf8",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#f8c967",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#e9bc62",
              },
            ],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#e98d58",
              },
            ],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#db8555",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#806b63",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#dfd2ae",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8f7d77",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#ebe3cd",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#dfd2ae",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#b9d3c2",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#92998d",
              },
            ],
          },
        ],
        dark: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#181818",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1b1b1b",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c2c2c",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8a8a8a",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#373737",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#3c3c3c",
              },
            ],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#4e4e4e",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#000000",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3d3d3d",
              },
            ],
          },
        ],
        night: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#242f3e",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#746855",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#242f3e",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#d59563",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#d59563",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#263c3f",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#6b9a76",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#38414e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#212a37",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9ca5b3",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#746855",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#1f2835",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#f3d19c",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#2f3948",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#d59563",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#17263c",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#515c6d",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#17263c",
              },
            ],
          },
        ],
        aubergine: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8ec3b9",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1a3646",
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#4b6878",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#64779e",
              },
            ],
          },
          {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#4b6878",
              },
            ],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#334e87",
              },
            ],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [
              {
                color: "#023e58",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#283d6a",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#6f9ba5",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#023e58",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3C7680",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#304a7d",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#98a5be",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#2c6675",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#255763",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#b0d5ce",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#023e58",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#98a5be",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1d2c4d",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#283d6a",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#3a4762",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#0e1626",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#4e6d70",
              },
            ],
          },
        ],
      },
    };
    _.apiStatus = null;

    this.geolocate = function ($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data("address-setting");
      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            deferred.reject(status);
          }

          deferred.resolve(results);
        }
      );
      return deferred;
    };

    this.createMap = function (container) {
      var $map = $(".map-section__map-container", container);
      return _.geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: _.config.zoom,
              styles: _.config.styles[$(container).data("map-style")],
              center: results[0].geometry.location,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
              zoomControl: true,
            };
            _.map = new google.maps.Map($map[0], mapOptions);
            _.center = _.map.getCenter();
            var marker = new google.maps.Marker({
              map: _.map,
              position: _.center,
              clickable: false,
            });
            google.maps.event.addDomListener(window, "resize", function () {
              google.maps.event.trigger(_.map, "resize");

              _.map.setCenter(_.center);
            });
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = theme.strings.addressNoResults;
              break;

            case "OVER_QUERY_LIMIT":
              errorMessage = theme.strings.addressQueryLimit;
              break;

            default:
              errorMessage = theme.strings.addressError;
              break;
          } // Only show error in the theme editor

          if (Shopify.designMode) {
            var $mapContainer = $map.parents(".map-section");
            $mapContainer.addClass("page-width map-section--load-error");
            $mapContainer
              .find(".map-section__wrapper")
              .html(
                '<div class="errors text-center">' + errorMessage + "</div>"
              );
          }
        });
    };

    this.onSectionLoad = function (target) {
      var $container = $(target); // Global function called by Google on auth errors

      window.gm_authFailure = function () {
        if (!Shopify.designMode) return;
        $container.addClass("page-width map-section--load-error");
        $container
          .find(".map-section__wrapper")
          .html(
            '<div class="errors text-center">' +
              theme.strings.authError +
              "</div>"
          );
      }; // create maps

      var key = $container.data("api-key");

      if (typeof key !== "string" || key === "") {
        return;
      } // load map

      theme.loadScriptOnce(
        "https://maps.googleapis.com/maps/api/js?key=" + key,
        function () {
          _.createMap($container);
        }
      );
    };

    this.onSectionUnload = function (target) {
      if (
        typeof window.google !== "undefined" &&
        typeof google.maps !== "undefined"
      ) {
        google.maps.event.clearListeners(this.map, "resize");
      }
    };
  })(); // Register the section

  cc.sections.push({
    name: "map",
    section: theme.MapSection,
  }); // A section that contains other sections, e.g. story page

  theme.NestedSectionsSection = new (function () {
    this.onSectionLoad = function (container) {
      // load child sections
      $("[data-nested-section-type]", container).each(function () {
        var type = $(this).attr("data-nested-section-type");
        var section = null;

        for (var i = 0; i < theme.Sections._sections.length; i++) {
          if (theme.Sections._sections[i].type == type) {
            section = theme.Sections._sections[i].section;
          }
        }

        if (section) {
          var instance = {
            target: this,
            section: section,
            $shopifySectionContainer: $(this).closest(".shopify-section"),
            thisContext: {},
          };

          theme.Sections._instances.push(instance);

          $(this).data("themeSectionInstance", instance);
          section.onSectionLoad.bind(instance.thisContext)(this);
        }
      });
    };

    this.onSectionUnload = function (container) {
      // unload child sections
      $("[data-nested-section-type]", container).each(function () {
        theme.Sections.sectionUnload.bind(
          $(this).data("themeSectionInstance").thisContext
        )(this);
      });
    };

    this.onBlockSelect = function (target) {
      // scroll to block
      $(window).scrollTop($(target).offset().top - 100);
    };
  })(); // Register the section

  cc.sections.push({
    name: "nested-sections",
    section: theme.NestedSectionsSection,
  });
  /**
   * Popup Section Script
   * ------------------------------------------------------------------------------
   *
   * @namespace Popup
   */

  theme.Popup = new (function () {
    /**
     * Popup section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    var dismissedStorageKey = "cc-theme-popup-dismissed";
    this.onSectionLoad = function (container) {
      var _this4 = this;

      var z = JSON.parse(localStorage.getItem("geoip-location"));
      if (container.getAttribute("data-geolocation-settings") !== "") {
        this.options = JSON.parse(
          container.getAttribute("data-geolocation-settings")
        );
      }

      if (z) {
        var x = z.value.country.iso_code;
        var eu =
          "AT;BE;BG;HR;CY;CZ;DK;EE;FI;FR;DE;GR;HU;IE;IT;LV;LT;LU;MT;NL;PL;PT;RO;SK;SI;ES;SE";
        if (eu.includes(x)) {
          x = eu;
        }
        if (this.options[x]) {
          container.querySelector(".geolocation-title").innerHTML =
            this.options[x]["Title"];
          container.querySelector(".geolocation-content").innerHTML =
            this.options[x]["Text"];
        }
      }

      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.popup = new ccPopup(this.$container, this.namespace);
      var dismissForDays = this.$container.data("dismiss-for-days"),
        delaySeconds = this.$container.data("delay-seconds"),
        showPopup = true,
        testMode = this.$container.data("test-mode"),
        lastDismissed = window.localStorage.getItem(dismissedStorageKey); // Should we show it during this page view?
      // Check when it was last dismissed

      if (lastDismissed) {
        var dismissedDaysAgo =
          (new Date().getTime() - lastDismissed) / (1000 * 60 * 60 * 24);

        if (dismissedDaysAgo < dismissForDays) {
          showPopup = false;
        }
      } // Check for error or success messages

      if (this.$container.find(".cc-popup-form__response").length) {
        showPopup = true;
        delaySeconds = 1; // If success, set as dismissed

        if (this.$container.find(".cc-popup-form__response--success").length) {
          this.functions.popupSetAsDismissed.call(this);
        }
      } // Prevent popup on Shopify robot challenge page

      if (/^\/[^\/]{2,3}\/challenge$/.test(window.location.pathname)) {
        showPopup = false;
      } // Show popup, if appropriate

      if (showPopup || testMode) {
        setTimeout(function () {
          _this4.popup.open();
        }, delaySeconds * 1000);
      } // Click on close button or modal background

      this.$container.on(
        "click" + this.namespace,
        ".cc-popup-close, .cc-popup-background",
        function () {
          _this4.popup.close(function () {
            _this4.functions.popupSetAsDismissed.call(_this4);
          });
        }
      );
    };

    this.onSectionSelect = function () {
      this.popup.open();
    };

    this.functions = {
      /**
       * Use localStorage to set as dismissed
       */
      popupSetAsDismissed: function popupSetAsDismissed() {
        window.localStorage.setItem(dismissedStorageKey, new Date().getTime());
      },
    };
    /**
     * Event callback for Theme Editor `section:unload` event
     */

    this.onSectionUnload = function () {
      this.$container.off(this.namespace);
    };
  })(); // Register section

  cc.sections.push({
    name: "newsletter-popup",
    section: theme.Popup,
  });
  /**
   * StoreAvailability Section Script
   * ------------------------------------------------------------------------------
   *
   * @namespace StoreAvailability
   */

  theme.StoreAvailability = function (container) {
    var loadingClass = "store-availability-loading";
    var initClass = "store-availability-initialized";
    var storageKey = "cc-location";

    this.onSectionLoad = function (container) {
      var _this5 = this;

      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.productId = this.$container.data("store-availability-container");
      this.sectionUrl = this.$container.data("section-url");
      this.$modal;
      var firstRun = true; // Handle when a variant is selected

      $(window).on(
        "cc-variant-updated".concat(this.namespace).concat(this.productId),
        function (e, args) {
          if (args.product.id === _this5.productId) {
            _this5.functions.updateContent.bind(_this5)(
              args.variant.id,
              args.product.title,
              firstRun,
              _this5.$container.data("has-only-default-variant"),
              typeof args.variant.available !== "undefined"
            );

            firstRun = false;
          }
        }
      ); // Handle single variant products

      if (this.$container.data("single-variant-id")) {
        this.functions.updateContent.bind(this)(
          this.$container.data("single-variant-id"),
          this.$container.data("single-variant-product-title"),
          firstRun,
          this.$container.data("has-only-default-variant"),
          this.$container.data("single-variant-product-available")
        );
        firstRun = false;
      }
    };

    this.onSectionUnload = function () {
      $(window).off(
        "cc-variant-updated".concat(this.namespace).concat(this.productId)
      );
      this.$container.off("click");

      if (this.$modal) {
        this.$modal.off("click");
      }
    };

    this.functions = {
      // Returns the users location data (if allowed)
      getUserLocation: function getUserLocation() {
        return new Promise(function (resolve, reject) {
          var storedCoords;

          if (sessionStorage[storageKey]) {
            storedCoords = JSON.parse(sessionStorage[storageKey]);
          }

          if (storedCoords) {
            resolve(storedCoords);
          } else {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                function (position) {
                  var coords = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                  }; //Set the localization api

                  fetch("/localization.json", {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(coords),
                  }); //Write to a session storage

                  sessionStorage[storageKey] = JSON.stringify(coords);
                  resolve(coords);
                },
                function () {
                  resolve(false);
                },
                {
                  maximumAge: 3600000,
                  // 1 hour
                  timeout: 5000,
                }
              );
            } else {
              resolve(false);
            }
          }
        });
      },
      // Requests the available stores and calls the callback
      getAvailableStores: function getAvailableStores(variantId, cb) {
        return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
      },
      // Haversine Distance
      // The haversine formula is an equation giving great-circle distances between
      // two points on a sphere from their longitudes and latitudes
      calculateDistance: function calculateDistance(
        coords1,
        coords2,
        unitSystem
      ) {
        var dtor = Math.PI / 180;
        var radius = unitSystem === "metric" ? 6378.14 : 3959;
        var rlat1 = coords1.latitude * dtor;
        var rlong1 = coords1.longitude * dtor;
        var rlat2 = coords2.latitude * dtor;
        var rlong2 = coords2.longitude * dtor;
        var dlon = rlong1 - rlong2;
        var dlat = rlat1 - rlat2;
        var a =
          Math.pow(Math.sin(dlat / 2), 2) +
          Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return radius * c;
      },
      // Updates the existing modal pickup with locations with distances from the user
      updateLocationDistances: function updateLocationDistances(coords) {
        var unitSystem = this.$modal
          .find("[data-unit-system]")
          .data("unit-system");
        var self = this;
        this.$modal.find('[data-distance="false"]').each(function () {
          var _this6 = this;

          var thisCoords = {
            latitude: parseFloat($(this).data("latitude")),
            longitude: parseFloat($(this).data("longitude")),
          };

          if (thisCoords.latitude && thisCoords.longitude) {
            var distance = self.functions
              .calculateDistance(coords, thisCoords, unitSystem)
              .toFixed(1);
            $(this).html(distance); //Timeout to trigger animation

            setTimeout(function () {
              $(_this6)
                .closest(".store-availability-list__location__distance")
                .addClass("-in");
            }, 0);
          }

          $(this).attr("data-distance", "true");
        });
      },
      // Requests the available stores and updates the page with info below Add to Basket, and append the modal to the page
      updateContent: function updateContent(
        variantId,
        productTitle,
        firstRun,
        isSingleDefaultVariant,
        isVariantAvailable
      ) {
        var _this7 = this;

        this.$container.off("click", "[data-store-availability-modal-open]");
        this.$container.off(
          "click" + this.namespace,
          ".cc-popup-close, .cc-popup-background"
        );
        $(".store-availabilities-modal").remove();

        if (firstRun) {
          this.$container.hide();
        } else if (!isVariantAvailable) {
          //If the variant is Unavailable (not the same as Out of Stock) - hide the store pickup completely
          this.$container.addClass(loadingClass).addClass(initClass);
          this.$container.css("height", "0px");
        } else {
          this.$container.addClass(loadingClass).addClass(initClass);
          this.$container.css(
            "height",
            this.$container.outerHeight() > 0
              ? this.$container.outerHeight() + "px"
              : "auto"
          );
        }

        if (isVariantAvailable) {
          this.functions.getAvailableStores.call(
            this,
            variantId,
            function (response) {
              if (
                response.trim().length > 0 &&
                !response.includes("NO_PICKUP")
              ) {
                _this7.$container.html(response);

                _this7.$container.html(
                  _this7.$container.children().first().html()
                ); // editor bug workaround

                _this7.$container
                  .find("[data-store-availability-modal-product-title]")
                  .html(productTitle);

                if (isSingleDefaultVariant) {
                  _this7.$container
                    .find(".store-availabilities-modal__variant-title")
                    .remove();
                }

                _this7.$container.find(".cc-popup").appendTo("body");

                _this7.$modal = $("body").find(".store-availabilities-modal");
                var popup = new ccPopup(_this7.$modal, _this7.namespace);

                _this7.$container.on(
                  "click",
                  "[data-store-availability-modal-open]",
                  function () {
                    popup.open(); //When the modal is opened, try and get the users location

                    _this7.functions.getUserLocation().then(function (coords) {
                      if (
                        coords &&
                        _this7.$modal.find('[data-distance="false"]').length
                      ) {
                        //Re-retrieve the available stores location modal contents
                        _this7.functions.getAvailableStores.call(
                          _this7,
                          variantId,
                          function (response) {
                            _this7.$modal
                              .find(".store-availabilities-list")
                              .html(
                                $(response)
                                  .find(".store-availabilities-list")
                                  .html()
                              );

                            _this7.functions.updateLocationDistances.bind(
                              _this7
                            )(coords);
                          }
                        );
                      }
                    });

                    return false;
                  }
                );

                _this7.$modal.on(
                  "click" + _this7.namespace,
                  ".cc-popup-close, .cc-popup-background",
                  function () {
                    popup.close();
                  }
                );

                if (firstRun) {
                  _this7.$container.slideDown(300);
                } else {
                  _this7.$container.removeClass(loadingClass);

                  var newHeight = _this7.$container
                    .find(".store-availability-container")
                    .outerHeight();

                  _this7.$container.css(
                    "height",
                    newHeight > 0 ? newHeight + "px" : "auto"
                  );
                }
              }
            }
          );
        }
      },
    }; // Initialise the section when it's instantiated

    this.onSectionLoad(container);
  }; // Register section

  cc.sections.push({
    name: "store-availability",
    section: theme.StoreAvailability,
  }); // ensure root_url ends in a slash

  if (!/\/$/.test(theme.routes.root_url)) theme.routes.root_url += "/";
  /*================ General Barry Bits ================*/

  theme.icons = {
    left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
    right:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
    close:
      '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Lager_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.3 11.3" style="enable-background:new 0 0 11.3 11.3;" xml:space="preserve"> <style type="text/css">.st0{fill:none;}.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style><rect x="-90.3" y="-90.3" class="st0" width="24" height="24"/><line class="st1" x1="10.2" y1="1.2" x2="1.2" y2="10.2"/><line class="st1" x1="10.2" y1="10.2" x2="1.2" y2="1.2"/></svg>',
    chevronLightLeft:
      '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
    chevronLightRight:
      '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
    chevronDown:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
    tick: '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Lager_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.3 17" style="enable-background:new 0 0 21.3 17;" xml:space="preserve"><style type="text/css">.st0{fill:none;}.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:3;}</style><rect x="-85.4" y="-87.5" class="st0" width="192" height="192"/><polyline class="st1" points="20.6,1.9 7.3,15.1 0.7,8.5 "/></svg>',
    add: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    loading:
      '<svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: transparent; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(263.279 50 50)"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>',
    chevronRight:
      '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Lager_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.3 17" style="enable-background:new 0 0 21.3 17;" xml:space="preserve"><style type="text/css">.st0{fill:none;}.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style><rect x="-85.4" y="-87.5" class="st0" width="192" height="192"/><line class="st1" x1="0.6" y1="8.5" x2="20.6" y2="8.5"/><polyline class="st1" points="12.4,1 20.6,8.5 12.4,16 "/></svg>',
    chevronLeft:
      '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Lager_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.3 17" style="enable-background:new 0 0 21.3 17;" xml:space="preserve"><style type="text/css">.st0{fill:none;}.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style><rect x="-85.4" y="-87.5" class="st0" width="192" height="192"/><line class="st1" x1="20.6" y1="8.5" x2="0.6" y2="8.5"/><polyline class="st1" points="8.8,1 0.6,8.5 8.8,16 "/></svg>',
    newDrop:
      '<svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.9941 1.78006L9.39068 7.01163L9.38341 7.01624C9.13705 7.17239 8.84851 7.17239 8.60214 7.01624L8.59626 7.01251L0.994141 1.86192L1.47152 0.944784L8.99219 6.04019L16.5113 0.866646L16.9941 1.78006Z" fill="#121212"/></svg>',
    closed:
      '<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_3_665)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7822 0.875546L1.87525 13.7709L1.21777 13.1128L14.1248 0.217476L14.7822 0.875546Z" fill="#121212"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1248 13.7709L1.21777 0.875546L1.87525 0.217476L14.7822 13.1128L14.1248 13.7709Z" fill="#121212"/> </g> <defs> <clipPath id="clip0_3_665"> <rect width="16" height="13.9535" fill="white" transform="translate(0 0.0232544)"/> </clipPath> </defs> </svg>',
  };
  theme.swipers = {};
  theme.productData = {};
  theme.viewport = {
    isXs: function isXs() {
      return $(window).outerWidth() < 768;
    },
    isSm: function isSm() {
      return $(window).outerWidth() >= 768;
    },
    isMd: function isMd() {
      return $(window).outerWidth() >= 992;
    }, 
  };
  theme.device = {
    isTouch: function isTouch() {
      try {
        document.createEvent("TouchEvent");
        return true;
      } catch (e) {
        return false;
      }
    },
  };
  /*================ Components ================*/

  theme.Nav = function () {
    var $navBar =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : $("#site-control");
    return {
      bar: {
        //Actions
        turnOpaque: function turnOpaque(_turnOpaque) {
          if (_turnOpaque) { 
            $navBar.addClass("nav-opaque");
          } else {
            $navBar.removeClass("nav-opaque");
          }
        },
        hide: function hide(_hide) {
          if (_hide && !$navBar.hasClass("nav-fade-out")) {
            document.body.classList.add("nav-hidden");
            $navBar.addClass("nav-hidden");
          } else {
            document.body.classList.remove("nav-hidden");
            $navBar.removeClass("nav-hidden");
          }
        },
        fadeOut: function fadeOut(_fadeOut) {
          if (_fadeOut) {
            $navBar.addClass("nav-fade-out");
          } else {
            $navBar.removeClass("nav-fade-out");
          }
        },
        hideAnnouncement: function hideAnnouncement(hide) {
          if (hide) {
            $navBar.addClass("announcement-hidden");
            // requestAnimationFrame(()=>{
            //   setProperty();
            // });
            //$('#search-modal').css('top', 'var(--header-height)');
          } else {
            $navBar.removeClass("announcement-hidden");            
            // $('#search-modal').css('top', 'calc(var(--header-height))');
          }
          requestAnimationFrame(()=>{
            setProperty();
          });
        },
        //Note: Don't reference $navBar below as the object may have changed (if in theme editor)
        //Settings
        hasOpaqueSetting: function hasOpaqueSetting() {
          return $("#site-control").data("opacity").includes("opaque");
        },
        hasStickySetting: function hasStickySetting() {
          return $("#site-control").data("positioning") === "sticky";
        },
        getPositionSetting: function getPositionSetting() {
          return $("#site-control").data("positioning");
        },
        getOpacitySetting: function getOpacitySetting() {
          if(document.querySelector('#page-content > .shopify-section').classList.contains('home-section-gallery')){
            return 'opaque';
          } else {
            return $("#site-control").data("opacity");
          }
    

        },
        //Current state
        isCurrentlyOpaque: function isCurrentlyOpaque() {
          return $("#site-control").hasClass("nav-opaque");
        },
        isAnnouncementBar: function isAnnouncementBar() {
          return (
            $("#site-control").find(".cc-announcement__inner").length === 1
          );
        },
        heightExcludingAnnouncementBar:
          function heightExcludingAnnouncementBar() {
            return $("#site-control")
              .find(".site-control__inner")
              .outerHeight();
          },
        heightOfAnnouncementBar: function heightOfAnnouncementBar() {
          return $("#site-control").find(".announcement").outerHeight();
        },
        height: function height() {
          //Returns the height including the announcement bar
          return $("#site-control").outerHeight();
        },
      },
    };
  };

  theme.ProductMediaGallery = function ($gallery, $thumbs, isFeaturedProduct) {
    var _this = this;

    var currentMedia;
    var initialisedMedia = {};
    var $viewInSpaceButton = $gallery.find(".view-in-space");
    var $swiperCont = $gallery.find(".swiper-container");
    var swiper;
    var preventSizeRedraw = false;
    var nav = theme.Nav();

    this.Image = function ($elem, autoplay) {
      this.show = function () {
        $elem.addClass("product-media--activated");
        $elem.show();
      };

      this.play = function () {
        $gallery
          .find(".product-media--current")
          .removeClass("product-media--current");
        $elem.addClass("product-media--current");
      };

      this.destroy = function () {};

      this.pause = function () {
        $elem.removeClass("product-media--activated");
      };

      this.hide = function () {
        $elem.hide();
      }; //Init the image

      this.show();
    };

    this.Video = function ($elem, autoplay) {
      var _video = this;

      var playerObj = {
        play: function play() {},
        pause: function pause() {},
        destroy: function destroy() {},
      };
      var videoElement = $elem.find("video")[0];

      this.show = function () {
        $elem.addClass("product-media--activated");
        $elem.show();

        _this.slideshowTabFix();
      };

      this.play = function () {
        $gallery
          .find(".product-media--current")
          .removeClass("product-media--current");
        $elem.addClass("product-media--current");

        _video.show();

        playerObj.play();
      };

      this.pause = function () {
        playerObj.pause();
        $elem.removeClass("product-media--activated");
      };

      this.hide = function () {
        playerObj.pause();
        $elem.hide();
      };

      this.destroy = function () {
        playerObj.destroy();
        $(videoElement).off("playing", handlePlay);
        $(document).off("fullscreenchange", delayedSwiperResize);
      }; //Init the video

      theme.loadStyleOnce(
        "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"
      ); // set up a controller for Plyr video

      window.Shopify.loadFeatures([
        {
          name: "video-ui",
          version: "1.0",
          onLoad: function () {
            playerObj = {
              playerType: "html5",
              element: videoElement,
              plyr: new Shopify.Plyr(videoElement, {
                controls: [
                  "play",
                  "progress",
                  "mute",
                  "volume",
                  "play-large",
                  "fullscreen",
                ],
                loop: {
                  active: $elem.data("enable-video-looping"),
                },
                autoplay: theme.viewport.isSm() && autoplay,
                hideControlsOnPause: true,
                iconUrl:
                  "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                tooltips: {
                  controls: false,
                  seek: true,
                },
              }),
              play: function play() {
                this.plyr.play();
              },
              pause: function pause() {
                this.plyr.pause();
              },
              destroy: function destroy() {
                this.plyr.destroy();
              },
            };
            $elem.addClass("product-media--video-loaded"); // Disable swipe on the model

            $elem.find(".plyr__controls").addClass("swiper-no-swiping");
            initialisedMedia[$elem.data("media-id")] = _video;
          }.bind(this),
        },
      ]);

      function handlePlay() {
        _this.pauseAllMedia($elem.data("media-id"));
      }

      $(videoElement).on("playing", handlePlay);

      function delayedSwiperResize(event) {
        preventSizeRedraw = true; // If not fullscreen

        if (window.innerHeight !== screen.height) {
          setTimeout(function () {
            preventSizeRedraw = true;
          }, 200);
        }
      } //When fullscreen ends, trigger a delayed resize to ensure swiper resets correctly

      $(document).on("fullscreenchange", delayedSwiperResize);

      _video.show();
    };

    this.ExternalVideo = function ($elem, autoplay) {
      var isPlaying = false;

      var _video = this;

      var playerObj = {
        play: function play() {},
        pause: function pause() {},
        destroy: function destroy() {},
      };
      var iframeElement = $elem.find("iframe")[0];

      this.play = function () {
        $gallery
          .find(".product-media--current")
          .removeClass("product-media--current");
        $elem.addClass("product-media--current");

        _video.show();

        playerObj.play();
      };

      this.togglePlayPause = function () {
        if (isPlaying) {
          _video.pause();
        } else {
          _video.play();
        }
      };

      this.pause = function () {
        playerObj.pause();
        $elem.removeClass("product-media--activated");
      };

      this.show = function () {
        $elem.addClass("product-media--activated");
        $elem.show();

        _this.slideshowTabFix();
      };

      this.hide = function () {
        playerObj.pause();
        $elem.hide();
      };

      this.destroy = function () {
        playerObj.destroy();
        $elem.off(
          "click",
          ".product-media--video-mask",
          _video.togglePlayPause
        );
      }; //Init the external video

      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          iframeElement.src
        )
      ) {
        var loadYoutubeVideo = function loadYoutubeVideo() {
          playerObj = {
            playerType: "youtube",
            element: iframeElement,
            player: new YT.Player(iframeElement, {
              videoId: $elem.data("video-id"),
              events: {
                onReady: function onReady() {
                  initialisedMedia[$elem.data("media-id")] = _video;
                  $elem.addClass("product-media--video-loaded");

                  if (autoplay && theme.viewport.isSm()) {
                    _video.play();
                  }
                },
                onStateChange: function onStateChange(event) {
                  if (event.data === 1) {
                    _this.pauseAllMedia($elem.data("media-id"));
                  }

                  isPlaying =
                    event.data === YT.PlayerState.PLAYING ||
                    event.data === YT.PlayerState.BUFFERING ||
                    event.data === YT.PlayerState.UNSTARTED;

                  if (event.data === 0 && $elem.data("enable-video-looping")) {
                    event.target.seekTo(0);
                  }
                },
              },
            }),
            play: function play() {
              this.player.playVideo();
            },
            pause: function pause() {
              this.player.pauseVideo();
            },
            destroy: function destroy() {
              this.player.destroy();
            },
          };
        };

        if (window.YT && window.YT.Player) {
          loadYoutubeVideo();
        } else {
          // set up a controller for YouTube video
          var temp = window.onYouTubeIframeAPIReady;

          window.onYouTubeIframeAPIReady = function () {
            temp();
            loadYoutubeVideo();
          };

          theme.loadScriptOnce("https://www.youtube.com/iframe_api");
        }
      }

      $elem.on("click", ".product-media--video-mask", _video.togglePlayPause);

      _video.show();
    };

    this.Model = function ($elem, autoplay) {
      var _model = this;

      var playerObj = {
        play: function play() {},
        pause: function pause() {},
        destroy: function destroy() {},
      };
      var modelElement = $elem.find("model-viewer")[0];

      this.show = function () {
        $elem.show();
        $elem.addClass("product-media--activated");

        _this.slideshowTabFix();

        _model.updateViewInSpaceButton();
      };

      this.updateViewInSpaceButton = function () {
        if (window.ShopifyXR && $viewInSpaceButton.length) {
          //Change the view in space button to launch this model
          $viewInSpaceButton.attr(
            "data-shopify-model3d-id",
            $elem.data("media-id")
          );
          window.ShopifyXR.setupXRElements();
        }
      };

      this.play = function () {
        $gallery
          .find(".product-media--current")
          .removeClass("product-media--current");
        $elem.addClass("product-media--current");

        _model.show();

        playerObj.play();
      };

      this.pause = function () {
        $elem.removeClass("product-media--activated");
        playerObj.pause();
      };

      this.hide = function () {
        playerObj.pause();
        $elem.hide();

        if (window.ShopifyXR && $viewInSpaceButton.length) {
          //Reset the view in space button to launch the first model
          $viewInSpaceButton.attr(
            "data-shopify-model3d-id",
            $viewInSpaceButton.data("shopify-model3d-first-id")
          );
          $viewInSpaceButton.attr(
            "data-shopify-title",
            $viewInSpaceButton.data("shopify-first-title")
          );
          window.ShopifyXR.setupXRElements();
        }
      };

      this.destroy = function () {
        //Nothing needed
      };

      this.initAugmentedReality = function () {
        if ($(".model-json", $gallery).length) {
          var doInit = function doInit() {
            if (!window.ShopifyXR) {
              document.addEventListener(
                "shopify_xr_initialized",
                function shopifyXrEventListener(event) {
                  doInit(); //Ensure this only fires once

                  event.target.removeEventListener(
                    event.type,
                    shopifyXrEventListener
                  );
                }
              );
              return;
            }

            window.ShopifyXR.addModels(
              JSON.parse($(".model-json", $gallery).html())
            );
            window.ShopifyXR.setupXRElements();
          };

          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: doInit,
            },
          ]);
        }
      }; //Init the model

      theme.loadStyleOnce(
        "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
      );
      window.Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: function () {
            playerObj = new Shopify.ModelViewerUI(modelElement);
            $elem.addClass("product-media--model-loaded");

            if (autoplay && theme.viewport.isSm()) {
              _model.play();
            } // add mouseup event proxy to fix carousel swipe gestures

            $('<div class="theme-event-proxy">')
              .on("mouseup", function (e) {
                e.stopPropagation();
                e.preventDefault();
                document.dispatchEvent(new MouseEvent("mouseup"));
              })
              .appendTo(
                $(this).find(".shopify-model-viewer-ui__controls-overlay")
              ); // Prevent the buttons from submitting the form

            $elem.find("button").attr("type", "button"); // Disable swipe on the model

            $elem
              .find(".shopify-model-viewer-ui")
              .addClass("swiper-no-swiping");
          }.bind(this),
        },
      ]);
      $elem
        .find("model-viewer")
        .on("shopify_model_viewer_ui_toggle_play", function () {
          _this.pauseAllMedia($elem.data("media-id"));

          $elem.addClass("product-media-model--playing");
          $gallery.on(
            "click",
            '.product-media:not([data-media-type="model"])',
            _model.pause
          );
        });
      $elem
        .find("model-viewer")
        .on("shopify_model_viewer_ui_toggle_pause", function () {
          $elem.removeClass("product-media-model--playing");
          $gallery.off(
            "click",
            '.product-media:not([data-media-type="model"])',
            _model.pause
          );
        });
      $elem.on("click", ".product-media--model-mask", function () {
        if (isFeaturedProduct) {
          //If we're on a featured product, delay the initialisation of the model until the current slide has changed
          _this.swipeToSlideIfNotCurrent($elem);

          setTimeout(_model.play, 500);
        } else {
          _model.play();
        }
      });
      initialisedMedia[$elem.data("media-id")] = _model;

      _model.show();

      if (!window.ShopifyXR) {
        _model.initAugmentedReality();
      }
    };

    this.pauseAllMedia = function (ignoreKey) {
      for (var key in initialisedMedia) {
        if (
          initialisedMedia.hasOwnProperty(key) &&
          (!ignoreKey || key != ignoreKey)
        ) {
          initialisedMedia[key].pause();
        }
      }
    };

    this.showMedia = function ($mediaToShow, autoplay, preventHide) {
      //In with the new
      if ($mediaToShow.length) {
        //Out with the old
        if (currentMedia && !preventHide) {
          currentMedia.pause();
        } //Function to instantiate and return the relevant media

        var getMedia = function getMedia(MediaType) {
          var media;

          if (initialisedMedia.hasOwnProperty($mediaToShow.data("media-id"))) {
            media = initialisedMedia[$mediaToShow.data("media-id")];

            if (autoplay && theme.viewport.isSm()) {
              media.show(); //Delay play so its easier for users to understand that it paused

              setTimeout(media.play, 250);
            } else {
              media.show();
            }
          } else {
            media = new MediaType($mediaToShow, autoplay);
          }

          return media;
        }; //Initialise the media

        if ($mediaToShow.data("media-type") === "image") {
          currentMedia = getMedia(_this.Image);
        } else if ($mediaToShow.data("media-type") === "video") {
          currentMedia = getMedia(_this.Video);
        } else if ($mediaToShow.data("media-type") === "external_video") {
          currentMedia = getMedia(_this.ExternalVideo);
        } else if ($mediaToShow.data("media-type") === "model") {
          currentMedia = getMedia(_this.Model);
        } else {
          console.warn("Media is unknown", $mediaToShow);
          $gallery.find(".product-media:visible").hide();
          $mediaToShow.show();
        }
      }
    };

    this.swipeToSlideIfNotCurrent = function ($elem) {
      var $slide = $elem.closest(".swiper-slide");
      swiper.slideTo($slide.index(), 500);
    };

    this.destroy = function () {
      for (var i = 0; i < initialisedMedia.length; i++) {
        initialisedMedia[i].destroy();
      }

      if (!isFeaturedProduct) {
        $(window).off(
          "load.productTemplateGallery scroll.productTemplateGallery",
          detectHeaderOverGallery
        );
      }

      $gallery
        .closest(".product-area")
        .off(
          "click",
          ".product-area__details__thumbs__thumb a",
          handleThumbnailClick
        );
      $gallery.off("click", "[data-full-size]", handleImageClick);
      $gallery.off("variantImageSelected", _this.pauseAllMedia);
      $(window).off("ccScrollToMedia");

      if ($thumbs && $thumbs.length) {
        $thumbs.off("click");
      }
    };

    this.slideshowTabFix = function () {
      if (swiper) {
        // which slide are we going to?
        var $activeMedia = $swiperCont.find(".product-media--current"),
          $activeSlide = null;

        if ($activeMedia.length) {
          $activeSlide = $activeMedia.closest(".swiper-slide");
        } else {
          $activeSlide = $swiperCont.find(".swiper-slide.swiper-slide-active");
        } // tabindex everything to prevent tabbing into hidden slides

        $activeSlide
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            if (
              typeof $(this).data("theme-slideshow-original-tabindex") !==
              "undefined"
            ) {
              if ($(this).data("theme-slideshow-original-tabindex") === false) {
                $(this).removeAttr("tabindex");
              } else {
                $(this).attr(
                  "tabindex",
                  $(this).data("theme-slideshow-original-tabindex")
                );
              }
            } else {
              $(this).removeAttr("tabindex");
            }
          });
        $($swiperCont.find(".swiper-slide"))
          .not($activeSlide)
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            if (
              typeof $(this).data("theme-slideshow-original-tabindex") ===
              "undefined"
            ) {
              $(this).data(
                "theme-slideshow-original-tabindex",
                typeof $(this).attr("tabindex") !== "undefined"
                  ? $(this).attr("tabindex")
                  : false
              );
            }

            $(this).attr("tabindex", "-1");
          });
      }
    };

    this.scrollToMedia = function (mediaId) {
      var $variantImage = $('[data-media-id="'.concat(mediaId, '"]')); //Scroll to that variant image

      if (
        $variantImage.length &&
        $("body").hasClass("template-product") &&
        theme.viewport.isSm()
      ) {
        var offset = parseInt(
          $gallery.find(".theme-images").css("padding-top").replace("px", "")
        );
        var scrollAmount = $variantImage.offset().top - offset + 1; //If the nav is opaque and sticky, compensate for the nav when scrolling

        if (
          (nav.bar.hasOpaqueSetting() && nav.bar.hasStickySetting()) ||
          ($gallery.data("column-count") > 1 && $(window).outerWidth() > 1100)
        ) {
          scrollAmount -= nav.bar.heightExcludingAnnouncementBar();
        } //If scrolling up and the nav is set hide on scroll down, subtract the nav from the new position

        if (
          scrollAmount < $(window).scrollTop() &&
          nav.bar.getPositionSetting() === "peek" &&
          nav.bar.hasOpaqueSetting()
        ) {
          scrollAmount -= nav.bar.heightExcludingAnnouncementBar();
        }

        scrollAmount = scrollAmount < 200 ? 0 : scrollAmount;

        if ($gallery.data("column-count") > 1) {
          $gallery
            .find(".product-media--active-variant")
            .removeClass("product-media--active-variant");
          $variantImage.addClass("product-media--active-variant");

          if (theme.viewport.isMd()) {
            var $column = $variantImage.closest(".media-column[data-scrollax]");

            if ($column.length) {
              var $scrollaxParent = $column.closest("[data-scrollax-parent]");

              if ($scrollaxParent.length) {
                // Find out how far down the top of the variant image is as a percentage of the parent
                var parentHeight = $scrollaxParent.outerHeight();
                var imageOffset =
                  $variantImage.parent().position().top +
                  ($scrollaxParent.outerHeight() - $column.outerHeight()); // Get that as a percentage of the parallax percent (20 is the % parallax to compensate - in product-media.js)

                var percentageFromTopOfParent = (
                  (100 / parentHeight) *
                  imageOffset
                ).toFixed(2);
                var percentageOfParallaxOffset =
                  20 * (percentageFromTopOfParent / 100); //Work out the px to compensate

                var parallaxOffset =
                  parentHeight * (percentageOfParallaxOffset / 100);

                if (parallaxOffset > 0) {
                  //40 is the padding top between the column and scrollax parent
                  scrollAmount -= parallaxOffset;
                }
              }
            }
          }
        }

        $("html,body").animate(
          {
            scrollTop: scrollAmount,
          },
          1000
        );
      }
    };

    function detectHeaderOverGallery() {
      var nav = theme.Nav();
      $("body").toggleClass(
        "header-over-gallery",
        $(window).scrollTop() < $gallery.height() - nav.bar.height()
      );
    }

    function initColumns() {
      var columns = $gallery.data("column-count");
      var $elements = $gallery.find(".theme-img");
      var elementsPerCol = Math.ceil($elements.length / columns);
      var $colContainer = $gallery.find(".theme-images");
      var currentCol = -1;
      var $colWrapper; // //Put more images in the first column to offset the parallax
      // if(columns === 2){
      //   elementsPerCol++;
      // }

      if (columns > 1 && $elements.length > 1) {
        if (theme.settings.productImageParallax) {
          $gallery.attr("data-scrollax-parent", "true");
        }

        $elements.each(function (i) {
          if (currentCol < Math.floor(i / elementsPerCol)) {
            var additionalAttrs = "";

            if (theme.settings.productImageParallax) {
              if (currentCol === -1) {
                //Note if changing the 20% below, also change the 20% in manifest.js variantImageSelected scroll
                additionalAttrs =
                  "data-scrollax=\"properties: { 'translateY': '-20%' }\"";
              } else if (currentCol === 0) {
                // additionalAttrs = "data-scrollax=\"properties: { 'translateY': '100px' }\"";
              } else if (currentCol === 1) {
                additionalAttrs =
                  "data-scrollax=\"properties: { 'translateY': '-10%' }\"";
              }
            }

            $colWrapper = $(
              '<div class="media-column" '.concat(additionalAttrs, "></div>")
            ).appendTo($colContainer);
            currentCol++;
          }

          $(this).appendTo($colWrapper);
        });

        if (theme.settings.productImageParallax) {
          if (columns === 2) {
            //Keep the first column the same height or shorter than the second column
            var $firstColumn = $colContainer.find(".media-column").eq(0);
            var $secondColumn = $colContainer.find(".media-column").eq(1);

            if ($secondColumn.outerHeight() > 4000) {
              var maintainFirstColumnHeight =
                function maintainFirstColumnHeight() {
                  if (
                    $secondColumn.outerHeight() < $firstColumn.outerHeight()
                  ) {
                    $firstColumn.css(
                      "height",
                      $secondColumn.outerHeight() + "px"
                    );
                  }
                };

              maintainFirstColumnHeight();
              $(window).on(
                "debouncedresize.columnheights",
                maintainFirstColumnHeight
              );
            }
          }

          $(window).Scrollax({
            offset: nav.bar.height(),
          });
          $(window).Scrollax("reload");
        }
      }
    }

    function destroyColumns() {
      var $colContainer = $gallery.find(".theme-images");
      $colContainer.find(".theme-img").each(function () {
        $(this).appendTo($colContainer);
      });
      $(window).off("debouncedresize.columnheights");
      $colContainer.find(".media-column").remove();

      if (theme.settings.productImageParallax) {
        $gallery.removeAttr("data-scrollax-parent", "true");
        $(window).Scrollax("destroy");
      }
    } //Check if media should be displayed in columns

    if (theme.viewport.isSm()) {
      initColumns();
    } //Init all media

    $gallery.find(".product-media").each(function (index) {
      _this.showMedia($(this), false, true);
    }); //Init swiper

    var $swiperExternalVideos = $swiperCont.find(
      '[data-media-type="external_video"]'
    ); //Scrolls to the media of the clicked thumbnail

    function handleThumbnailClick(e) {
      e.preventDefault();
      var mediaId = $(this).closest("[data-media-id]").data("media-id");
      var $media = $gallery.find(
        '.product-media[data-media-id="'.concat(mediaId, '"]')
      ); //Scroll to that variant image

      if ($media.length) {
        //fixed and not data-opacity="transparent"
        $gallery
          .closest(".product-area")
          .find(".thumb-active")
          .removeClass("thumb-active");
        $(this).addClass("thumb-active");

        _this.scrollToMedia(mediaId);
      }

      return false;
    } //Opens the zoom modal

    function handleImageClick() {
      if (theme.viewport.isSm()) {
        var thisSmallSizeImageUrl = $(this).find(".rimage-wrapper > img")[0]
          .currentSrc;
        var $allImages = $(this)
          .closest(".theme-images")
          .find("[data-full-size]");
        var imageHtml =
          '<a href="#" data-modal-close class="modal-close">' +
          theme.icons.close +
          "</a>";
        $allImages.each(function () {
          var smallSizeImageUrl = $(this).find(".rimage-wrapper > img")[0]
            .currentSrc;
          var fullSizeImageUrl = $(this).data("full-size");
          var extraAttrs =
            thisSmallSizeImageUrl === smallSizeImageUrl
              ? "id='zoom-image'"
              : ""; //Build the html for the images within the modal

          imageHtml += '<img class="zoom-image" '
            .concat(extraAttrs, ' src="')
            .concat(smallSizeImageUrl, '" data-full-size="')
            .concat(fullSizeImageUrl, '"/>');
        });
        showThemeModal(
          $(
            '<div class="theme-modal product-image-zoom temp -light"  role="dialog" aria-modal="true"/>'
          ).append(
            "\n           <div class='inner-scroller -out'>".concat(
              imageHtml,
              "</div>"
            )
          ),
          "product-image",
          function ($modal) {
            var $mainImage = $("#zoom-image");
            $mainImage.attr("src", $mainImage.data("full-size")); // let offset = $mainImage.outerHeight() - $(window).outerHeight();
            // if(offset < 0){
            //   offset = 0;
            // }

            setTimeout(function () {
              //Set full resolution of the other images
              $modal.find("[data-full-size]").each(function () {
                $(this).attr("src", $(this).data("full-size"));
              });
            }, 100);
            setTimeout(function () {
              //Scroll to the middle of the image
              $modal.scrollTop(
                $mainImage.position().top +
                  ($mainImage.outerHeight() / 2 - $modal.outerHeight() / 2)
              ); //Scroll to the top of the image
              // $modal.scrollTop($mainImage.position().top);

              $modal.find(".inner-scroller").removeClass("-out");
            }, 1000);
          },
          true
        );
      }
    } // Bind listeners

    if ($gallery.hasClass("theme-gallery--thumbs-enabled")) {
      $gallery
        .closest(".product-area")
        .on(
          "click",
          ".product-area__details__thumbs__thumb a",
          handleThumbnailClick
        );
    }

    if ($gallery.hasClass("theme-gallery--zoom-enabled")) {
      $gallery.on("click", "[data-full-size]", handleImageClick);
    }

    $(window)
      .off("ccScrollToMedia")
      .on("ccScrollToMedia", function (e, mediaId) {
        if (
          $gallery.data("scroll-to-variant-media") !== false ||
          theme.viewport.isXs()
        ) {
          _this.scrollToMedia(mediaId);
        }
      });

    if (!isFeaturedProduct) {
      $(window)
        .on(
          "doThemeGalleryResizeCheck.productTemplateGallery resize.productTemplateGallery",
          function (e) {}
        )
        .trigger("doThemeGalleryResizeCheck");
      $(detectHeaderOverGallery); // indicate if header over the gallery

      $(window).on("scroll.productTemplateGallery", detectHeaderOverGallery);
    } else {
      // set external video dimensions for featured products
      $swiperExternalVideos.each(function () {
        $(this).width($gallery.outerHeight() * $(this).data("aspectratio"));
      });
    }

    $gallery.on("variantImageSelected", _this.pauseAllMedia);

    function initSwiper() {
      destroyColumns();
      var extraSwiperOpts = {};

      if ($swiperCont.data("swiper-nav-style") === "dots") {
        extraSwiperOpts = {
          dynamicBullets: true,
          pagination: {
            el: $swiperCont.find(".swiper-pagination")[0],
            dynamicBullets: true,
          },
        };
      } else {
        extraSwiperOpts = {
          navigation: {
            nextEl: $swiperCont.find(".swiper-button-next")[0],
            prevEl: $swiperCont.find(".swiper-button-prev")[0],
          },
        };
      } //Maintain the height of the carousel on desktop

      if (isFeaturedProduct) {
        var updateMediaHeight = function updateMediaHeight() {
          if (theme.viewport.isSm()) {
            $productMedia.css("height", $productDetails.outerHeight() + "px");
          } else {
            $productMedia.css("height", "auto");
          }
        };

        var $productDetails = $gallery
          .closest(".product-area")
          .find(".product-area__details .product-area__details__inner");
        var $productMedia = $gallery
          .closest(".product-area")
          .find(".product-area__media");
        $(window).on("debouncedresize.swiper", updateMediaHeight);
        updateMediaHeight();
      } //Init swiper

      var swiperOpts = _objectSpread(
        {
          mode: "horizontal",
          loop: false,
          slidesPerView: "auto",
          resizeReInit: true,
          autoHeight: false,
          scrollContainer: true,
          grabCursor: true,
          createPagination: false,
          preventClicks: false,
          freeMode: true,
          freeModeFluid: true,
          spaceBetween: 20,
          dynamicBullets: false,
          mousewheel: {
            invert: true,
            forceToAxis: true,
          },
          scrollbar: {
            el: $swiperCont.find(".swiper-scrollbar")[0],
            draggable: true,
          },
        },
        extraSwiperOpts,
        {
          breakpoints: {
            767: _objectSpread(
              {
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                freeMode: false,
                freeModeFluid: false,
              },
              extraSwiperOpts
            ),
          },
          on: {
            init: function init() {
              lazySizes.autoSizer.checkElems(); //Hack for iPhone X - where loading the page on slower connection sometimes causes Swiper to steal focus

              if (
                theme.viewport.isXs() &&
                $(".product-detail__form__options a:not(.size-chart-link)")
                  .length &&
                !isFeaturedProduct
              ) {
                $(
                  ".product-detail__form__options a:not(.size-chart-link):first"
                ).focus();
                setTimeout(function () {
                  $(window).scrollTop(0);
                }, 500);
              }
            },
            slideChangeTransitionEnd: function slideChangeTransitionEnd(e) {
              // Update the view in space button on swipe
              if (theme.viewport.isXs() || isFeaturedProduct) {
                var $activeMedia = $gallery.find(
                  ".swiper-slide-active .product-media"
                );
                var activeMediaObj =
                  initialisedMedia[$activeMedia.data("media-id")];

                if (activeMediaObj) {
                  if ($activeMedia.data("media-type") === "model") {
                    activeMediaObj.updateViewInSpaceButton();
                  } else if (window.ShopifyXR && $viewInSpaceButton.length) {
                    //Reset the view in space button to launch the first model
                    $viewInSpaceButton.attr(
                      "data-shopify-model3d-id",
                      $viewInSpaceButton.data("shopify-model3d-first-id")
                    );
                    $viewInSpaceButton.attr(
                      "data-shopify-title",
                      $viewInSpaceButton.data("shopify-first-title")
                    );
                    window.ShopifyXR.setupXRElements();
                  }
                }
              }

              _this.slideshowTabFix();
            },
          },
        }
      );

      swiper = new Swiper($swiperCont, swiperOpts);
      var randomId = new Date().getTime();
      theme.swipers[randomId] = swiper;
      $swiperCont.attr("data-swiper-id", randomId);
      var startIndex = $gallery.find(".current-img").index();

      if (startIndex > 0) {
        swiper.slideTo(startIndex, 0);
      }

      if (isFeaturedProduct) {
        $gallery
          .find(".current-img .product-media")
          .addClass("product-media--active-variant");
      } //Disable swipe on single products within the featured product slider

      if ($gallery.hasClass("featured-product__gallery--single")) {
        $swiperCont.addClass("swiper-no-swiping");
      } //Fixes bug where the last slide gets cut off if its a model

      setTimeout(
        function () {
          $(window).trigger("resize"); //Load lazy images

          lazySizes.autoSizer.checkElems();

          if (swiper) {
            swiper.update();
          } //Autoplay the active slide on desktop

          if (theme.viewport.isSm() && !isFeaturedProduct) {
            _this.showMedia(
              $swiperCont.find(
                ".swiper-slide.swiper-slide-active .product-media"
              ),
              false,
              true
            );
          }

          if (isFeaturedProduct) {
            _this.slideshowTabFix();
          }
        },
        isFeaturedProduct ? 3000 : 1000
      );
      document.body.addEventListener("reset-mobile-slider", (e) => {
        swiper.slideTo(0);
      });
    }

    function destroySwiper() {
      $swiperCont.removeClass("swiper-no-swiping");
      swiper.destroy(false);
      initColumns();
    }

    var swiperEnabled = false;

    function toggleSwiper() {
      if (theme.viewport.isXs() && !swiperEnabled) {
        swiperEnabled = true;
        initSwiper();
      } else if (theme.viewport.isSm() && swiperEnabled) {
        swiperEnabled = false;
        destroySwiper();
      }
    }

    $(function () {
      if (isFeaturedProduct) {
        initSwiper();
      } else {
        toggleSwiper();
        $(window).on("debouncedresize.swiper", toggleSwiper);
      }
    });
  };

  theme.initContentSlider = function (target, afterChange) {
    var lastSlide = $(".slideshow .slide", target).length - 1;
    var speed = $(this).data("transition") == "instant" ? 0 : 1000;

    if ($(this).data("transition-speed")) {
      speed = $(this).data("transition-speed");
    }

    $(".slideshow", target).each(function () {
      $(this)
        .on("init", function () {
          $(".lazyload--manual", this)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        })
        .slick({
          autoplay: $(this).data("autoplay"),
          fade: $(this).data("transition") != "slide",
          speed: speed,
          autoplaySpeed: $(this).data("autoplay-speed") * 1000,
          arrows: $(this).data("navigation") == "arrows",
          dots: $(this).data("navigation") == "dots",
          // pauseOnHover: $(this).data('transition') != 'instant' || $(this).data('autoplay-speed') > 2, // no pause when quick & instant
          infinite: true,
          useTransform: true,
          adaptiveHeight: true,
          prevArrow:
            '<button type="button" class="slick-prev" aria-label="' +
            theme.strings.previous +
            '">' +
            theme.icons.chevronLeft +
            "</button>",
          nextArrow:
            '<button type="button" class="slick-next" aria-label="' +
            theme.strings.next +
            '">' +
            theme.icons.chevronRight +
            "</button>",
          pauseOnHover: false,
          cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
          lazyLoad: $(this).find("[data-lazy]").length > 0 ? "ondemand" : null,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                fade: $(this).data("transition") != "slide",
                // keep instant gif-style on mobile
                speed: $(this).data("transition") == "instant" ? 0 : 750,
                arrows: false,
                //$(this).data('navigation') == 'arrows',
                dots: $(this).data("navigation") != "none",
                // $(this).data('navigation') == 'none' || $(this).data('navigation') == 'dots',
                lazyLoad:
                  $(this).find("[data-lazy]").length > 0 ? "progressive" : null,
              },
            },
          ],
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          var _this8 = this;

          //Figure out the direction we're travelling in
          var direction = "left";

          if (
            ((nextSlide < currentSlide &&
              !(currentSlide === lastSlide && nextSlide === 0)) ||
              (currentSlide == 0 && nextSlide === lastSlide)) &&
            !(nextSlide === 1 && currentSlide === 0)
          ) {
            direction = "right";
          } //Pop the direction to animate from, forcing the text left or right and hidden

          $(this).addClass("direction-".concat(direction));
          var $outgoingSlide = $(slick.$slides.get(currentSlide));
          $outgoingSlide.addClass("-outgoing").addClass("-leaving");
          var movingToClonedSlide =
            (currentSlide === lastSlide && nextSlide === nextSlide) ||
            (currentSlide === 0 && nextSlide === lastSlide);
          setTimeout(
            function () {
              //Remove the direction and animate the text in
              $(_this8)
                .removeClass("direction-left")
                .removeClass("direction-right");
              $outgoingSlide.removeClass("-outgoing");
            },
            movingToClonedSlide ? 600 : 100
          ); //Cloned slides take longer to initialise

          setTimeout(function () {
            $outgoingSlide.removeClass("-leaving");
          }, 1000);
        })
        .on("afterChange", function (event, slick, currentSlide) {
          if (afterChange) {
            afterChange(currentSlide);
          }
        });
    });
  };

  theme.initProductSlider = function ($swiperCont) {
    var isBlog =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var slidesInView = $swiperCont.data("products-in-view");
    var breakpoints = {
      767: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      900: {
        slidesPerView:
          slidesInView === 4 || slidesInView === 3 ? 2 : slidesInView,
      },
      1439: {
        slidesPerView:
          slidesInView === 4 || slidesInView === 3 ? 3 : slidesInView,
      },
      3000: {
        slidesPerView: slidesInView,
        spaceBetween: 20,
      },
    };

    if (isBlog) {
      breakpoints = {
        767: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 2,
        },
        1600: {
          slidesPerView: 3,
        },
        3000: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      };
    } //Init swiper

    new Swiper($swiperCont, {
      mode: "horizontal",
      loop: false,
      resizeReInit: true,
      freeMode: true,
      freeModeFluid: true,
      scrollContainer: true,
      grabCursor: true,
      createPagination: false,
      slidesPerView: slidesInView,
      spaceBetween: 20,
      mousewheel: {
        invert: true,
        forceToAxis: true,
      },
      scrollbar: {
        el: $swiperCont.find(".swiper-scrollbar")[0],
        draggable: true,
      },
      navigation: {
        nextEl: $swiperCont.find(".swiper-button-next")[0],
        prevEl: $swiperCont.find(".swiper-button-prev")[0],
      },
      breakpoints: breakpoints,
      on: {
        init: function init() {
          lazySizes.autoSizer.checkElems();
        },
      },
    });
  };

  theme.convertOptionsToBoxes = function (container) {
    // show box-style options
    var $form = $('select[name="id"]:first', container).closest("form");
    var $clickies = $form
      .find("select[data-make-box]")
      .each(function () {
        $(this).find('option[value=""]').remove(); //Remove 'Pick a' option, if exists
      })
      .clickyBoxes()
      .parent()
      .addClass("has-clickyboxes");
    $(".selector-wrapper:not(.cc-swatches) .clickyboxes").ccHoverLine({
      lineCss: {
        height: "1px",
      },
    }); // If we have clicky boxes, add the disabled-state to options that have no valid variants

    if ($clickies.length > 0) {
      var productData = theme.OptionManager.getProductData($form); // each option

      for (
        var optionIndex = 0;
        optionIndex < productData.options.length;
        optionIndex++
      ) {
        // list each value for this option
        var optionValues = {};

        for (
          var variantIndex = 0;
          variantIndex < productData.variants.length;
          variantIndex++
        ) {
          var variant = productData.variants[variantIndex];

          if (
            typeof optionValues[variant.options[optionIndex]] === "undefined"
          ) {
            optionValues[variant.options[optionIndex]] = false;
          } // mark true if an option is available

          if (variant.available) {
            optionValues[variant.options[optionIndex]] = true;
          }
        } // mark any completely unavailable options

        for (var key in optionValues) {
          if (!optionValues[key]) {
            $(
              ".selector-wrapper:eq(" + optionIndex + ") .clickyboxes li a",
              $form
            )
              .filter(function () {
                return $(this).attr("data-value") == key;
              })
              .addClass("unavailable");
          }
        }
      }
    }

    if ($form.data("show-realtime-availability")) {
      /// Highlight the available variants.
      theme.OptionManager.updateVariantOptionStatusClasses($form);
    }
  };
  
  

      theme.loadInfiniteScroll = function (container) {
        if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1) {
          var infiniteLoadCount = localStorage.getItem('count');
          infiniteLoadCount = 3;
          localStorage.setItem('count', infiniteLoadCount);
        } else {
          var infiniteLoadCount = 1; /// Pagination-replacement
          var count = 0;
          localStorage.setItem('count', infiniteLoadCount);
        }
        

        $(".pagination.infiniscroll:not(.infinit)", container)
          .addClass("infinit")
          .each(function () {
            var waitForTrigger = $(this).hasClass("wait-for-trigger");
            var $pager = $(
              '<div class="pager-button"><a href="#" aria-label="' +
                theme.strings.loadMore +
                '">' +
                theme.icons.loading +
                "</a></div>"
            );
            $(this).replaceWith($pager);
            $pager.find("a").attr("href", $(this).find(".next a").attr("href"));
            $pager.on("click", "a", function (e) {
              if ($(this).hasClass("loading")) {
                return false;
              } //Show spinner
    
              $(this).addClass("loading"); //Load next page
    
              var $link = $(this);
              $.get($(this).attr("href"), function (data) {
                infiniteLoadCount++;
                localStorage.setItem('count', infiniteLoadCount);
                var isCollage = false; // var $data = $($.parseHTML(data));
                // //Grab products & insert into page
                // var indexOffset = $('.product-list .product-block').length;
                // var $newProducts = $data.find('.product-list .product-block').hide().appendTo('.product-list').filter('.product-block').each(function(index){
                //   $(this).removeAttr('data-loop-index').data('loop-index', indexOffset + index);
                // });
    
                var $data = $($.parseHTML(data)); //Grab products & insert into page
    
                if ($(".product-list--columns").length) {
                  //Collage
                  isCollage = true;
                  var $newProducts = $data.find(".product-list").hide();
                  $newProducts.prepend(
                    "<h2>" +
                      theme.strings.page.replace("{{ page }}", infiniteLoadCount) +
                      "</h2>"
                  );
                  var $newProducts = $newProducts.insertBefore(
                    ".product-list-container .pager-button"
                  );
                } else {
                  //Not collage
                  var $newProducts = $data
                    .find(".product-list .product-block")
                    .hide()
                    .appendTo(".product-list");
                }

                $(".product-list-container")
                  .filter(".product-block")
                  .each(function (index) {
                    $(this).removeAttr("data-loop-index").data("loop-index", index);
                    i++;
                    
                  }); //Sort by offset from the top
                //Fix height
    
                if (!isCollage) {
                  console.log("Init");

                  var $productList = $(".product-list");
                  var currentHeight = $productList.outerHeight(); 
                  
                  if ($newProducts.length === 0) {
                      console.warn("No new products found!");
                      return;
                  }
                  
                  // Merimo visinu koristeći privremeni kontejner
                  var $tempContainer = $("<div>")
                      .append($newProducts.clone().css({ position: "absolute", visibility: "hidden", display: "block" }))
                      .appendTo("body");
                  
                  var newHeight = $tempContainer[0].getBoundingClientRect().height;
                  $tempContainer.remove();
                  
                  // Postavimo nove proizvode, ali ih privremeno sakrijemo
                  $newProducts.addClass("pre-trans").css({ display: "block", visibility: "hidden", opacity: 0 });
                  $productList.append($newProducts);
                  
                  requestAnimationFrame(() => {
                      var finalHeight = $productList[0].getBoundingClientRect().height;
                  
                      if (finalHeight > currentHeight) {
                          $productList.css({ minHeight: currentHeight, overflow: "hidden" });
                  
                          $productList.animate({ height: finalHeight }, 500, function () {
                              $(this).css({ height: "", minHeight: "", overflow: "" });
                              $newProducts.removeClass("pre-trans").css({ visibility: "visible", opacity: 1 });
                              setTimeout(theme.tryRefreshProductReviews, 500);
                          });
                      } else {
                          console.warn("New height is not greater than current height, skipping animation.");
                      }
                  });                  

                // Ažuriranje URL-a
                const nextPage = $(".pager-button a").attr("href");
                if (nextPage) {
                    window.history.pushState(null, "", nextPage);
                }

                // Podešavanje URL-a na osnovu `data-page`
                document.querySelectorAll(".product-block").forEach(function (product) {
                    product.addEventListener("click", function () {
                        const url = window.location.href;
                        const page = $(this).attr("data-page");
                        if (page) {
                            const page_num = url.split("=")[0] + "=" + page;
                            window.history.pushState(null, "", page_num);
                        }
                    });
                });

                // Čuvamo broj učitavanja
                count++;
                localStorage.setItem("count", count);

                // Pokrećemo video
                $(".video-por-wrapper video").trigger("play");



                } else {
                  setTimeout(function () {
                    $newProducts.fadeIn();
                    setTimeout(theme.tryRefreshProductReviews, 500);
                  }, 300);
                } //Spin no more

                    
                var $next = $data.find(".pagination .next a");
    
                if ($next.length == 0) {
                  //We are out of products
                  $pager.slideUp();
                } else {
                  //More to show
                  $link.attr("href", $next.attr("href")).removeClass("loading");
                }
              });
              return false;
            });
    
            if (!waitForTrigger) {
              //Infiniscroll
              $(window).on("throttled-scroll.infiniscroll", function () {
                if (
                  $(window).scrollTop() + $(window).height() >
                  $pager.offset().top - 500
                ) {
                  $pager.find("a").trigger("click");
                }
              });
            }
        
          });
          
      };
   
  theme.unloadInfiniteScroll = function (container) {
    if (container) {
      $(".pagination.infiniscroll.infinit", container).removeClass("infinit");
    }

    $(window).off("throttled-scroll.infiniscroll");
  };

  theme.applyAjaxToProductForm = function ($form_param) {
    var shopifyAjaxAddURL = theme.routes.cart_add_url + ".js";
    var shopifyAjaxStorePageURL = theme.routes.search_url;
    $form_param
      .filter('[data-ajax-add-to-cart="true"]:not(.feedback-go_to_cart)')
      .on("submit", function (e) {
        e.preventDefault();
        var $form = $(this); //Disable add button

        var $btn = $(this)
          .find("[type=submit]")
          .attr("disabled", "disabled")
          .addClass("confirmation adding");
        $btn
          .data("originalHtml", $btn.html())
          .html(theme.strings.productAddingToCart);
        var $stickyBtn = $(".product-area__add-to-cart-xs button");
        var updateStickyButton = theme.viewport.isXs() && $stickyBtn.length;

        if (updateStickyButton) {
          $stickyBtn.attr("disabled", "disabled");
          $stickyBtn
            .data("originalHtml", $stickyBtn.html())
            .html(theme.strings.productAddingToCart);
        } //Add to cart

        $.post(
          shopifyAjaxAddURL,
          $form.serialize(),
          function (itemData) {
            //Enable add button
            $btn.html(
              theme.icons.tick + " " + theme.strings.productAddedToCart
            );

            if (updateStickyButton) {
              $stickyBtn.html(
                theme.icons.tick + " " + theme.strings.productAddedToCart
              );
            }

            setTimeout(function () {
              $btn
                .removeAttr("disabled")
                .removeClass("confirmation")
                .html($btn.data("originalHtml"));

              if (updateStickyButton) {
                $stickyBtn
                  .removeAttr("disabled")
                  .removeClass("confirmation")
                  .html($stickyBtn.data("originalHtml"));
              }
            }, 4000);

            if (
              $form.hasClass("feedback-add_in_modal") ||
              $form.hasClass("feedback-add_in_modal_no_checkout")
            ) {
              var product = $.parseJSON(itemData);
              var noCheckoutButton = $form.hasClass(
                "feedback-add_in_modal_no_checkout"
              ); //Preload the thumbnail image

              var thumbUrl = theme.Shopify.formatImage(product.image, "300x");
              var img = new Image();
              img.src = thumbUrl;
              $btn.removeClass("adding");
              var variantHtml = "";

              if (
                product.selling_plan_allocation &&
                product.selling_plan_allocation.selling_plan.name
              ) {
                variantHtml += '<p class="cart-product__content__meta">'.concat(
                  product.selling_plan_allocation.selling_plan.name,
                  "</p>"
                );
              }

              if (
                product.options_with_values &&
                product.options_with_values.length
              ) {
                for (
                  var _i = 0;
                  _i < product.options_with_values.length;
                  _i++
                ) {
                  var option = product.options_with_values[_i];

                  if (
                    option.name !== "Title" &&
                    option.value !== "Default Title"
                  ) {
                    variantHtml += '<p class="cart-product__content__meta">'
                      .concat(option.name, ": ")
                      .concat(option.value, "</p>");
                  }
                }
              } // let $priceElem = $form.closest('.product-area__details__inner').find('.price-area .current-price');
              // if($priceElem.length){
              //   variantHtml += `<p class="cart-product__content__price">${$priceElem.text()}</p>`;
              // }

              var offset = 25;
              var nav = theme.Nav();

              if (nav.bar.getPositionSetting() !== "inline") {
                offset = nav.bar.height();
              }

              showThemeModal(
                [
                  '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
                  '<div class="inner" style="top:'.concat(offset, 'px">'),
                  '<a href="#" data-modal-close class="modal-close">' +
                    theme.icons.close +
                    "</a>",
                  '<h4 id="added-to-cart-title">' +
                    theme.icons.tick +
                    theme.strings.productAddedToCart +
                    "</h4>",
                  '<div class="cart-product">',
                  '<div class="cart-product__image"><img src="'
                    .concat(thumbUrl, '" alt="')
                    .concat(product.featured_image.alt, '"/></div>'),
                  '<div class="cart-product__content">' +
                    '<p class="cart-product__content__title">',
                  product.product_title,
                  "</p>" + "".concat(variantHtml ? variantHtml : "") + "</div>",
                  "</div>",
                  '<p class="links '.concat(
                    noCheckoutButton ? "links--no-checkout" : "",
                    '">'
                  ),
                  '<a href="' +
                    theme.routes.cart_url +
                    '" class="button '.concat(
                      noCheckoutButton ? "" : "alt",
                      '">'
                    ) +
                    theme.strings.viewCart +
                    "</a>",
                  '<a href="' +
                    theme.routes.checkout +
                    '" class="button button--checkout" [data-cc-checkout-button]>' +
                    theme.strings.popupCheckout +
                    "</a> ",
                  "</p>",
                  "</div>",
                  "</div>",
                ].join(""),
                null,
                null,
                false,
                true
              );
            } //Update header summary

            $.get(shopifyAjaxStorePageURL, function (data) {
              var cartSummarySelector = "#site-control .cart:not(.nav-search)";
              var $newCartObj = $($.parseHTML("<div>" + data + "</div>")).find(
                cartSummarySelector
              );
              var $currCart = $(cartSummarySelector);
              $currCart.replaceWith($newCartObj);
              $("#site-control")
                .find("[data-cc-animate]")
                .removeAttr("data-cc-animate");
            });
          },
          "text"
        ).fail(function (data) {
          //Enable add button
          $btn
            .removeAttr("disabled")
            .removeClass("confirmation")
            .html($btn.data("originalHtml"));

          if (updateStickyButton) {
            $stickyBtn
              .removeAttr("disabled")
              .removeClass("confirmation")
              .html($stickyBtn.data("originalHtml"));
          } //Not added, show message

          if (typeof data != "undefined" && typeof data.status != "undefined") {
            var jsonRes = $.parseJSON(data.responseText);
            var $statusMessageContainer = $form.find(".product-status-message");
            $statusMessageContainer.html(jsonRes.description);
            $statusMessageContainer.slideDown().fadeIn();
            setTimeout(function () {
              $statusMessageContainer.slideUp();
            }, 8000);
          } else {
            //Some unknown error? Disable ajax and submit the old-fashioned way.
            $form.attr("ajax-add-to-cart", "false").submit();
          }
        });
      });
  };

  theme.removeAjaxFromProductForm = function ($form_param) {
    $form_param.off("submit");
  }; // Manage option dropdowns

  theme.OptionManager = new (function () {
    var _ = this;

    _._getVariantOptionElement = function (variant, $container) {
      return $container.find(
        'select[name="id"] option[value="' + variant.id + '"]'
      );
    };

    _.currentVariant = null;
    _.selectors = {
      container: ".product-area",
      gallery: ".theme-gallery",
      priceArea: ".price-area",
      priceAreaContainer: ".product-area__col--price",
      submitButton:
        ".product-detail__form input[type=submit], .product-detail__form button[type=submit]",
      multiOption: ".option-selectors",
    };
    _.strings = {
      priceNonExistent: theme.strings.priceNonExistent,
      buttonDefault: theme.strings.buttonDefault,
      buttonNoStock: theme.strings.buttonNoStock,
      buttonNoVariant: theme.strings.buttonNoVariant,
      unitPriceSeparator: theme.strings.unitPriceSeparator,
      inventoryNotice: theme.strings.onlyXLeft,
      priceSoldOut: theme.strings.priceSoldOut,
    };

    _._getString = function (key, variant) {
      var string = _.strings[key];

      if (variant) {
        if (string) {
          string = string.replace(
            "[PRICE]",
            '<span class="theme-money">' +
              theme.Shopify.formatMoney(variant.price, theme.money_format) +
              "</span>"
          );
        } else {
          console.warn("No string for key '".concat(key, "' was found."));
        }
      }

      return string;
    };

    _.getProductData = function ($form) {
      var productId = $form.data("product-id");
      var data = null;

      if (!theme.productData[productId]) {
        theme.productData[productId] = JSON.parse(
          document.getElementById("cc-product-json-" + productId).innerHTML
        );
      }

      data = theme.productData[productId];

      if (!data) {
        console.log(
          "Product data missing (id: " + $form.data("product-id") + ")"
        );
      }

      return data;
    };

    (_.getBaseUnit = function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }),
      (_.addVariantUrlToHistory = function (variant) {
        if (variant) {
          var newurl =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname +
            "?variant=" +
            variant.id;
          window.history.replaceState(
            {
              path: newurl,
            },
            "",
            newurl
          );
        }
      });

    _.updateSku = function (variant, $container) {
      $container.find(".sku .sku__value").html(variant ? variant.sku : "");
      $container
        .find(".sku")
        .toggleClass("sku--no-sku", !variant || !variant.sku);
    };

    _.updateBarcode = function (variant, $container) {
      $container
        .find(".barcode .barcode__value")
        .html(variant ? variant.barcode : "");
      $container
        .find(".barcode")
        .toggleClass("barcode--no-barcode", !variant || !variant.barcode);
    };

    _.updateInventoryNotice = function (variant, $container) {
      var inventoryData = _._getVariantOptionElement(variant, $container).data(
        "inventory"
      );

      if (inventoryData) {
        $container
          .find(".product-inventory-notice")
          .removeClass("product-inventory-notice--no-inventory")
          .html(
            _._getString("inventoryNotice").replace(
              "[[ quantity ]]",
              inventoryData
            )
          )
          .slideDown(300);
      } else {
        $container
          .find(".product-inventory-notice")
          .addClass("product-inventory-notice--no-inventory")
          .slideUp(300);
      }
    };

    _.updateBackorder = function (variant, $container) {
      var $backorder = $container.find(".backorder");

      if ($backorder.length) {
        if (variant && variant.available) {
          if (
            variant.inventory_management &&
            _._getVariantOptionElement(variant, $container).data("stock") ==
              "out"
          ) {
            var productData = _.getProductData($backorder.closest("form"));

            $backorder
              .find(".backorder__variant")
              .html(
                productData.title +
                  (variant.title.indexOf("Default") >= 0
                    ? ""
                    : " - " + variant.title)
              );
            $backorder.show();
          } else {
            $backorder.hide();
          }
        } else {
          $backorder.hide();
        }
      }
    };

    _.updatePrice = function (variant, $container) {
      var $priceArea = $container.find(_.selectors.priceArea);
      $priceArea.removeClass("on-sale");
      var $priceAreaContainer = $container.find(_.selectors.priceAreaContainer);

      if (variant.unit_price_measurement) {
        $priceAreaContainer
          .removeClass("price-area--no-unit-price")
          .addClass("price-area--has-unit-price");
      } else {
        $priceAreaContainer
          .removeClass("price-area--has-unit-price")
          .addClass("price-area--no-unit-price");
      }

      if (variant && variant.available == true) {
        var $newPriceArea = $("<div>");

        if (variant.compare_at_price > variant.price) {
          $('<span class="was-price theme-money">')
            .html(
              theme.Shopify.formatMoney(
                variant.compare_at_price,
                theme.money_format
              )
            )
            .appendTo($newPriceArea);
          $newPriceArea.append(" ");
          $priceArea.addClass("on-sale");
        }

        $('<span class="current-price theme-money">')
          .html(theme.Shopify.formatMoney(variant.price, theme.money_format))
          .appendTo($newPriceArea);

        if (variant.unit_price_measurement) {
          var $newUnitPriceArea = $('<div class="unit-price">').appendTo(
            $newPriceArea
          );
          $('<span class="unit-price__price theme-money">')
            .html(
              theme.Shopify.formatMoney(variant.unit_price, theme.money_format)
            )
            .appendTo($newUnitPriceArea);
          $('<span class="unit-price__separator">')
            .html(_._getString("unitPriceSeparator"))
            .appendTo($newUnitPriceArea);
          $('<span class="unit-price__unit">')
            .html(_.getBaseUnit(variant))
            .appendTo($newUnitPriceArea);
        }

        $priceArea.html($newPriceArea.html());
      } else {
        if (variant) {
          $priceArea.html(
            "<span>" + _._getString("priceSoldOut", variant) + "</span>"
          );
        } else {
          $priceArea.html(
            "<span>" + _._getString("priceNonExistent", variant) + "</span>"
          );
        }
      }
    };

    _._updateButtonText = function ($button, string, variant) {
      $button.each(function () {
        var newVal;
        newVal = _._getString("button" + string, variant);

        if (newVal !== false) {
          if ($(this).is("input")) {
            $(this).val(newVal);
          } else {
            $(this).html(newVal);
          }
        }
      });
    };

    _.updateButtons = function (variant, $container) {
      var $button = $container.find(_.selectors.submitButton);

      if (variant && variant.available == true) {
        $button.removeAttr("disabled");

        _._updateButtonText($button, "Default", variant);
      } else {
        $button.attr("disabled", "disabled");

        if (variant) {
          _._updateButtonText($button, "NoStock", variant);
        } else {
          _._updateButtonText($button, "NoVariant", variant);
        }
      }
    };

    _.updateContainerStatusClasses = function (variant, $container) {
      $container.toggleClass("variant-status--unavailable", !variant.available);
      $container.toggleClass(
        "variant-status--backorder",
        variant.available &&
          variant.inventory_management &&
          _._getVariantOptionElement(variant, $container).data("stock") == "out"
      );
    };

    _.updateVariantOptionStatusClasses = function ($form) {
      var variant = _.currentVariant;

      var productData = _.getProductData($form); //For the given array of option values, find variants which share the same options

      function getMatchingVariants(optionValues) {
        // console.log(`Finding variants with option values: ${optionValues}`);
        var tempVariants = productData.variants;
        var matchingVariants = tempVariants.filter(function (thisVariant) {
          var variantMatches = true;

          for (var j = 0; j < optionValues.length; j++) {
            if (thisVariant.options[j] !== optionValues[j]) {
              variantMatches = false;
              break;
            }
          }

          return variantMatches;
        });
        return matchingVariants;
      } //Returns an object of all the possible values for the given option with each option set to false

      function getAllValuesForOption(i) {
        var allOptionValues = {};

        for (var l = 0; l < productData.variants.length; l++) {
          var value = productData.variants[l].options[i];

          if (value) {
            allOptionValues[value] = false;
          }
        }

        return allOptionValues;
      }

      if (variant === false) {
        //The variant is unavailable, fabricate variant options based on the current selection
        variant = {
          options: [],
        };
        $form.find(".selector-wrapper a.active[data-value]").each(function () {
          variant.options.push($(this).data("value"));
        });
      }

      if (variant && variant.options && variant.options.length > 1) {
        var optionValues = _toConsumableArray(variant.options);

        var optionStock = {}; //Iterate the current variant option selection from the bottom up

        for (var _i2 = variant.options.length - 1; _i2 >= 0; _i2--) {
          optionValues.pop(); //Get an object of values for this option all with stock set to false

          var optionAvailability = getAllValuesForOption(_i2); //Get variants which have the parent options

          var matchingVariants = getMatchingVariants(optionValues); //Check for in stock options within matching variants

          for (var k = 0; k < matchingVariants.length; k++) {
            if (matchingVariants[k].available) {
              var value = matchingVariants[k].options[_i2];

              if (value) {
                optionAvailability[value] = true;
              }
            }
          } //Add this option value to the master object of availability for this variant

          optionStock[productData.options[_i2]] = optionAvailability;
        } //Update the UI to reflect stock

        $(".selector-wrapper", $form).each(function () {
          var optionName = $(this).data("option-name");

          for (
            var _i3 = 0,
              _Object$entries = Object.entries(optionStock[optionName]);
            _i3 < _Object$entries.length;
            _i3++
          ) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
              option = _Object$entries$_i[0],
              isAvailable = _Object$entries$_i[1];

            option = removeDiacritics(option)
              .toLowerCase()
              .replace(/'/g, "")
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-+/g, "-")
              .replace(/-*$/, "");
            $(this)
              .find(".clickyboxes .opt--".concat(option))
              .toggleClass("unavailable", !isAvailable);
          }
        });
      }
    };

    _.initProductOptions = function (originalInput) {
      $(originalInput)
        .not(".theme-init")
        .addClass("theme-init")
        .each(function () {
          var $originalInput = $(this);

          if (
            $originalInput.is("select") &&
            !$originalInput.hasClass("is-single-swatch")
          ) {
            var productData = _.getProductData($originalInput.closest("form")); // change state for original dropdown

            $originalInput.on(
              "change.themeProductOptions firstrun.themeProductOptions",
              function (e, variant) {
                if ($(this).is("input[type=radio]:not(:checked)")) {
                  return; // handle radios - only update for checked
                }

                var variant = variant;

                if (!variant && variant !== false) {
                  for (var i = 0; i < productData.variants.length; i++) {
                    if (productData.variants[i].id == $(this).val()) {
                      variant = productData.variants[i];
                    }
                  }
                }

                var $container = $(this).closest(_.selectors.container); // update price

                _.updatePrice(variant, $container); // update buttons

                _.updateButtons(variant, $container); // emit an event to broadcast the variant update

                $(window).trigger("cc-variant-updated", {
                  variant: variant,
                  product: productData,
                }); // variant images

                if (variant && variant.featured_media) {
                  $container
                    .find(_.selectors.gallery)
                    .trigger("variantImageSelected", variant);
                }

                _.currentVariant = variant;
                var $form = $(this).closest("form"); // extra details

                _.updateBarcode(variant, $container);

                _.updateSku(variant, $container);

                _.updateInventoryNotice(variant, $container);

                _.updateBackorder(variant, $container);

                _.updateContainerStatusClasses(variant, $container);

                if ($form.data("show-realtime-availability")) {
                  _.updateVariantOptionStatusClasses($form);
                } // variant urls

                if ($form.data("enable-history-state") && e.type == "change") {
                  _.addVariantUrlToHistory(variant);
                } // notify quickbuy of content change

                $container.find(".quickbuy-container").trigger("changedsize");
              }
            ); // split-options wrapper

            $originalInput
              .closest(_.selectors.container)
              .find(_.selectors.multiOption)
              .on("change.themeProductOptions", "select", function () {
                var selectedOptions = [];
                $(this)
                  .closest(_.selectors.multiOption)
                  .find("select")
                  .each(function () {
                    selectedOptions.push($(this).val());
                  }); // find variant

                var variant = false;

                for (var i = 0; i < productData.variants.length; i++) {
                  var v = productData.variants[i];
                  var matchCount = 0;

                  for (var j = 0; j < selectedOptions.length; j++) {
                    if (v.options[j] == selectedOptions[j]) {
                      matchCount++;
                    }
                  }

                  if (matchCount == selectedOptions.length) {
                    variant = v;
                    break;
                  }
                } // trigger change

                if (variant) {
                  $originalInput.val(variant.id);
                }

                $originalInput.trigger("change", variant);
              }); // first-run

            $originalInput.trigger("firstrun");
          } else {
            var productData = _.getProductData($originalInput.closest("form"));

            var $container = $(this).closest(_.selectors.container);
            var $backorder = $container.find(".backorder");
            var quantityAvailable = $container
              .find(".single_variant_availability")
              .val();

            if ($backorder.length > 0 && quantityAvailable < 1) {
              $backorder
                .find(".backorder__variant")
                .html(
                  productData.title +
                    (productData.variants[0].title.indexOf("Default") >= 0
                      ? ""
                      : " - " + productData.variants[0].title)
                );
              $backorder.show();
            }
          } // ajax

          theme.applyAjaxToProductForm($originalInput.closest("form"));
        });
    };

    _.unloadProductOptions = function (originalInput) {
      $(originalInput)
        .removeClass("theme-init")
        .each(function () {
          $(this).trigger("unloading").off(".themeProductOptions");
          $(this)
            .closest(_.selectors.container)
            .find(_.selectors.multiOption)
            .off(".themeProductOptions");
          theme.removeAjaxFromProductForm($(this).closest("form"));
        });
    };
  })();
  theme.addControlPaddingToModal = function () {
    // $("body")
    //   .get(0)
    //   .style.setProperty("--header-height", `${theme.Nav().bar.height()}px`);
    $(".theme-modal.reveal > .inner").css(
      "padding-top",
      theme.Nav().bar.height()
    );
  }; /// Maintain padding at the top of the body to reserve space

  theme.updateBodyPadding = function () {
    $("body").css("padding-top", Math.round(theme.Nav().bar.height()));
  };

  theme.assessTopSectionPadding = function () {
    var $topBlogSection = $(
      "#page-content .shopify-section:first-child.section-featured-blog .slideshow-blog"
    );

    if ($topBlogSection.length) {
      $topBlogSection.addClass("slideshow-blog--top");
      var nav = theme.Nav();

      if ($topBlogSection.find(".slideshow-blog__title").length) {
        $topBlogSection
          .find(".slideshow-blog__title")
          .css("top", nav.bar.height());
      }

      if ($topBlogSection.find(".slideshow-blog__view-all").length) {
        $topBlogSection
          .find(".slideshow-blog__view-all")
          .css("top", nav.bar.height());
      }
    }
  };

  theme.allowRTEFullWidthImages = function (container) {
    $(
      ".rte--allow-full-width-images p > img, .rte--allow-full-width-images div > img",
      container
    ).each(function () {
      if ($(this).siblings().length == 0) {
        $(this).unwrap().wrap('<div class="no-side-pad">');
      }
    });
    $(
      ".rte--allow-full-width-images p > a > img, .rte--allow-full-width-images div > a > img",
      container
    ).each(function () {
      if (
        $(this).siblings().length == 0 &&
        $(this).parent().siblings().length == 0
      ) {
        $(this).parent().unwrap().wrap('<div class="no-side-pad">');
      }
    });
  };

  theme.browserHas3DTransforms = function () {
    var el = document.createElement("p"),
      has3d,
      transforms = {
        webkitTransform: "-webkit-transform",
        OTransform: "-o-transform",
        msTransform: "-ms-transform",
        MozTransform: "-moz-transform",
        transform: "transform",
      }; // Add it to the body to get the computed style.

    document.body.insertBefore(el, null);

    for (var t in transforms) {
      if (el.style[t] !== undefined) {
        el.style[t] = "translate3d(1px,1px,1px)";
        has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
      }
    }

    document.body.removeChild(el);
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
  };

  if (theme.browserHas3DTransforms()) {
    $("html").addClass("supports-transforms");
  }

  theme.namespaceFromSection = function (container) {
    return [
      ".",
      $(container).data("section-type"),
      $(container).data("section-id"),
    ].join("");
  }; //Try and trigger the reviews stuff to render, but fail silently

  theme.tryRefreshProductReviews = function () {
    if (window.SPR) {
      try {
        SPR.initRatingHandler();
        SPR.initDomEls();
        SPR.loadProducts();
        SPR.loadBadges();
      } catch (err) {}
    }
  }; //Keep elements full height where appropriate
  // theme.updateFullHeightElements = function () {
  //   let minHeight = 500;
  //   const windowHeight = $(window).height();
  //
  //   if(windowHeight > minHeight){
  //     minHeight = windowHeight;
  //   }
  //
  //   if()
  //
  //   $('#cc-full-height').remove();
  //
  //   $('head').append(`<style type="text/css" id="cc-full-height">
  //         .height--full, .height--full .rimage-outer-wrapper, .placeholder-image {
  //             min-height: ${minHeight} !important;
  //         }
  //     </style>`);
  // }
  /*================ Sections ================*/

  theme.HeaderSection = new (function () {
    var c;
    var currentScrollTop = 0;
    var default_threshold = 100;

    handleScroll = function handleScroll(nav, positioning, opacity) {
      if (
        opacity === "opaque_on_scroll" ||
        opacity === "opaque_on_scroll_alt"
      ) {
        if ($(window).scrollTop() < 100) {
          nav.bar.turnOpaque(false);
        } else {
          nav.bar.turnOpaque(true);
        }
      } else if (opacity !== "opaque") {
        nav.bar.turnOpaque(false);
      }

      var scrollTop = $(window).scrollTop();

      if (
        (positioning === "peek" ||
          (nav.bar.isAnnouncementBar() && positioning == "sticky")) &&
        scrollTop > 100
      ) {
        currentScrollTop = scrollTop;

        if (positioning != "sticky") {
          if (c < currentScrollTop && scrollTop > default_threshold) {
            nav.bar.hide(true);
          } else if (c > currentScrollTop && !(scrollTop <= 50)) {
            nav.bar.hide(false);
          }
        }

        c = currentScrollTop;
      } else {
        nav.bar.hide(false);
      }

      if (positioning == "sticky" || positioning == "peek") {
        if (scrollTop <= 100) {
          nav.bar.hideAnnouncement(false);
        } else {
          nav.bar.hideAnnouncement(true);
        }
      }
    };

    this.onSectionLoad = function (target) {

      theme.addControlPaddingToModal();
      theme.updateBodyPadding();
      $("body").toggleClass(
        "modal-active",
        $(".theme-modal.reveal").length > 0
      );
      $("#page-menu a", target).attr("tabindex", "-1");
      $("#page-menu .main-nav li:has(ul)", target).addClass("has-children");
      $(
        "#page-menu.nav-uses-modal .main-nav li.has-children > a",
        target
      ).append(
        '<span class="arr">' +
          theme.icons.newDrop +
          theme.icons.closed +
          "</span>"
      );
      $(".disclosure", target).each(function () {
        $(this).data("disclosure", new theme.Disclosure($(this)));
      });
      var nav = new theme.Nav();
      var positioning = nav.bar.getPositionSetting();
      var opacity = nav.bar.getOpacitySetting();

      if (opacity === "opaque") {
        nav.bar.turnOpaque(true);
      } else {
        nav.bar.turnOpaque(false);
      }

      if (positioning === "inline") {
        $("body").addClass("nav-inline");
      } else {
        $("body").removeClass("nav-inline");
      }

      if (nav.bar.isAnnouncementBar()) {
        $("body").addClass("showing-announcement");
      } else {
        $("body").removeClass("showing-announcement");
      }

      if (
        opacity === "opaque_on_scroll" ||
        opacity === "opaque_on_scroll_alt" ||
        positioning === "peek" ||
        nav.bar.isAnnouncementBar()
      ) {
        currentScrollTop = 0;
        $(window).on("throttled-scroll.nav", function () {

          handleScroll(nav, positioning, opacity);
        });
      }

      $(document).on(
        "click.video-section",
        ".video-container__play",
        function () {
          if (theme.viewport.isXs()) {
            nav.bar.fadeOut(true);
          }
        }
      );
      $(document).on(
        "click.video-section",
        ".video-container__stop",
        function () {
          if (theme.viewport.isXs()) {
            nav.bar.fadeOut(false);
          }
        }
      );
      theme.checkViewportFillers();
      theme.assessAltLogo();
      $(window).trigger("cc-header-updated");
    };

    this.onSectionUnload = function (target) {
      $(".disclosure", target).each(function () {
        $(this).data("disclosure").unload();
      });
      $(window).off("throttled-scroll.nav");
      $(document).on("click.video-section");
    };
  })();
  theme.FooterSection = new (function () {
    this.onSectionLoad = function (container) {
      $(".disclosure", container).each(function () {
        $(this).data("disclosure", new theme.Disclosure($(this)));
      });
    };

    this.onSectionUnload = function (container) {
      $(".disclosure", container).each(function () {
        $(this).data("disclosure").unload();
      });
    };
  })();
  theme.SlideshowSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.initContentSlider(target);
      $(window).trigger("slideshowfillheight");
      theme.checkViewportFillers();
      theme.assessAltLogo();
    };

    this.onSectionUnload = function (target) {
      $(".slick-slider", target).slick("unslick").off("init");
      $(window).off(".slideshowSection");
    };

    this.onBlockSelect = function (target) {
      $(target)
        .closest(".slick-slider")
        .slick("slickGoTo", $(target).data("slick-index"))
        .slick("slickPause");
    };

    this.onBlockDeselect = function (target) {
      $(target).closest(".slick-slider").slick("slickPlay");
    };
  })();
  theme.FeaturedBlogSection = new (function () {
    this.onSectionLoad = function (target) {
      if ($(".carousel-blog", target).length) {
        var $swiperCont = $(".swiper-container", target);

        if ($swiperCont.length === 1) {
          theme.initProductSlider($swiperCont, true);
        }
      }

      if ($(".slideshow-blog", target).length) {
        theme.initContentSlider(target, function (slide) {
          $(".slideshow-blog__titles__active", target).removeClass(
            "slideshow-blog__titles__active"
          );
          $('[data-go-to-slide="'.concat(slide, '"]'), target)
            .parent()
            .addClass("slideshow-blog__titles__active");
        });
        var $slideshowTitles = $(".slideshow-blog__titles", target);

        if ($('.slideshow[data-title-navigation="true"]', target).length) {
          var checkTitleNavHeight = function checkTitleNavHeight() {
            if (theme.viewport.isSm()) {
              $(".overlay-type .inner", target).css(
                "padding-bottom",
                $slideshowTitles.height() + 50 + "px"
              );
            } else {
              $(".overlay-type .inner", target).removeAttr("style");
            }
          };

          checkTitleNavHeight();
          $(window).on("debouncedresize.titleNavHeight", checkTitleNavHeight);
          $("[data-go-to-slide]", target).on("click", function () {
            var slideNum = $(this).data("go-to-slide");
            $(".slideshow", target)
              .slick("slickGoTo", slideNum)
              .slick("slickPause");
            $(".slideshow-blog", target).addClass("slideshow--paused");
            return false;
          });
          $("[data-go-to-slide]:first", target)
            .parent()
            .addClass("slideshow-blog__titles__active");
        }

        $(window).trigger("slideshowfillheight");
      }

      theme.checkViewportFillers();
      theme.assessAltLogo();
    };

    this.onSectionUnload = function (target) {
      $(".slick-slider", target).slick("unslick").off("init");
      $(window).off("debouncedresize.titleNavHeight");
      $("[data-go-to-slide]", target).off("click");
    };
  })();
  theme.ImageWithTextOverlay = new (function () {
    var _ = this;

    _.checkTextOverImageHeights = function () {
      $(
        '[data-section-type="image-with-text-overlay"], [data-nested-section-type="image-with-text-overlay"]'
      ).each(function () {
        var $imageContainer = $(".rimage-outer-wrapper", this);
        var imageHeight = $(".rimage-wrapper", this).outerHeight();
        var textVerticalPadding = parseInt(
          $(".overlay", this).css("padding-top")
        );
        var textHeight =
          $(".overlay__content", this).height() + textVerticalPadding * 2;

        if (textHeight > imageHeight + 2) {
          // +2 for rounding errors
          $imageContainer.css("height", textHeight);
        } else {
          $imageContainer.css("height", "");
        }
      });
    };

    this.onSectionLoad = function (target) {
      $(window).off(".imageWithTextOverlaySection");

      if ($(".overlay__content", target).length) {
        $(_.checkTextOverImageHeights);
        $(window).on(
          "debouncedresize.imageWithTextOverlaySection",
          _.checkTextOverImageHeights
        );
      }

      theme.checkViewportFillers();
    };

    this.onSectionUnload = function (target) {
      $(window).off(".imageWithTextOverlaySection");
    };
  })();
  theme.ImageBesideImageSection = new (function () {
    var _ = this;

    _.checkTextOverImageHeights = function () {
      $(".image-beside-image__image").each(function () {
        var $imageContainer = $(".rimage-outer-wrapper", this);
        var imageHeight = $(".rimage-wrapper", this).outerHeight();
        var textVerticalPadding = parseInt(
          $(".overlay", this).css("padding-top")
        );
        var textHeight =
          $(".overlay__content", this).height() + textVerticalPadding * 2;

        if (textHeight > imageHeight + 2) {
          // +2 for rounding errors
          $imageContainer.css("height", textHeight);
        } else {
          $imageContainer.css("height", "");
        }
      });
    };

    this.onSectionLoad = function (target) {
      $(window).off(".imageBesideImageSection");

      if ($(".overlay__content", target).length) {
        $(_.checkTextOverImageHeights);
        $(window).on(
          "debouncedresize.imageBesideImageSection",
          _.checkTextOverImageHeights
        );
      }

      theme.checkViewportFillers();
    };

    this.onSectionUnload = function (target) {
      $(window).off(".imageBesideImageSection");
    };
  })();
  theme.ProductTemplateSection = new (function () {
    var galleries = [];
    var nav = theme.Nav();

    this.onSectionLoad = function (target) {
      if (window.location.href.indexOf("eu.") > -1) {
        var countriesEU =
          "AT,BE,BG,HR,CY,CZ,EE,FI,FR,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,CH,DK,DE,NO,CA";
        var z = JSON.parse(localStorage.getItem("geoip-location"));
        if (z) {
          var x = z.value.country.iso_code;
          var country = z.value.country.names.en;
          if (x == "CH") {
            $(".product-policies").html("<p>Tax & Duties included</p>");
          } else if (x == "HK") {
            $(".product-policies").hide();
          } else if (x == "RU") {
            $(".product-policies").html(
              '<p><a target="_blank" href="/pages/shipping-terms-dhl-russia">Tax and duties may apply</a></p>'
            );
          } else if (countriesEU.includes(x)) {
            $(".product-policies").html("<p>VAT & Duties included</p>");
          } else {
            $(".product-policies").html("<p>Taxes & Duties may apply</p>");
          }
        }
      }

      var isFeaturedProduct = $(target).data("is-featured-product") || false; /// Init store availability if applicable

      if (
        !isFeaturedProduct &&
        $("[data-store-availability-container]", target).length
      ) {
        this.storeAvailability = new theme.StoreAvailability(
          $("[data-store-availability-container]", target)[0]
        );
      } // header assessment first (affects gallery height)

      theme.checkViewportFillers();
      theme.assessAltLogo();

      if (nav.bar.isCurrentlyOpaque() && !isFeaturedProduct) {
        $("body").removeClass("header-section-overlap");
      } /// Product page upper gallery

      $(".theme-gallery", target).each(function () {
        galleries.push(
          new theme.ProductMediaGallery(
            $(this),
            $(".theme-gallery-thumb", target),
            isFeaturedProduct
          )
        );
      });
      var headerIsMobileMode = false;
      var $stickyAddToCart = $(".product-area__add-to-cart-xs", target);
      var stickyAddToCartInitialised = !$stickyAddToCart.length;
      var stickyAddToCartIsUnstuck = false;
      var stickyAddToCartThreshold = $(
        "#shopify-section-product-template"
      ).outerHeight();
      var $productHeader = $(".product-area__details__header", target);
      var $productDetails = $(".product-area__details", target); /// Work out the tallest product tab and compensate the height of the details area
      /// (for position:sticky to work in this case, it needs a fixed height).

      function resizeProductDetails() {
        if (theme.viewport.isSm()) {
          $productDetails
            .find(".product-area__details__inner")
            .css("top", nav.bar.height() + 20 + "px");
          $productHeader.css("margin-top", 0); // If the product details is too close to the top (due to the height of the media panel)

          if ($productDetails.offset().top < nav.bar.height() - 1) {
            $productHeader.css("margin-top", nav.bar.height() - 20 + "px");
          }

          if (headerIsMobileMode) {
            $productHeader.prependTo(".product-area__details__inner");
            headerIsMobileMode = false;
          }
        } else {
          //It's mobile
          if (!headerIsMobileMode) {
            if (
              $(".product-area > .product-area__details__header", target).length
            ) {
              $(
                ".product-area > .product-area__details__header",
                target
              ).remove();
            } //If header overlap is set, set padding top for the header

            if ($("body").hasClass("header-section-overlap")) {
              $productHeader.css("margin-top", nav.bar.height());
            } else {
              $productHeader.css("margin-top", 0);
            }

            $productHeader.prependTo(".product-area");
            headerIsMobileMode = true;
          } else {
            $productHeader.css("margin-top", nav.bar.height());
          }

          if (!stickyAddToCartInitialised) {
            $(window).on("throttled-scroll.sticky-add-to-cart", function () {
              if ($(window).scrollTop() > stickyAddToCartThreshold) {
                if (!stickyAddToCartIsUnstuck) {
                  $stickyAddToCart.addClass("-out");
                  stickyAddToCartIsUnstuck = true;
                }
              } else {
                if (stickyAddToCartIsUnstuck) {
                  $stickyAddToCart.removeClass("-out");
                  stickyAddToCartIsUnstuck = false;
                }
              }
            });
            $(".product-area__add-to-cart-xs button", target).on(
              "click",
              function (e) {
                $(".product-detail__form form", target).submit();
              }
            );
            stickyAddToCartInitialised = true;
          }
        }
      }

      if (!isFeaturedProduct) {
        $(window).on(
          "debouncedresizewidth.productDetails",
          resizeProductDetails
        );
        $(window).on("cc-header-updated.productDetails", resizeProductDetails);
        resizeProductDetails();
      } /// Thumb carousels

      if ($(".product-area__details__thumbs").length) {
        $(".carousel-wrapper .carousel:not(.slick-initialized)", target).each(
          function ($slick) {
            $(this)
              .on("init reInit setPosition", function () {
                var lastSlide = $(this).find(".slick-slide:last");

                if (lastSlide.length > 0) {
                  var slideInnerWidth =
                    lastSlide.position().left + lastSlide.outerWidth(true);
                  var $carouselWrapper = $(this).parent();
                  var carouselWidth = $carouselWrapper.outerWidth(true);

                  if (carouselWidth > slideInnerWidth) {
                    $(this)
                      .find(".slick-next, .slick-prev")
                      .addClass("theme-unnecessary")
                      .attr("tabindex", "-1");
                  } else {
                    $(this)
                      .find(".slick-next, .slick-prev")
                      .removeClass("theme-unnecessary")
                      .attr("tabindex", "0");
                  }
                }
              })
              .on("init reInit setPosition", function ($slick) {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
                setTimeout(function () {
                  $($slick.target).find(".slick-slide a").attr("tabindex", "0");
                });
              })
              .slick({
                autoplay: false,
                fade: false,
                infinite: false,
                useTransform: true,
                arrows: true,
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                centerMode: false,
                verticalSwiping: true,
                vertical: true,
                prevArrow:
                  '<button type="button" class="slick-prev" aria-label="' +
                  theme.strings.previous +
                  '">' +
                  theme.icons.chevronDown +
                  "</button>",
                nextArrow:
                  '<button type="button" class="slick-next" aria-label="' +
                  theme.strings.next +
                  '">' +
                  theme.icons.chevronDown +
                  "</button>",
                responsive: [
                  {
                    breakpoint: 1100,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    },
                  },
                ],
              });
          }
        );
      } /// Product options

      theme.OptionManager.initProductOptions($('[name="id"]', target)); /// Boxed-options

      theme.convertOptionsToBoxes(target); /// Visual style of dropdowns

      $("select:not(.original-selector)")
        .selectReplace()
        .closest(".selector-wrapper")
        .addClass("has-pretty-select"); /// Size chart

      $(".size-chart-link", target).on("click", function () {
        $.colorbox({
          inline: true,
          href: "#size-chart-content > .size-chart",
        });
        return false;
      }); // Keep colour swatches updated

      $(window).on("cc-variant-updated.product-swatches", function (e, args) {
        var $swatchesContainer = $(".cc-swatches", target);

        if ($swatchesContainer.length) {
          $swatchesContainer.find(".cc-swatches__label").remove();
          $swatchesContainer
            .find("label")
            .append(
              '<span class="cc-swatches__label">'.concat(
                $swatchesContainer.find(".active").text(),
                "</span>"
              )
            );
        }
      }); /// Click on the reviews link
      // $('.product-area__details__header [href="#shopify-product-reviews"]', target).on('click', function(){
      //   const $socialLinks = $(target).find('.social-links');
      //   const $reviewsTab = $(target).find('#shopify-product-reviews').closest('.cc-tabs__tab');
      //   const $reviewsHeader = $reviewsTab.find('.cc-tabs__accordion__header');
      //
      //   if($reviewsHeader.length) {
      //     if($reviewsHeader.attr('aria-selected') != "true") {
      //       $reviewsHeader.trigger('click');
      //     }
      //
      //     //Calculate where Reviews are (which isn't easy because they're in a sticky container)
      //     const reviewsTop = $(target).offset().top
      //       + $(target).outerHeight()
      //       - $reviewsTab.outerHeight()
      //       - parseInt($(target).find('.product-area__details__inner').css('padding-bottom').replace('px', ''))
      //       - ($socialLinks.length ? $(target).find('.social-links').outerHeight() : 0)
      //       - theme.Nav().bar.height();
      //
      //     theme.viewport.scrollTo(null, reviewsTop);
      //     return false;
      //   }
      // });
      /// Trigger the animations

      $.fn.initAnimateOnScroll();
    };

    this.onSectionUnload = function (target) {
      $(window).off("doThemeGalleryResizeCheck.productTemplateGallery");
      $(window).off("throttled-scroll.sticky-add-to-cart");
      $(window).off(".productDetails");
      $(window).off("cc-variant-updated.product-swatches");
      $(".spr-container", target).off("click");
      $(".theme-gallery-thumb", target).off("click");
      $(".carousel-wrapper .carousel", target).off("init reInit setPosition");
      $(".slick-slider", target).slick("unslick");
      $(".size-chart-link", target).off("click");
      $(".product-area__add-to-cart-xs button", target).off("click"); // $('.product-area > .product-area__details__header', target).remove();

      theme.OptionManager.unloadProductOptions($('[name="id"]', target));

      if (galleries.length) {
        for (var i = 0; i < galleries.length; i++) {
          galleries[i].destroy();
        }
      }

      if (this.storeAvailability) {
        this.storeAvailability.onSectionUnload();
      }
    };
  })();
  theme.CollectionTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.updateBodyPadding();
      var tagGroupsEnabled = $(target).data("tag-groups-enabled"); // Infinite scroll

      var count = 0;
      

if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1) {
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  var getCount = localStorage.getItem('count', count);
  getCount ++;

  localStorage.setItem('count', getCount);
  var checkCount = localStorage.getItem('count', count);

  window.infiniteScroll = false;
  window.scrollToMe = true;

  /* Scroll to the element */
  if (window.scrollToMe == true) {
    const item_to_scroll = localStorage.getItem('product_scroll_id');
    const toScroll = $(`#${item_to_scroll}`);
    if(item_to_scroll){
      setTimeout(function () {
        $("body,html,document").animate({
          scrollTop: toScroll.position().top
        }, 'slow');
  
      }, 100);
    }
    
    window.scrollToMe = false;
              
  }

  if (window.checkCount > 0 && window.infiniteScroll == false) {
      
      window.addEventListener("pageshow", function(evt){
          if(evt.persisted){
          setTimeout(function(){
              window.location.reload();
          },10);
        }
      }, false);

      $('.preload').css("display","block");

      $(document).ready(function() {
        $(".preload").fadeOut(3000);
      });
                    
      $(".pagination.infiniscroll:not(.infinit)")
        .addClass("infinit")
        .each(function () {
          var waitForTrigger = $(this).hasClass("wait-for-trigger");
          var $pager = $(
            '<div class="pager-button"><a href="#" aria-label="' +
              theme.strings.loadMore +
              '">' +
              theme.icons.loading +
              "</a></div>"
          );
          $(this).replaceWith($pager);

          $pager.find("a").attr("href", $(this).find(".next a").attr("href"));
          $pager.on("click", "a", function (e) {
            if ($(this).hasClass("loading")) {
              return false;
            } //Show spinner
  
            $(this).addClass("loading"); //Load next page
  
            var $link = $(this);
            var infiniteLoadCount = 1; /// Pagination-replacement

              const queryOptions = {
                method: "GET",
                credentials: "same-origin",
              };

              let queries = [];

              window.infiniteScroll = true;
              const url = $(this).attr("href");
              console.log(url);
              var new_url = url;
              window.history.pushState(null,"",new_url);  
              queries.push(fetch(
                url,
                queryOptions
              ));
                

              /* Update link based on data-page on product */
              const products = document.querySelectorAll('.product-block');
              products.forEach(function(product){
                product.addEventListener('click', function(){
                  const url = window.location.href;
                  const page = $(this).attr('data-page');
                  const page_num = url.split('=');
                  p_num = page_num[1];
                  const new_link = page_num[0] + '=' + page;
                  localStorage.setItem('count', page);
                  window.history.pushState(null,"",new_link);

                })
              })
              
              
              Promise.all(queries).then(function (responses) {
    
                Promise.all(
                  responses.map(function (response) {
                  return response.text();
                  })).then(function (contents) {
                    contents.forEach((item) => {
                      appendContent(item)
                    })                                          
                  })
                  
              });

              function appendContent(data) {
                var isCollage = false;
                var $data = $($.parseHTML(data));
            
                if ($(".product-list--columns").length) {
                    // Collage stil
                    isCollage = true;
                    var $newProducts = $data.find(".product-list").css("opacity", 0);
                    $newProducts.prepend(
                        "<h2>" + theme.strings.page.replace("{{ page }}", infiniteLoadCount) + "</h2>"
                    );
                    $newProducts = $newProducts.insertBefore(".product-list-container .pager-button");
                } else {
                    // Standardni stil
                    var $newProducts = $data.find(".product-list .product-block").css("opacity", 0);
                    $(".product-list").append($newProducts);
                }
            
                // Sortiranje indeksa
                $(".product-list-container .product-block").each(function (index) {
                    $(this).removeAttr("data-loop-index").data("loop-index", index);
                });
            
                if (!isCollage) {
                    console.log("Pokrenuta animacija visine");
            
                    var $productList = $(".product-list");
                    var currentHeight = $productList.outerHeight(); // Trenutna visina
                    var $tempContainer = $("<div>").append($newProducts.clone().css({ position: "absolute", visibility: "hidden", display: "block" })).appendTo("body");
                    var newHeight = $tempContainer.height();
                    $tempContainer.remove();
            
                    $productList.css("min-height", currentHeight).css("overflow", "hidden");
            
                    $newProducts.addClass("pre-trans").css("display", "block");
            
                    $productList.animate(
                        {
                            height: newHeight,
                        },
                        500,
                        function () {
                            $(this).css({ height: "", "min-height": "", overflow: "" });
                            $newProducts.removeClass("pre-trans").css("opacity", 1);
                            setTimeout(theme.tryRefreshProductReviews, 500);
                        }
                    );
            
                    $(".video-por-wrapper video").trigger("play");
                } else {
                    setTimeout(function () {
                        $newProducts.fadeIn();
                        setTimeout(theme.tryRefreshProductReviews, 500);
                    }, 300);
                }
            
                // Provera da li ima još proizvoda za učitavanje
                var $next = $data.find(".pagination .next a");
            
                if ($next.length == 0) {
                    $(".pager-button").slideUp();
                } else {
                    $(".pager-button a").attr("href", $next.attr("href")).removeClass("loading");
                }
            
                // Sprečavanje dupliranja proizvoda
                setTimeout(() => {
                    $(".product-block").each(function () {
                        var productId = $(this).data("product-id");
                        var $duplicates = $('.product-block[data-product-id="' + productId + '"]');
            
                        if ($duplicates.length > 1) {
                            $duplicates.slice(1).hide();
                        }
                    });
                }, 100);
            }
            
                
          })
          if (!waitForTrigger) {
            //Infiniscroll
            $(window).on("throttled-scroll.infiniscroll", function () {
              if (
                $(window).scrollTop() + $(window).height() >
                $pager.offset().top - 500
              ) {
                $pager.find("a").trigger("click");
              }
            });
          }
        })

  } else{
    console.log('else')
    theme.loadInfiniteScroll(target);
  }
  }else{
    theme.loadInfiniteScroll(target);
  }
      
      if (!tagGroupsEnabled) {
        // Sorting
        var $sortBy = $("#sort-by", target);

        if ($sortBy.length > 0) {
          queryParams = {};

          if (location.search.length) {
            for (
              var aKeyValue,
                i = 0,
                aCouples = location.search.substr(1).split("&");
              i < aCouples.length;
              i++
            ) {
              aKeyValue = aCouples[i].split("=");

              if (aKeyValue.length > 1) {
                queryParams[decodeURIComponent(aKeyValue[0])] =
                  decodeURIComponent(aKeyValue[1]);
              }
            }
          }

          $sortBy
            .val($sortBy.data("initval"))
            .trigger("change")
            .on("change", function () {
              queryParams.sort_by = $(this).val();
              location.search = $.param(queryParams);
            });
        } // Visual style of dropdowns

        $("select").selectReplace();
      } else {
        var buildActiveFilterControls = function buildActiveFilterControls() {
          var activeFilterHtml = "";
          $(
            ".cc-product-filter ul:not(.cc-product-filter__sort-by) li.active button",
            target
          ).each(function () {
            var tag = $(this).closest("li").data("tag");
            var heading = $(this)
              .closest(".cc-tabs__tab")
              .find(".cc-tabs__accordion__header")
              .text()
              .trim();
            activeFilterHtml += '<li><a href="#" data-active-tag="'
              .concat(tag, '">')
              .concat(heading, ": ")
              .concat($(this).text())
              .concat(theme.icons.close, "</a></li>");
          });

          if (activeFilterHtml) {
            var collectionUrl = $(target)
              .closest("[data-collection-url]")
              .data("collection-url");
            $(".product-list-container", target).prepend(
              '\n            <div class="active-filter-controls-container">\n              <ul class="active-filter-controls">\n                  '
                .concat(activeFilterHtml, '\n                  <li><a href="')
                .concat(
                  collectionUrl,
                  '" class="active-filter-controls__clear">Clear all</a></li>\n              </ul>\n            </div>\n          '
                )
            );
          } //Update the mobile 'Close filters' button text

          if ($(".cc-product-filter", target).hasClass("-in")) {
            var buttonText;
            var resultCount = $(".product-list", target).data("result-count");

            if (resultCount === 1) {
              buttonText = $("[data-show-collection-filter]", target)
                .data("result-count-text-singular")
                .replace("[x]", resultCount);
            } else {
              buttonText = $("[data-show-collection-filter]", target)
                .data("result-count-text")
                .replace("[x]", resultCount);
            }

            $("[data-show-collection-filter]", target).text(buttonText);
          }
        };

        var updateCollectionResults = function updateCollectionResults(
          url,
          updatePushState
        ) {
          var $filterContainer = $(".cc-product-filter-container", target);
          $filterContainer.addClass("cc-product-filter-container--loading");
          $filterContainer
            .find(".product-list")
            .append(
              '<span class="loading" aria-label="'
                .concat(theme.strings.loading, '">')
                .concat(theme.icons.loading, " </span>")
            );
          theme.unloadInfiniteScroll(target);
          $.get(url, function (content) {
            var $newPage = $($.parseHTML(content));
            var newTitleTag = $newPage.filter("title").text().trim();
            document.title = newTitleTag;

            if (updatePushState) {
              window.history.pushState(null, newTitleTag, url);
            } //Update the html of the page

            $filterContainer
              .find(".product-list-container")
              .html(
                $newPage
                  .find(".cc-product-filter-container .product-list-container")
                  .html()
              ); //Update each of the hrefs in the filter

            var $filters = $newPage.find(
              ".cc-product-filter .cc-tabs__tab__panel ul"
            );
            $filterContainer
              .find(".cc-product-filter .cc-tabs__tab__panel ul")
              .each(function (index) {
                $(this).html($filters.eq(index).html());
              });
            buildActiveFilterControls();
            $filterContainer.removeClass(
              "cc-product-filter-container--loading"
            );
            theme.loadInfiniteScroll(target);
          });
        };

        // Handle click on the filter groups
        $(target).on("click", ".cc-tabs__tab__panel a", function () {
          $(this).closest("li").toggleClass("active");
          updateCollectionResults($(this).attr("href"), true);
          return false;
        }); // Handle clicking on the pagination

        $(target).on(
          "click",
          ".pagination a, .active-filter-controls a.active-filter-controls__clear",
          function () {
            updateCollectionResults($(this).attr("href"), true);
            return false;
          }
        );
        $(window).on("popstate.collection-list", function (e) {
          updateCollectionResults(window.location.href, false);
        }); // Handling clicking on the main filters - only allow one option per filter group

        $(target).on("click", ".cc-tabs__tab .not-a-button", function () {
          //Detect whether we are just deselecting this option
          var preventReselection = $(this).closest("li").hasClass("active"); //Update classes

          $(this)
            .closest(".cc-tabs__tab")
            .find(".active")
            .removeClass("active");

          if (!preventReselection) {
            $(this).closest("li").addClass("active");
          } //Get all active tags

          var activeTags = [];
          $(target)
            .find(".cc-tabs__tab .active")
            .each(function () {
              if ($(this).data("tag")) {
                activeTags.push($(this).data("tag"));
              }
            }); //Construct a new url

          var activeTagsUrlEncoded =
            activeTags.length > 0 ? activeTags.join("+") : "";
          var currentSortBy = $(target).find("[data-sort].active").data("sort");
          var url =
            window.location.protocol +
            "//" +
            window.location.host +
            $(target).data("collection-url") +
            "/" +
            activeTagsUrlEncoded +
            "?sort_by=" +
            currentSortBy;
          updateCollectionResults(url, true);
        });
        $(target).on("click", "[data-active-tag]", function (e) {
          e.preventDefault();
          $(target)
            .find('[data-tag="' + $(this).data("active-tag") + '"] button')
            .trigger("click");
          return false;
        });
        buildActiveFilterControls(); //Prepare the mobile filter button
        // let filterButtonIsStuck = false;
        // let $stickyFilterButton = $('.footer-button-xs', target);
        // $(window).on('throttled-scroll.collection-filter-button', function () {
        //   if ($(window).scrollTop() > 400) {
        //     if (filterButtonIsStuck) {
        //       $stickyFilterButton.removeClass('-out');
        //       filterButtonIsStuck = false;
        //     }
        //   } else {
        //     if (!filterButtonIsStuck) {
        //       $stickyFilterButton.addClass('-out');
        //       filterButtonIsStuck = true;
        //     }
        //   }
        // });

        var nav = theme.Nav();
        $(target).on("click", "[data-show-collection-filter]", function () {
          if ($(".cc-product-filter", target).hasClass("-in")) {
            $(this).text($(this).data("open-text"));
            $(this).parent().removeClass("active");
            nav.bar.fadeOut(false);
            document.body.dispatchEvent(
              new CustomEvent("collection-filter-dropdown", {
                detail: {
                  isOpen: false,
                },
              })
            );
          } else {
            $(this).text($(this).data("close-text"));
            $(this).parent().addClass("active");
            nav.bar.fadeOut(true);
            document.body.dispatchEvent(
              new CustomEvent("collection-filter-dropdown", {
                detail: {
                  isOpen: true,
                },
              })
            );
          }

          $(".cc-product-filter", target).toggleClass("-in");
          return false;
        });
      }

      theme.checkViewportFillers();
      theme.assessAltLogo();
    };

    this.onSectionUnload = function (target) {
      $("#sort-by", target).off("change");
      $(window).off("popstate.collection-list");
      $(window).off("throttled-scroll.collection-filter-button");
      $(".cc-tabs__tab__panel a", target).off("click");
      $(target).off("click");
      theme.unloadInfiniteScroll();
    };
  })();
  theme.ListCollectionsSection = new (function () {
    this.onSectionLoad = function (target) {};
  })();

  theme.SEARCH_CLEAR_INPUT_DELAY_MS = 400;

  theme.clearSearchResultsInputOnSubmit = function (container) {
    var form = container && container.querySelector('.search-form--page');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.addEventListener('submit', function () {
      setTimeout(function () {
        input.value = '';
      }, theme.SEARCH_CLEAR_INPUT_DELAY_MS);
    });
  };

  theme.SearchTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.clearSearchResultsInputOnSubmit(target);
      var pageSearchInput = target.querySelector('.search-form--page input[name="q"]');
      if (pageSearchInput) {
        setTimeout(function () {
          pageSearchInput.focus();
        }, 150);
      }
      if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1) {
        theme.loadInfiniteScroll(target);
        
        setTimeout(function () {
          const item_to_scroll = localStorage.getItem('product_scroll_id');
          const toScroll = $(`#${item_to_scroll}`);
          
          $("body,html,document").animate({
            scrollTop: toScroll.offset().top - 100
          }, 'slow');

        }, 6000);
      }else{
        theme.loadInfiniteScroll(target);
      }
      
    };

    this.onSectionUnload = function (target) {
      theme.unloadInfiniteScroll();
    };
  })();
  theme.BlogTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      /// Visual style of dropdowns
      $("select").selectReplace();
      theme.allowRTEFullWidthImages(target);
    };
  })();
  theme.ArticleTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.checkViewportFillers();
      theme.assessAltLogo();
      theme.allowRTEFullWidthImages(target);
    };
  })();
  theme.CartTemplateSection = new (function () {
    this.onSectionLoad = function (target) {
      theme.cartNoteMonitor.load($('#cartform [name="note"]', target)); // terms and conditions checkbox

      if ($("#cartform input#terms", target).length > 0) {
        $(document).on(
          "click.cartTemplateSection",
          '#cartform [name="checkout"]:submit, .additional-checkout-buttons :submit, .additional-checkout-buttons input[type=image], a[href="/checkout"]',
          function () {
            if ($("#cartform input#terms:checked").length == 0) {
              alert(theme.strings.cartConfirmation);
              return false;
            }
          }
        );
      }
    };

    this.onSectionUnload = function (target) {
      theme.cartNoteMonitor.unload($('#cartform [name="note"]', target));
      $(document).off(".cartTemplateSection");
    };
  })();
  theme.CollectionListSection = new (function () {
    this.onSectionLoad = function (target) {
      var $swiperCont = $(".swiper-container", target);

      if ($swiperCont.length === 1) {
        theme.initProductSlider($swiperCont);
      }
    };
  })();
  theme.FeaturedCollectionSection = new (function () {
    this.onSectionLoad = function (target) {
      var $swiperCont = $(".swiper-container", target);

      if ($swiperCont.length === 1) {
        theme.initProductSlider($swiperCont);
      }
    };
  })();
  theme.ProductRecommendations = new (function () {
    this.onSectionLoad = function (container) {
      var max_products = 4; // Look for an element with class 'product-recommendations'
      if ($(window).width() < 750) {
        max_products = 6;
      }
      var productRecommendationsSection = document.querySelector(
        ".product-recommendations"
      );

      if (productRecommendationsSection === null) {
        return;
      } // Read product id from data attribute

      var productId = productRecommendationsSection.dataset.productId; // Read limit from data attribute

      var limit = productRecommendationsSection.dataset.limit; // Build request URL

      var requestUrl =
        productRecommendationsSection.dataset.url +
        "?section_id=product-recommendations&limit=" +
        max_products +
        "&product_id=" +
        productId; // Create request and submit it using Ajax

      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);

      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML =
            container.querySelector(".product-recommendations").innerHTML;
          $.fn.initAnimateOnScroll();
          var $swiperCont = $(
            "#shopify-section-product-recommendations .swiper-container"
          );

          if ($swiperCont.length === 1) {
            theme.initProductSlider($swiperCont);
            setTimeout(theme.tryRefreshProductReviews, 500);
          } else {
            console.warn(
              "Unable to find #shopify-section-product-recommendations"
            );
          }
        }
      };

      request.send();
    };

    this.onSectionUnload = function (container) {};
  })();
  theme.GallerySection = new (function () {
    this.onSectionLoad = function (container) {
      var $carouselGallery = $(".gallery--mobile-carousel", container);

      if ($carouselGallery.length) {
        var assessCarouselFunction = function assessCarouselFunction() {
          var isCarousel = $carouselGallery.hasClass("slick-slider"),
            shouldShowCarousel = theme.viewport.isXs();

          if (!shouldShowCarousel) {
            $(".lazyload--manual", $carouselGallery)
              .removeClass("lazyload--manual")
              .addClass("lazyload");
          }

          if (isCarousel && !shouldShowCarousel) {
            // Destroy carousel
            // - unload slick
            $carouselGallery.slick("unslick").off("init");
            $carouselGallery
              .find("a, .gallery__item")
              .removeAttr("tabindex")
              .removeAttr("role"); // - re-row items

            var rowLimit = $carouselGallery.data("grid");
            var $currentRow = null;
            $carouselGallery.find(".gallery__item").each(function (index) {
              if (index % rowLimit === 0) {
                $currentRow = $('<div class="gallery__row">').appendTo(
                  $carouselGallery
                );
              }

              $(this).appendTo($currentRow);
            });
          } else if (!isCarousel && shouldShowCarousel) {
            // Create carousel
            // - de-row items
            $carouselGallery.find(".gallery__item").appendTo($carouselGallery);
            $carouselGallery.find(".gallery__row").remove(); // - init carousel

            $carouselGallery
              .on("init", function () {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .slick({
                autoplay: false,
                fade: false,
                infinite: false,
                useTransform: true,
                arrows: false,
                dots: true,
              });
          }
        };

        assessCarouselFunction();
        $(window).on(
          "debouncedresize.themeSection" + container.id,
          assessCarouselFunction
        );
      }
    };

    this.onSectionUnload = function (container) {
      $(window).off(".themeSection" + container.id);
      $(".slick-slider", container).each(function () {
        $(this).slick("unslick").off("init");
      });
    };

    this.onBlockSelect = function (block) {
      $(block)
        .closest(".slick-slider")
        .each(function () {
          $(this)
            .slick("slickGoTo", $(this).data("slick-index"))
            .slick("slickPause");
        });
    };

    this.onBlockDeselect = function (block) {
      $(block)
        .closest(".slick-slider")
        .each(function () {
          $(this).slick("slickPlay");
        });
    };
  })();
  theme.TestimonialsSection = new (function () {
    var scrollax;

    this.onSectionLoad = function (container) {
      if (theme.settings.animationEnabledDesktop && theme.viewport.isSm()) {
        scrollax = new Scrollax(window).init();
      }
    };

    this.onSectionUnload = function (container) {
      if (scrollax && scrollax.Scrollax) {
        scrollax.Scrollax("destroy");
      }
    };
  })();
  theme.PageStoryTemplate = new (function () {
    var scrollax;

    this.onSectionLoad = function (container) {
      if (theme.settings.animationEnabledDesktop && theme.viewport.isSm()) {
        scrollax = new Scrollax(window).init();
      }
    };

    this.onSectionUnload = function (container) {
      if (scrollax && scrollax.Scrollax) {
        scrollax.Scrollax("destroy");
      }
    };
  })();
  jQuery(function ($) {
    lazySizesConfig.minSize = 200; /// Gallery variant images

    $(document).on(
      "variantImageSelected",
      ".theme-gallery",
      function (e, args) {
        var $container = $(this);

        if ($(this).find(".swiper-container-horizontal").length) {
          var $swiperImgLinks = $(
            ".swiper-container:first .swiper-slide .product-media",
            this
          );
          var swiperId = $(".swiper-container:first", this).data("swiper-id");
          var swiper = theme.swipers[swiperId];
          var toMatch = args.featured_media.id;
          var $match = $swiperImgLinks
            .filter(function () {
              return $(this).data("media-id") == toMatch;
            })
            .first();

          if ($match.length) {
            setTimeout(
              function () {
                swiper.update();
                swiper.slideTo($match.parent().index(), 1000);
                $container
                  .find(".product-media--active-variant")
                  .removeClass("product-media--active-variant");
                $match
                  .closest(".product-media")
                  .addClass("product-media--active-variant");
              },
              args.eventType === "firstrun" ? 1500 : 0
            ); //Above: If its the first page load, wait 1.5s for media to load
          }
        } else if (!$(this).hasClass("featured-product__gallery")) {
          $(window).trigger("ccScrollToMedia", args.featured_media.id);
        } //If thumbs, scroll to the active one and add a class to it

        var $thumbSlider = $(this)
          .closest(".shopify-section")
          .find(".product-area__details__thumbs .carousel");

        if (
          $thumbSlider.length === 1 &&
          ($container.data("scroll-to-variant-media") !== false ||
            theme.viewport.isXs())
        ) {
          var $activeSlide = $thumbSlider.find(
            '[data-media-id="'.concat(args.featured_media.id, '"]:first')
          );

          if ($activeSlide.length) {
            $thumbSlider.find(".thumb-active").removeClass("thumb-active");
            $activeSlide.find("a").addClass("thumb-active");
            $thumbSlider.slick("slickGoTo", $activeSlide.data("slick-index"));
          }
        }
      }
    ); /// Visual style of dropdowns

    $("select:not(.original-selector)")
      .selectReplace()
      .closest(".selector-wrapper")
      .addClass("has-pretty-select"); /// General-purpose lightbox

    $("a[rel=lightbox]").colorbox(); /// Galleries (only on large screens)

    if (theme.viewport.isSm()) {
      $('a[rel="gallery"]').colorbox({
        rel: "gallery",
      });
    } /// Translations for colorbox

    $.extend($.colorbox.settings, {
      previous: theme.strings.colorBoxPrevious,
      next: theme.strings.colorBoxNext,
      close: theme.icons.close,
    }); /// Image-links

    $(".rte a img").closest("a").addClass("contains-img"); /// Check if using correct logo (would be nice to assess on section move/load/unload as well)

    theme.assessAltLogo(); /// On any section reload

    $(document).on("shopify:section:reorder", function (e) {
      theme.checkViewportFillers();
      theme.assessAltLogo();
      theme.updateBodyPadding();
      theme.assessTopSectionPadding();
    });
    $(document).on("shopify:section:load", function (e) {
      /// Image-links inside any rte block
      $(".rte a img", e.target).closest("a").addClass("contains-img"); /// Feature-sized headers have a little fluff

      if ($(".feature-header", e.target).length) {
        $(window).trigger("assessFeatureHeaders");
      } /// Init any inline videos

      $(".section-background-video--inline", e.target).each(function () {
        theme.VideoManager.onSectionLoad($(this)[0]);
      });
      theme.checkViewportFillers();
      theme.assessAltLogo();
      theme.updateBodyPadding();
      theme.assessTopSectionPadding();
    }); // end of shopify:section:load

    $(document).on("shopify:section:unload", function (e) {
      /// Unload any inline videos
      $(".section-background-video--inline", e.target).each(function () {
        theme.VideoManager.onSectionUnload($(this)[0]);
      });
    });
    theme.assessTopSectionPadding();
    $(window).on(
      "debouncedresizewidth.assessTopSectionPadding",
      theme.assessTopSectionPadding
    ); /// Slideshow fills viewport

    theme.lastViewportWidth = 0;
    $(window).on("debouncedresize slideshowfillheight", function (e) {
      // if only height changed, don't do anything, to avoid issue with viewport-size-change on mobile-scroll
      if (
        e.type == "debouncedresize" &&
        theme.lastViewportWidth == $(window).width()
      ) {
        return;
      }

      var nav = theme.Nav(); // set height of slideshows

      var desiredHeight = $(window).height();

      if (nav.bar.isAnnouncementBar()) {
        desiredHeight -= nav.bar.heightOfAnnouncementBar();
      }

      $(".slideshow.fill-viewport, .slideshow.fill-viewport .slide").css(
        "min-height",
        desiredHeight
      ); // check for content that must be contained

      $(".slideshow.fill-viewport").each(function () {
        var inner = 0;
        $(this)
          .find(".slide")
          .each(function () {
            var t = 0;
            $(".fill-viewport__contain", this).each(function () {
              t += $(this).outerHeight(true);
            });

            if (inner < t) {
              inner = t;
            }
          });

        if (inner > desiredHeight) {
          $(this).css("min-height", inner);
          $(".slide", this).css("min-height", inner);
        }
      });
      theme.lastViewportWidth = $(window).width(); // bump down any header-overlap areas to cater for announcements

      if (
        $("body.header-section-overlap").length &&
        nav.bar.isAnnouncementBar()
      ) {
        $("#page-content").css("margin-top", nav.bar.heightOfAnnouncementBar());
      } else {
        $("#page-content").css("margin-top", "");
      }
    }); /// Some states are dependent on scroll position

    $(window).on("scroll assessFeatureHeaders", function () {
      var scrollTop = $(window).scrollTop();
      var appearenceBuffer = 60;
      var windowBottom = scrollTop + $(window).height() - appearenceBuffer;
      $("body").toggleClass("scrolled-down", scrollTop > 0);
      theme.assessAltLogo();
      $(".feature-header:not(.feature-header--visible)")
        .filter(function () {
          var offset = $(this).offset().top;
          var height = $(this).outerHeight();
          return offset + height >= scrollTop && offset <= windowBottom;
        })
        .addClass("feature-header--visible");
    });
    $(function () {
      $(window).trigger("slideshowfillheight");
      $(window).trigger("assessFeatureHeaders");
    }); /// Side up and remove

    $.fn.slideUpAndRemove = function () {
      var speed =
        arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
      $(this).each(function () {
        $(this).slideUp(speed, function () {
          $(this).remove();
        });
      });
    }; /// Overlay menu nav

    var previousNavRoutes = ["_root"];

    updateNavCtas = function updateNavCtas() {
      var trimmedTitle = previousNavRoutes[previousNavRoutes.length - 1];
      var $ctasToShow = $(
        '#page-menu .nav-ctas__container[data-for-nav-item="'.concat(
          trimmedTitle,
          '"]:hidden'
        )
      );

      if ($ctasToShow.length > 0) {
        if ($("#page-menu .nav-ctas__container:visible").length) {
          $("#page-menu .nav-ctas__container:visible").fadeOut(
            drilldownTransSpeed,
            function () {
              $ctasToShow.fadeIn(drilldownTransSpeed);
            }
          );
        } else {
          setTimeout(function () {
            $ctasToShow.fadeIn(drilldownTransSpeed);
          }, drilldownTransSpeed);
        }
      } else {
        $("#page-menu .nav-ctas__container:visible").fadeOut(
          drilldownTransSpeed
        );
      }
    }; //Drill down

    var drilldownTransSpeed = 250;
    $(document).on(
      "click",
      "#page-menu.nav-uses-modal .main-nav li.has-children > a",
      function () {
        $(this).next("ul").slideToggle();
        $(this).toggleClass("active_one");
        var trimmedTitle = $(this)
          .text()
          .replace(/^\s\s*/, "")
          .replace(/\s\s*$/, "")
          .toLowerCase();
        previousNavRoutes.push(trimmedTitle); //- Links

        var $content = $('<div class="container growth-area"/>').append(
          $(this)
            .siblings("ul")
            .clone()
            .wrap('<div class="nav-body main-nav growth-area"/>')
            .parent()
        ); //- Title, in its own menu row, using subnav style for the other links

        var $menuList = $content
          .find(".main-nav > ul")
          .wrap("<li/>")
          .parent()
          .wrap("<ul/>")
          .parent();

        if (theme.strings.back.length > 0) {
          $menuList.prepend(
            '<li class="main-nav__back" data-nav-title="'
              .concat(
                trimmedTitle,
                '"><a href="#" data-revert-back><span class="arr arr--left">'
              )
              .concat(theme.icons.chevronLeft, "</span>")
              .concat(theme.strings.back, "</a></li>")
          );
        } //Hide current & show new

        var $containers = $(
          "#page-menu > .inner > .nav-container > .container:not(.inactive)"
        );
        $containers
          .addClass("inactive")
          .fadeOut(drilldownTransSpeed, function () {
            $content.hide().fadeIn(drilldownTransSpeed);
            $content.closest(".theme-modal").focus(); // add focus for keyboard scrolling
          });
        updateNavCtas(); //Hide the footer links

        $("#page-menu > .inner > .nav-container > .nav-footer-links").fadeOut(
          drilldownTransSpeed
        );
        return false;
      }
    ); //Drill back up

    $(document).on(
      "click",
      "#page-menu.nav-uses-modal a[data-revert-back]",
      function () {
        previousNavRoutes.pop();
        updateNavCtas();
        $(
          "#page-menu.nav-uses-modal > .inner > .nav-container > .container:not(.inactive)"
        ).fadeOutAndRemove(drilldownTransSpeed, function () {
          var $menuToShow = $(
            "#page-menu.nav-uses-modal > .inner > .nav-container > .container.inactive:last"
          );
          $menuToShow.removeClass("inactive").fadeIn(drilldownTransSpeed);

          if ($menuToShow.data("root-nav")) {
            $(
              "#page-menu > .inner > .nav-container > .nav-footer-links"
            ).fadeIn(drilldownTransSpeed);
          }
        });
        return false;
      }
    ); //Close and reset nav

    $(document)
      .on("reset-modal", "#page-menu.nav-uses-modal", function () {
        closeThemeModal();
        setTimeout(function () {
          $("#page-menu.nav-uses-modal > .inner > .nav-container > .container")
            .removeClass("inactive")
            .show()
            .slice(1)
            .remove();
        }, 300); // Delay to match transition on .theme-modal.reveal

        return false;
      })
      .on("click", "a[data-reset-and-close]", function () {
        $("#page-menu.nav-uses-modal").trigger("reset-modal");
        return false;
      }); /// Inline nav links
    //Handle expanding nav

    theme.lastHoverInteractionTimestamp = -1;
    $(document).on(
      "click",
      ".multi-level-nav .nav-rows  .contains-children > a",
      function (e) {
        $(this).parent().find("ul:first").slideToggle(300);
        return false;
        
      }
    );
    $(document).on(
      theme.device.isTouch()
        ? "click forceopen forceclose"
        : "forceopen forceclose",
      ".multi-level-nav .contains-mega-menu a.has-children",
      function (e) {
        // skip column headings
        if ($(this).hasClass("column-title")) {
          return true;
        }

        var navAnimSpeed = 200; // check if mouse + click events occurred in same event chain

        var thisInteractionTimestamp = Date.now();

        if (
          e.type == "click" &&
          thisInteractionTimestamp - theme.lastHoverInteractionTimestamp < 500
        ) {
          return false;
        }

        if (e.type == "forceopen" || e.type == "forceclose") {
          theme.lastHoverInteractionTimestamp = thisInteractionTimestamp;
        } //Set some useful vars

        var $tierEl = $(this).closest('[class^="tier-"]');
        var $tierCont = $tierEl.parent();
        var targetTierNum = parseInt($tierEl.attr("class").split("-")[1]) + 1;
        var targetTierClass = "tier-" + targetTierNum; ///Remove nav for all tiers higher than this one (unless we're opening on same level on hover)

        if (e.type != "forceopen") {
          $tierCont.children().each(function () {
            if (
              parseInt($(this).attr("class").split("-")[1]) >= targetTierNum
            ) {
              if (e.type == "forceclose") {
                $(this).removeClass("tier-appeared");
                var $this = $(this);
                theme.hoverRemoveTierTimeoutId = setTimeout(function () {
                  $this.remove();
                }, 260);
              } else {
                $(this).slideUpAndRemove(navAnimSpeed);
              }
            }
          });
        } //Are we expanding or collapsing

        if ($(this).hasClass("expanded") && e.type != "forceopen") {
          //Collapsing. Reset state
          $(this)
            .removeClass("expanded")
            .removeAttr("aria-expanded")
            .removeAttr("aria-controls");
        } else {
          ///Show nav
          //Reset other nav items at this level
          $tierEl
            .find("a.expanded")
            .removeClass("expanded")
            .removeAttr("aria-expanded");
          clearTimeout(theme.hoverRemoveTierTimeoutId); //If next tier div doesn't exist, make it

          var $targetTierEl = $tierCont.children("." + targetTierClass);

          if ($targetTierEl.length == 0) {
            $targetTierEl = $("<div />")
              .addClass(targetTierClass)
              .attr("id", "menu-" + targetTierClass)
              .appendTo($tierCont);

            if (navAnimSpeed > 0) {
              // new tier, start at 0 height
              $targetTierEl.css("height", "0px");
            }
          } else {
            if (navAnimSpeed > 0) {
              // tier exists, fix its height before replacing contents
              $targetTierEl.css("height", $targetTierEl.height() + "px");
            }
          } // populate new tier

          $targetTierEl
            .empty()
            .stop(true, false)
            .append($(this).siblings("ul").clone().attr("style", ""));

          if (navAnimSpeed > 0) {
            // transition to correct height, then clear height css
            $targetTierEl.animate(
              {
                height: $targetTierEl.children().outerHeight(),
              },
              navAnimSpeed,
              function () {
                $(this).css("height", "");
              }
            );
          } // add class after reflow, for any transitions

          setTimeout(function () {
            $targetTierEl.addClass("tier-appeared");
            var getPopup = document.querySelector('.popupSubscribe');
            getPopup.classList.remove('visiblePopup')
          }, 10); //Mark as expanded

          $(this)
            .addClass("expanded")
            .attr("aria-expanded", "true")
            .attr("aria-controls", "menu-" + targetTierClass);
          $("body").addClass("nav-mega-open");
        }

        return false;
      }
    );

    /// Closing megamenu, mega-menu, menu nav, mega-nav on hover
    theme.closeOpenMenuItem = function () {
      $("body").removeClass("nav-mega-open");
      $(".multi-level-nav.reveal-on-hover .has-children.expanded").trigger(
        "forceclose"
      );
    };

    $(document).on(
      "mouseenter mouseleave",
      ".multi-level-nav.reveal-on-hover .tier-1 .contains-mega-menu",
      function (e) {
        if (theme.viewport.isSm()) {
          clearTimeout(theme.closeOpenMenuItemTimeoutId);

          if (e.type == "mouseenter") {
            $(this).children("a").trigger("forceopen");
          } else {
            theme.closeOpenMenuItemTimeoutId = setTimeout(
              theme.closeOpenMenuItem,
              200
            );
          }
        }
      }
    );

    $(document).on(
      "mouseleave",
      ".multi-level-nav.reveal-on-hover .tier-appeared",
      function (e) {
        if (theme.viewport.isSm()) {
          clearTimeout(theme.closeOpenMenuItemTimeoutId);
          theme.closeOpenMenuItemTimeoutId = setTimeout(
            theme.closeOpenMenuItem,
            50
          );
        }
      }
    );
    $(document).on(
      "mouseenter",
      ".multi-level-nav.reveal-on-hover .tier-2, .multi-level-nav.reveal-on-hover .tier-3",
      function (e) {
        if (theme.viewport.isSm()) {
          clearTimeout(theme.closeOpenMenuItemTimeoutId);
        }
      }
    );

    function isPageScrollin() {
      return $("#page-content").outerHeight() > $(window).height();
    } /// Modal windows

    var removeModalTimeoutID = -1;
    var closeModalDelay = 300;

    window.closeThemeModal = function (immediate) {
      $("[data-modal-toggle].active").removeClass("active");
      var $modal = $(".theme-modal.reveal")
        .removeClass("reveal")
        .addClass("unreveal");

      if (!$("body").hasClass("modal-active--prevent-close")) {
        $("body").addClass("modal-closing");
      }

      if (
        $("html.supports-transforms").length &&
        (typeof immediate == "undefined" || !immediate)
      ) {
        removeModalTimeoutID = setTimeout(function () {
          $("body")
            .removeClass("modal-active")
            .removeClass("modal-active--show-close-bg")
            .removeClass("modal-active--prevent-close");
          $("body, #page-content, #site-control").css("padding-right", "");
        }, closeModalDelay); // Delay to match transition on .theme-modal.reveal
      } else {
        $("body")
          .removeClass("modal-active")
          .removeClass("modal-active--show-close-bg");
        $("body, #site-control").css("padding-right", "");
      } // tabindex

      $modal.find("a").attr("tabindex", "-1");

      if (immediate) {
        $("body").removeAttr("data-modal-id");
      } else {
        setTimeout(function () {
          $("body").removeAttr("data-modal-id");
        }, 200);
      }

      setTimeout(function () {
        $("body").removeClass("modal-closing");
      }, 300);
      $("#search-modal").removeClass("-in");
    }; //Show arbitrary content in modal window

    window.showThemeModal = function (
      el,
      id,
      callbackFn,
      showCloseBackground,
      preventCloseButton
    ) {
      //Close current
      closeThemeModal(true); //Remove any existing temporary modals

      $(".theme-modal.temp").remove();
      theme.Nav().bar.hide(false); //Actually add to the page

      var $el = $(el);
      $el.appendTo("body");
      setTimeout(function () {
        $el.addClass("reveal");
      }, 10);
      theme.addControlPaddingToModal(); //When body is under a modal & has scrollbar, it is not allowed to scroll,
      //so we overflow:hidden it and add a padding the same size as the scrollbar

      if (isPageScrollin()) {
        $("#page-content, #site-control").css(
          "padding-right",
          $.scrollBarWidth()
        );
      } //Set page state

      $("body").addClass("modal-active");

      if (showCloseBackground) {
        $("body").addClass("modal-active--show-close-bg");
      }

      if (preventCloseButton) {
        $("body").addClass("modal-active--prevent-close");
      } else {
        $("body").addClass("modal-opening");
      }

      if (id) {
        $("body").attr("data-modal-id", id);
      }

      if ($(".theme-modal:visible [data-modal-close]").length) {
        setTimeout(function () {
          $(".theme-modal:visible [data-modal-close]").focus();
        }, 100);
      }

      setTimeout(function () {
        $("body").removeClass("modal-opening");
      }, 300);

      if (callbackFn) {
        callbackFn($el);
      }
    }; //Show existing modal container hidden on page

    window.showInPageModal = function ($target) {
      $target.removeClass("unreveal").addClass("reveal");
      theme.addControlPaddingToModal();
      var $inputs = $target.find(".focus-me"); //Any inputs to highlight?

      $(this).addClass("active"); //When body is under a modal, it is not allowed to scroll, so we need this to keep it the same width

      if (isPageScrollin()) {
        $("body, #site-control").css("padding-right", $.scrollBarWidth());
      }

      $("body")
        .addClass("modal-active  modal-opening")
        .attr("data-modal-id", $target.attr("id"));
      $("a[tabindex]", $target).removeAttr("tabindex");

      if ($inputs.length == 0) {
        $target.closest(".theme-modal").focus(); // add focus for keyboard scrolling
      } else {
        if (theme.viewport.isSm()) {
          $inputs.focus();
        }
      }

      if ($target.attr("id") === "search-modal") {
        setTimeout(function () {
          $("#search-modal").addClass("-in");
        }, 400);
      }

      if ($target.attr("id") === "page-menu") {
        document.dispatchEvent(new CustomEvent('menu:open', {
          bubbles: true
        }));
      }

      setTimeout(function () {
        $("body").removeClass("modal-opening");
      }, 400);
    };

    $(document).on(
      "click",
      "body:not(.modal-active) [data-modal-toggle]",
      function (e) {
        e.preventDefault();
        window.showInPageModal($($(this).data("modal-toggle")));

        document.dispatchEvent(new CustomEvent('search:open', {
            bubbles: true
        }));

        let openMenu = document.querySelector('.headerLinks[aria-expanded="true"]');
        if(openMenu){
          openMenu.setAttribute('aria-expanded', 'false');
        }
        
        setProperty();
      }
      
    ); //Close modal on escape keypress

    // Click-only dropdowns (subscribe + market): open on click, not hover
    $(document).on("click", ".dropdown--click-only .subscribe-btn, .dropdown--click-only .dropdown--deskButton", function (e) {
      e.stopPropagation();
      var $dropdown = $(this).closest(".dropdown--click-only");
      var isOpen = $dropdown.hasClass("is-open");
      $(".dropdown--click-only").removeClass("is-open").find("[aria-expanded]").attr("aria-expanded", "false");
      if (!isOpen) {
        $dropdown.addClass("is-open");
        $dropdown.find(".subscribe-btn, .dropdown--deskButton").attr("aria-expanded", "true");
      }
      return false;
    });
    $(document).on("click", ".dropdown--click-only .dropdown-content", function (e) {
      e.stopPropagation();
    });
    $(document).on("click", function (e) {
      // Only close if click is outside the dropdown
      if (!$(e.target).closest(".dropdown--click-only").length) {
        $(".dropdown--click-only").removeClass("is-open").find("[aria-expanded]").attr("aria-expanded", "false");
      }
    });

    $(document).on("keyup", function (e) {
      if (e.which == 27) {
        closeThemeModal();
      }
    }); //Close modal button

    $(document).on(
      "click",
      "body.modal-active a[data-modal-close]",
      function () {
        closeThemeModal();
        return false;
      }
    ); //Click outside container to close modal

    $(document).on("click", ".theme-modal", function (e) {
      if (e.target == this) {
        closeThemeModal(); //Trigger any reset events (e.g. in drilldown nav)

        $(this).trigger("reset-modal");
        return false;
      }
    }); //Switch to a different modal

    $(document).on(
      "click",
      "body.modal-active [data-modal-toggle]",
      function () {
        var toggleTarget = $(this).data("modal-toggle");
        var currentModalId = $("body").attr("data-modal-id");
        var isSameModal = (toggleTarget === "#" + currentModalId || String(toggleTarget).replace("#", "") === currentModalId);
        if (isSameModal) {
          closeThemeModal(true);
          return false;
        }
        closeThemeModal(true);
        $(this).click();
        return false;
      }
    );
    $(document).on(
      "click",
      ".site-control a[data-modal-nav-toggle]",
      function () {
        // Check if page-menu is already open
        var isPageMenuOpen = $("body").attr("data-modal-id") === "page-menu" || $("#page-menu").hasClass("reveal");
        
        if (isPageMenuOpen) {
          // If page-menu is open, just close it
          closeThemeModal(true);
        } else if ($("body.modal-active").length) {
          // If another modal is open, close it first, then open menu
          closeThemeModal(true);
          setTimeout(function () {
            window.showInPageModal($("#page-menu"));
          }, 305); // after modal fade-out
        } else {
          // No modal is open, just open the menu
          window.showInPageModal($("#page-menu"));
        }

        return false;
      }
    ); //Open arbitrary page in a modal

    $(document).on("click", "a[data-modal-target]", function (e) {
      e.preventDefault();
      showThemeModal(
        $(
          '<div class="theme-modal temp" role="dialog" aria-modal="true"/>'
        ).append(
          $('<div class="inner"/>').html(
            $($(this).data("modal-target"))
              .wrapInner('<div class="container"/>')
              .html()
          )
        )
      );
    }); //Immmediately select contents when focussing on some inputs

    $(document)
      .on("focusin click", "input.select-on-focus", function () {
        $(this).select();
      })
      .on("mouseup", "input.select-on-focus", function (e) {
        e.preventDefault(); //Prevent mouseup killing select()
      }); //Textareas increase size as you type

    $("#template textarea").each(function () {
      $(this).autogrow({
        animate: false,
        onInitialize: true,
      });
    });
    $(document).on("click", ".quantity-wrapper [data-quantity]", function () {
      var adj = $(this).data("quantity") == "up" ? 1 : -1;
      var $qty = $(this).closest(".quantity-wrapper").find("[name=quantity]");
      $qty.val(Math.max(1, parseInt($qty.val()) + adj));
      return false;
    }); /// Redirection dropdowns

    $(document).on("change", "select.redirecter", function () {
      window.location = $(this).val();
    });

    theme.getUrlParameter = function (name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }; /// Scroll to the newsletter when necessary

    var formType = theme.getUrlParameter("form_type");

    if (
      theme.getUrlParameter("customer_posted") ||
      (formType && formType === "customer")
    ) {
      if ($("#footer_newsletter_signup").length) {
        setTimeout(function () {
          $("html,body").animate(
            {
              scrollTop: $("#footer_newsletter_signup").offset().top - 100,
            },
            1000
          );
        }, 100);
      }
    } /// Detect android for 100vh fix

    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      $("html").addClass("os-android");
    } /// Bind checkout button clicks

    $(document).on("click", "[data-cc-checkout-button]", function (e) {
      if ($("#cc-checkout-form").length) {
        $("#cc-checkout-form").submit();
        return false;
      } else {
        console.warn("Unable to find form with id cc-checkout-form");
      }
    }); /// Bind pseudo-page-to-page animation event

    $(document).on("click", "[data-cc-animate-click]", function (e) {
      if (theme.settings.animationEnabledDesktop) {
        if (
          (window.location.hostname === this.hostname ||
            !this.hostname.length) &&
          $(this).attr("href").length > 0 &&
          $(this).attr("href") !== "#"
        ) {
          e.preventDefault();
          $("#cc-veil").addClass("-in");
          var url = $(this).attr("href");
          $("body").append('<link rel="prefetch" href="'.concat(url, '">'));
          setTimeout(function () {
            window.location.href = url;
          }, 200);
          setTimeout(function () {
            //Remove the veil after a few second just in case
            $("#cc-veil").removeClass("-in");
          }, 8000);
          return false;
        }
      }
    });

    theme.updateBodyPadding();
    $(window).on(
      "debouncedresizewidth.updateBodyPadding",
      theme.updateBodyPadding
    ); // Process lazy loaded images on page load

    setTimeout(lazySizes.autoSizer.checkElems, 1000); /// Watch for tabbing

    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        // 9 == tab
        $("body").addClass("user-is-tabbing");
        window.removeEventListener("keydown", handleFirstTab);
      }
    }

    window.addEventListener("keydown", handleFirstTab); //Hide the footer on the challenge page

    if (
      window.location.href.indexOf("/challenge") > 0 &&
      window.location.href.indexOf("/pages") === -1
    ) {
      document.getElementById("shopify-section-footer").style.display = "none";
    }

    if (theme.device.isTouch()) {
      document.getElementsByTagName("html")[0].classList.add("touch");
    }

    var deferredLoadViewportExcess = 1200; /// Register all sections

    theme.Sections.init();
    theme.Sections.register("header", theme.HeaderSection, {
      deferredLoad: false,
    });
    theme.Sections.register("footer", theme.FooterSection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("slideshow", theme.SlideshowSection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("video", theme.VideoManager, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("background-video", theme.VideoManager, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register(
      "image-with-text-overlay",
      theme.ImageWithTextOverlay,
      {
        deferredLoadViewportExcess: deferredLoadViewportExcess,
      }
    );
    theme.Sections.register(
      "image-beside-image",
      theme.ImageBesideImageSection,
      {
        deferredLoadViewportExcess: deferredLoadViewportExcess,
      }
    );
    theme.Sections.register(
      "featured-collection",
      theme.FeaturedCollectionSection,
      {
        deferredLoadViewportExcess: deferredLoadViewportExcess,
      }
    );
    theme.Sections.register("collection-list", theme.CollectionListSection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("featured-blog", theme.FeaturedBlogSection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("product-template", theme.ProductTemplateSection, {
      deferredLoadViewportExcess: 200,
    });
    theme.Sections.register(
      "collection-template",
      theme.CollectionTemplateSection,
      {
        deferredLoad: false,
      }
    );
    theme.Sections.register("search-template", theme.SearchTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register("blog-template", theme.BlogTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register("article-template", theme.ArticleTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register("list-collections", theme.ListCollectionsSection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("cart-template", theme.CartTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register(
      "product-recommendations",
      theme.ProductRecommendations,
      {
        deferredLoadViewportExcess: deferredLoadViewportExcess,
      }
    );
    theme.Sections.register("gallery", theme.GallerySection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
    theme.Sections.register("testimonials", theme.TestimonialsSection, {
      deferredLoadViewportExcess: deferredLoadViewportExcess,
    });
  }); //Register dynamically pulled in sections

  $(function ($) {
    if (cc.sections.length) {
      cc.sections.forEach(function (section) {
        try {
          theme.Sections.register(section.name, section.section);
        } catch (err) {
          console.error(
            "Unable to register section ".concat(section.name, "."),
            err
          );
        }
      });
    } else {
      console.warn("Barry: No common sections have been registered.");
    }
  });
})(theme.jQuery);

$(document).ready(function () {
  if (window.location.href.indexOf("eu.") > -1) {
    var changed = sessionStorage.getItem("changed");

    if (changed == null) {
      var z = JSON.parse(localStorage.getItem("el-geoip-location"));
      var x = z.value.country.iso_code;
      var selectorEl = document.querySelector(".CurrencySelector__Select");
      if (x == "DK" && selectorEl.value != "DKK") {
        selectorEl.value = "DKK";
        selectorEl.dispatchEvent(new Event("change"));
        sessionStorage.setItem("changed", true);
      } else if (x == "CH" && selectorEl.value != "CHF") {
        selectorEl.value = "CHF";
        selectorEl.dispatchEvent(new Event("change"));
        sessionStorage.setItem("changed", true);
      }
    }
    setTimeout(() => {
      var countriesEU =
        "AT,BE,BG,HR,CY,CZ,EE,FI,FR,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,CH,DK,DE,NO,CA,UK,GB,GBP";
      var z = JSON.parse(localStorage.getItem("el-geoip-location"));

      var x = z.value.country.iso_code;
      var country = z.value.country.names.en;

      if (x == "HK") {
        $(".cc-announcement__text").html("Express shipping to Hong Kong");
      } else if (countriesEU.includes(x)) {
        $(".cc-announcement__text").html(
          "Free delivery to " + country + " | Easy returns"
        );
      } else {
        $(".cc-announcement__text").html("Worldwide shipping | Easy returns");
      }
    }, 300);
  }
});


function submitInfo() {
  event.preventDefault();

  var g = $('#cc-popup :input[name="g"]').val();
  var mail = $('#cc-popup :input[name="email"]').val();
  var settings = {
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    },
    data: {
      g: g,
      email: mail,
      $source: "BlackPopup",
    },
  };

  $.ajax(settings).done(function (response) {
    $("#cc-popup").html(
      '<div class="rte u-p7">' + window.theme.strings.formThankYou + "</div>"
    );
  });
}

function submitInfo2() {
  event.preventDefault();
  var g = $('#cc-popup-footer :input[name="g"]').val();
  var mail = $('#cc-popup-footer :input[name="email"]').val();
  var settings = {
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
    },
    data: {
      g: g,
      email: mail,
      $source: "FooterNewsletter",
    },
  };

  $.ajax(settings).done(function (response) {
    $("#cc-popup-footer").html(
      '<div class="rte u-p7 footer_msg">' +
        window.theme.strings.popup_success +
        "</div>"
    );
  });

  $.ajax(settings).done(function (response) {
    $("#cc-popup-footer").html(
      '<div class="rte u-p7 footer_msg">' +
        window.theme.strings.popup_success +
        "</div>"
    );
  });
}

$(".product-custom-template-main").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,

  asNavFor: ".product-custom-template-thumbs",
  responsive: [
    {
      breakpoint: 750,
      settings: {
        adaptiveHeight: false,
        dots: true,
        infinite: true
      },
    },
  ],
});

$(".template-suffix-default_50 .product-custom-template-thumbs").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: true,
  infinite: false,
  arrows: true,
  verticalSwiping: true,
  asNavFor: ".product-custom-template-main",
  dots: false,
  centerMode: true,
  adaptiveHeight: false,
  focusOnSelect: true,
  centerPadding: "16px",
  prevArrow:
    '<button class="slick-prev"><svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_262_18708)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 13.2043L12.0341 19.7437L12.0237 19.7495C11.6724 19.9447 11.2609 19.9447 10.9095 19.7495L10.9012 19.7448L0.0595703 13.3066L0.74037 12.1602L11.4658 18.5294L22.189 12.0625L22.8776 13.2043Z" fill="black"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 6.60417L12.0341 13.1436L12.0237 13.1494C11.6724 13.3446 11.2609 13.3446 10.9095 13.1494L10.9012 13.1447L0.0595703 6.7065L0.74037 5.56008L11.4658 11.9293L22.189 5.4624L22.8776 6.60417Z" fill="black"/> </g> <defs> <clipPath id="clip0_262_18708"> <rect width="22.9333" height="20" fill="white"/> </clipPath> </defs> </svg></button>',
  nextArrow:
    '<button class="slick-next"><svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_262_18708)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 13.2043L12.0341 19.7437L12.0237 19.7495C11.6724 19.9447 11.2609 19.9447 10.9095 19.7495L10.9012 19.7448L0.0595703 13.3066L0.74037 12.1602L11.4658 18.5294L22.189 12.0625L22.8776 13.2043Z" fill="black"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 6.60417L12.0341 13.1436L12.0237 13.1494C11.6724 13.3446 11.2609 13.3446 10.9095 13.1494L10.9012 13.1447L0.0595703 6.7065L0.74037 5.56008L11.4658 11.9293L22.189 5.4624L22.8776 6.60417Z" fill="black"/> </g> <defs> <clipPath id="clip0_262_18708"> <rect width="22.9333" height="20" fill="white"/> </clipPath> </defs> </svg></button>',
});

$(".template-suffix-default_75 .product-custom-template-thumbs").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  vertical: true,
  infinite: false,
  arrows: true,
  verticalSwiping: true,
  asNavFor: ".product-custom-template-main",
  dots: false,
  centerMode: true,
  adaptiveHeight: false,
  focusOnSelect: true,
  centerPadding: "16px",
  prevArrow:
    '<button class="slick-prev"><svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_262_18708)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 13.2043L12.0341 19.7437L12.0237 19.7495C11.6724 19.9447 11.2609 19.9447 10.9095 19.7495L10.9012 19.7448L0.0595703 13.3066L0.74037 12.1602L11.4658 18.5294L22.189 12.0625L22.8776 13.2043Z" fill="black"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 6.60417L12.0341 13.1436L12.0237 13.1494C11.6724 13.3446 11.2609 13.3446 10.9095 13.1494L10.9012 13.1447L0.0595703 6.7065L0.74037 5.56008L11.4658 11.9293L22.189 5.4624L22.8776 6.60417Z" fill="black"/> </g> <defs> <clipPath id="clip0_262_18708"> <rect width="22.9333" height="20" fill="white"/> </clipPath> </defs> </svg></button>',
  nextArrow:
    '<button class="slick-next"><svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_262_18708)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 13.2043L12.0341 19.7437L12.0237 19.7495C11.6724 19.9447 11.2609 19.9447 10.9095 19.7495L10.9012 19.7448L0.0595703 13.3066L0.74037 12.1602L11.4658 18.5294L22.189 12.0625L22.8776 13.2043Z" fill="black"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8776 6.60417L12.0341 13.1436L12.0237 13.1494C11.6724 13.3446 11.2609 13.3446 10.9095 13.1494L10.9012 13.1447L0.0595703 6.7065L0.74037 5.56008L11.4658 11.9293L22.189 5.4624L22.8776 6.60417Z" fill="black"/> </g> <defs> <clipPath id="clip0_262_18708"> <rect width="22.9333" height="20" fill="white"/> </clipPath> </defs> </svg></button>',
});

const slickTrack = document.querySelectorAll('.slick--item');
if(slickTrack.length > 1){
  slickTrack[0].style.display = 'none';
}

var scrollCount = null;
var scroll= null;
$(".product-custom-template-thumbs").on("wheel", function (e) {
  e.preventDefault();
  clearTimeout(scroll);
  scroll = setTimeout(function(){scrollCount=0;}, 200);
  if(scrollCount) return 0;
  scrollCount=1;

  // Popravka za touchpad: Provera da li postoji deltaY, a ako ne, koristi wheelDelta
  const deltaY = e.originalEvent.deltaY || -e.originalEvent.wheelDelta;

  if (deltaY > 0) {
    $(this).slick("slickNext");
    slickTrack[0].style.display = 'block';
    $(this).slick("slickNext");
  } else {
    $(this).slick("slickPrev");
  }

});

$(".product-custom-template-main").on("beforeChange", function (){
  slickTrack[0].style.display = 'block';
})

$(".product-template-custom .size_guide h3").click(function () {
  $(this).toggleClass("active_h3");
  $(this).next().slideToggle();
});

$(".accordions h4").click(function () {
  $(this).toggleClass("active_tab");
  $(this).next().slideToggle();
  $(this).parent(".accordions").siblings(".accordions").find("div").slideUp();
});

$(".product-template-custom .Select-size input").click(function () {
  $(".Select-size").slideUp();
});

$(".all-variatns  option").each(function () {
  let _this = $(this),
    val = _this.data("variant-available"),
    title = _this.data("title");
  $(".Select-size input").each(function () {
    let _thisInput = $(this),
      valInput = _thisInput.data("title");
    if (valInput == title) {
      _thisInput.parent("li").addClass(val);

      if (val == 'not-avaliable'){
        $('.product-add-to-cart').remove();
      }
    }
  });
});

if ($(window).width() > 1300) {
  $(window).on("load", function () {
    let he = $(
      ".template-suffix-default_50 .product-custom-template-thumbs "
    ).height();
    let jd = $(
      ".template-suffix-default_50 .product-custom-template-main .slick-slide:first-child  "
    ).height();
    if (he > jd) {
      $(
        ".template-suffix-default_50 .product-custom-template-main img,.template-suffix-default_50 .product-custom-template-main video"
      ).css("height", he - 8);
    }
  });
}

if ($(window).width() > 1024) {
  $("ul.variants-items div input").click(function () {
    $(this).parent("li").hide().siblings().show();
    $(this)
      .parent("li")
      .addClass("selected--size")
      .siblings()
      .removeClass("selected--size");

    $(".size-header span.box_-number").text(
      $(this).parent("li").find(".box_-number").text()
    );
   

  });
  $(
    ".product-template-custom .colour-header:not(.header--blank),.product-template-custom .size-header"
  ).click(function () {
    $(this).toggleClass("active_h3");
    $(this).parents("ul").toggleClass("active--container");
    $(this).next().slideToggle();
  });
} else {
  $(".section-gallery.home-section-gallery .cc-gallery .gallery__row").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    adaptiveHeight: true
  });

  $(".product--mobile-details").fadeIn();

  $(".var--overlays").click(function () {
    $(".Select--colour,.Select-size").fadeOut();
    $("body").removeClass("active-colour");
    $("body").removeClass("activeBody");
  });
  var html = $(".size_guide").html();
  $(".mobile-size-guide").html(html);
  $(".product-template-custom .mobile-size-guide h3").click(function () {
    $(this).toggleClass("active_h3");
    $(this).next().slideToggle();
  });

  $(".product--mobile-details ul.color-options--item").click(function () {
    console.log('click test')
    $(".Select--colour").fadeIn();
    $("body").addClass("active-colour");
  });
  $(".Select--colour h2").click(function () {
    $(".Select--colour").fadeOut();
    $("body").removeClass("active-colour");
  });
  $("ul.variants-items .size-header").click(function () {
    $(".Select-size").fadeIn();
    $("body").addClass("active-colour");
  });
  $(".Select-size h2,ul.variants-items div input").click(function () {
    $(".Select-size").fadeOut();
    $("body").removeClass("active-colour");
    $("body").removeClass("activeBody");
  });
}

$(".available").click(function(){
  $('.notifyInputFieldWrapper').removeClass('showNotify');
})

$(".product-custom-template-main").on(
  "afterChange",
  function (event, currentSlide) {
    let index = currentSlide.currentSlide;

    $(".product-custom-template-main  .product-media").each(function (event) {
      let _this = $(this),
        index2 = _this.attr("data-slick-index");
      if (index2 == index) {
        _this.siblings().find("video").trigger("pause");

        if (_this.hasClass("product-media--video")) {
          $(".product-custom-template-left").addClass("dots-static");
          _this.find("video").trigger("play");

          $(".product-custom-template-main  iframe").each(function (event) {
            var sdff = $(this).attr("src");

            $(this).attr("src", sdff.replace("&autoplay=1", ""));
            $(this).attr("src", sdff.replace("&autoplay=1&autoplay=1", ""));
            $(this).attr("src", sdff.replace("&autoplay=1", ""));
          });
        }
        if (_this.hasClass("product-media--image")) {
          $(".product-custom-template-left").removeClass("dots-static");
          $(".product-custom-template-main  iframe").each(function (event) {
            var sdff = $(this).attr("src");

            $(this).attr("src", sdff.replace("&autoplay=1", ""));
            $(this).attr("src", sdff.replace("&autoplay=1&autoplay=1", ""));
            $(this).attr("src", sdff.replace("&autoplay=1", ""));
          });
          $(".product-custom-template-main  video").each(function (event) {
            $(this).trigger("pause");
          });
        }
        if (_this.hasClass("product-media--external-video")) {
          $(".product-custom-template-main  video").each(function (event) {
            $(this).trigger("pause");
          });
          $(".product-custom-template-left").addClass("dots-static");
          var sdff = _this.find("iframe").attr("src") + "&autoplay=1";
          _this.find("iframe").attr("src", sdff);
        }
      }
    });
  }
);

$(window).resize(function () {
  let height = 0;
 
  $(".home-blocks-section > div").each(function () {
    let _this = $(this);
    height += _this.outerHeight();
  });
  //$(".home-blocks-section").height(height);
});

//document
  // .querySelector(".klaviyo_form_trigger")
  // .addEventListener("click", function () {
  //   var form = this.getAttribute("data-form");
  //   console.log("here");
  //   var _klOnsite = window._klOnsite || [];
  //   _klOnsite.openForm(form, () => console.log("you triggered the form!"));
  // });

// document
//   .querySelector(".klaviyo_form_trigger-mob")
//   .addEventListener("click", function () {
//     console.log("you triggered the form!")
//     var form = this.getAttribute("data-form");

//     var _klOnsite = window._klOnsite || [];
//     _klOnsite.openForm(form, () => console.log("you triggered the form!"));
//   });

// $(document).ready(function () {
//   $(".HomeBlock-Wrapper").each(function () {
//     let height = 0;
//     let _this1 = $(this);
//     $("[data-height]", _this1).each(function () {
//       let _this = $(this);
//       height += _this.outerHeight();
//     });
//     _this1.height(height);
//     setTimeout(() => {
//       document.body.querySelector(".pageOverlay").classList.remove("isvisible");
//     }, "100");
//   });

//   $(window).scroll(function () {
//     $(".HomeBlock-Wrapper").each(function () {
//       let height = 0;
//       let _this1 = $(this);
//       $("[data-height]", _this1).each(function () {
//         let _this = $(this);
//         height += _this.outerHeight();
//       });
//       _this1.height(height);
//       setTimeout(() => {
//         document.body
//           .querySelector(".pageOverlay")
//           .classList.remove("isvisible");
//       }, "100");
//     });
//   });
// });

// $(window).resize(function () {
//   $(".HomeBlock-Wrapper").each(function () {
//     let height = 0;
//     let _this1 = $(this);
//     $("[data-height]", _this1).each(function () {
//       let _this = $(this);
//       height += _this.outerHeight();
//     });
//     _this1.height(height);
//     setTimeout(() => {
//       document.body.querySelector(".pageOverlay").classList.remove("isvisible");
//     }, "100");
//   });
// });

$(document).ready(function () {
  // Funkcija za podešavanje visine elemenata
  function setBlockHeights() {
    $(".HomeBlock-Wrapper").each(function () {
      let height = 0;
      let _this1 = $(this);

      // Računanje ukupne visine elemenata sa data-height atributom
      $("[data-height]", _this1).each(function () {
        height += $(this).outerHeight();
      });

      // Postavljanje visine HomeBlock-Wrapper elementa
      _this1.css('height', height + 'px');
    });

    // Uklanjanje klase isvisible sa pageOverlay koristeći requestAnimationFrame
    requestAnimationFrame(() => {
      document.body.querySelector(".pageOverlay").classList.remove("isvisible");
    });
  }

  // Pozivanje funkcije pri učitavanju stranice
  $(window).on('load', function () {
    setBlockHeights();
  });

  // Pozivanje funkcije pri promeni veličine prozora
  $(window).resize(function () {
    setBlockHeights();
  });

  // Pratimo promene u DOM-u koje mogu uticati na visinu
  const observer = new MutationObserver(() => {
    setBlockHeights();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// document
//   .querySelector(".klaviyo_form_trigger")
//   .addEventListener("click", function () {
//     var form = this.getAttribute("data-form");
//     console.log("here");
//     var _klOnsite = window._klOnsite || [];
//     _klOnsite.openForm(form, () => console.log("you triggered the form!"));
//   });

// document
//   .querySelector(".klaviyo_form_trigger-mob")
//   .addEventListener("click", function () {
//     var form = this.getAttribute("data-form");

//     var _klOnsite = window._klOnsite || [];
//     _klOnsite.openForm(form, () => console.log("you triggered the form!"));
//   });

let addToCartClickedWithoutVariant = false;
$(".product-add-to-cart-id").click(function (e) {
  const variantSelected = $("ul.variants-items div input:checked").length > 0;
  if (variantSelected == false) {
    e.preventDefault();
    addToCartClickedWithoutVariant = true;
  }
})


$("ul.variants-items div input").click(function () {
  $("li.size-header span:nth-child(2)").text("Selected");
  $("li.size-header span:nth-child(3)").text($(this).data("title"));

  var selectedOptions = "";
  $("ul.variants-items div input:checked").each(function (i) {
    if (selectedOptions == "") {
      selectedOptions = $(this).data("title");
    } else {
      selectedOptions = selectedOptions + " / " + $(this).data("title");
    }
  });
  $(".all-variatns option").each(function () {
    let _this = $(this),
      title = _this.data("title");
    if (title == selectedOptions) {
      _this
        .attr("selected", "selected")
        .siblings()
        .removeAttr("selected", "selected");
      _this.prop("selected", true).siblings().prop("selected", false);

      if(_this.data('variant-available') === 'not-available'){

            $('.product-add-to-cart-id').hide();
          
        
        $('.product-add-to-notify-id').show();
        $('ul.variants-items li').css('color', '#bfbfbf');
        $('ul.color-options li').css('color', '#bfbfbf');
        $('.detailesInner path').css('fill', '#bfbfbf');
        $('.color-options path').css('fill', '#bfbfbf');
        $('.variants-items path').css('fill', '#bfbfbf');
        $('span.box_-number').css('border-color', '#bfbfbf');
        $('span.box_-number').css('color', '#bfbfbf');
        $('span.box_-number').css('background', 'linear-gradient(to right top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) calc(50% - 0.8px), rgb(0 0 0 / 31%) 50%, rgba(0, 0, 0, 0) calc(50% + 0.8px), rgba(0, 0, 0, 0) 100%)');
        $('.color-options li.colour-header span:first-child').css('opacity','.3');
        $('.notifyHandlerInput').attr('data-var-id', _this.data('id'));
      } else {
        $('.product-add-to-cart-id').show();
        $('.product-add-to-notify-id').hide();
        $('ul.variants-items li').css('color', 'black');
        $('ul.color-options li').css('color', 'black');
        $('.detailesInner path').css('fill', 'black');
        $('.color-options path').css('fill', 'black');
        $('.variants-items path').css('fill', 'black');
        $('span.box_-number').css('border-color', 'black');
        $('span.box_-number').css('color', 'black');
        $('span.box_-number').css('background', '');
        $('.color-options li.colour-header span:first-child').css('opacity','1');
        
          if (addToCartClickedWithoutVariant) {
            $('.product-add-to-cart-id').click();
            addToCartClickedWithoutVariant = false; 
          }
  


      }
    }
  });
});

const validateEmail = (email) => {
  return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};





$('.notifyInputField input').on('input',  function() {
  const email = $(this).val();

  if (validateEmail(email)) {

    $('[data-action="sendKlaviyoNotify"]').show();
    $('.notifyHandlerInput').css('border-right','0px');
  } else {
    $('[data-action="sendKlaviyoNotify"]').hide();
    $('.notifyHandlerInput').css('border-right','1px solid #bfbfbf');
  }
  return false;


});
$('[data-action="open-notify"]').click(function () {
$('.notifyInputFieldWrapper').addClass('showNotify');
$('.notifyHandlerInput').focus();
    
    const width = $(window).width();
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
      ? true
      : width < 1025;

      if(!isMobile){
    $('.product-add-to-notify-id').hide();}
  });

  $('[data-action="sendKlaviyoNotify"]').click(function () {
   
    var _thisP = $(this).parent();
    var email = $('.notifyHandlerInput', _thisP).val();
    var variant = "$shopify:::$default:::" + $('.notifyHandlerInput', _thisP).data('var-id');
    var klaviyo_data =  
    {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          },
          channels: [
            "EMAIL"
          ]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: variant
            }
          }
        }
      }
    };
   
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=" +  window.theme.klaviyoAPI,
      beforeSend: function(request) {
        request.setRequestHeader('accept', 'application/vnd.api+json');
        request.setRequestHeader('content-type', 'application/vnd.api+json');
        request.setRequestHeader('revision', '2024-10-15');
      },
      data: JSON.stringify(klaviyo_data),
      success: function(){
        const width = $(window).width();
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
      ? true
      : width < 1025;

      if(!isMobile){
        $('.notifyInputField').text( theme.strings.notification);
        $('.notifyInputField').addClass('notifySuccess');
        $('.product-add-to-notify-id').css('color', 'black');
        $('ul.variants-items li').css('color', '#bfbfbf');
        $('ul.color-options li').css('color', '#bfbfbf');
        $('.detailesInner path').css('fill', '#bfbfbf');
        $('.pdp_disclaimer').css('display', 'none');
      } else {
        $('.notifyInputFieldWrapper').removeClass('showNotify');
        $('.product-add-to-notify-id').text( theme.strings.notification);
        $('.product-add-to-notify-id').css('background-color', 'white');
        $('.product-add-to-notify-id').css('color', 'black');
    
      }
         
        
      }
  })
  });


$(".product-add-to-cart-id").click(function () {
  if (!$("ul.variants-items div input").is(":checked")) {
    $("ul.variants-items .Select-size").show();
    $("ul.variants-items").addClass("activeOverlay");
    $("body").addClass("activeBody");

    $(".activeOverlay input").click(function () {
      $("ul.variants-items").removeClass("activeOverlay");
      $("body").removeClass("activeBody");
      $("li.size-header span:nth-child(2)").text("Selected");
      $("li.size-header span:nth-child(3)").text($(this).data("title"));

      var selectedOptions = "";
      $("ul.variants-items div input:checked").each(function (i) {
        if (selectedOptions == "") {
          selectedOptions = $(this).data("title");
        } else {
          selectedOptions = selectedOptions + " / " + $(this).data("title");
        }
      });

      $(".all-variatns option").each(function () {
        let _this = $(this),
          title = _this.data("title");
        if (title == selectedOptions) {
          _this
            .attr("selected", "selected")
            .siblings()
            .removeAttr("selected", "selected");
          _this.prop("selected", true).siblings().prop("selected", false);
        }
      });
    });
  } else {
    console.log("here")
    addToCarstdsffs(
      $(".all-variatns option[selected='selected']").data("id"),
      $(".connected_name--opr").text()
    );
  }
});

function addToCarstdsffs(variant_id, prop) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: variant_id,
      properties: {
        Colour: prop,
      },
    },
    success: addToCartOk,
    error: addToCartFail,
  });
}
function addToCarst(variant_id, prop) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: variant_id,
      properties: {
        Colour: prop,
      },
    },
    success: function (cart) {
      var offset = 25;
      var nav = theme.Nav();

      if (nav.bar.getPositionSetting() !== "inline") {
        offset = nav.bar.height();
      }
      let text = "";
      for (let i = 0; i < cart.options_with_values.length; i++) {
        text +=
          cart.options_with_values[i].name +
          ":" +
          cart.options_with_values[i].value;
      }
      var html = `<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">
<div class="inner" style="top:${offset}px">
      <a href="#" data-modal-close="" class="modal-close">
${theme.icons.close}
      </a>
      <h4 id="added-to-cart-title">
      ${theme.icons.tick}
     ${theme.strings.productAddedToCart}
      </h4>
      <div class="cart-product">
         <div class="cart-product__image"><img src="${cart.featured_image.url}" alt="${cart.featured_image.alt}"></div>
         <div class="cart-product__content">
            <p class="cart-product__content__title">${cart.title}</p>
            <p class="cart-product__content__meta">${text}</p>
         </div>
      </div>
<p class="links "><a href="${theme.routes.cart_url}" class="button alt">${theme.strings.viewCart}</a><a href="${theme.routes.checkout}" class="button button--checkout" [data-cc-checkout-button]="">${theme.strings.popupCheckout}</a> </p>
   </div>
</div>`;
      $("body").prepend(html);
      setTimeout(function () {
        $("#added-to-cart").addClass("reveal");
      }, 500);
      $(".modal-close").click(function (e) {
        e.preventDefault();
        $("#added-to-cart").remove();
      });
    },
    error: function (cart) {
      $(
        '<div class="product-status-message">' +
          cart.responseJSON.description +
          "</div>"
      ).insertAfter(".product-add-to-cart-id");
      setTimeout(function () {
        $(".product-status-message").remove();
      }, 2500);
    },
  });
}

if (window.location.href.indexOf("eu.") > -1) {
  var countriesEU =
    "AT,BE,BG,HR,CY,CZ,EE,FI,FR,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,CH,DK,DE,NO";
  var z = JSON.parse(localStorage.getItem("geoip-location"));

  if (z) {
    var x = z.value.country.iso_code;
    var country = z.value.country.names.en;
    if (x == "CH") {
      $(".product-policies").html("<p>Tax & Duties included</p>");
    } else if (x == "HK") {
      $(".product-policies").hide();
    } else if (x == "RU") {
      $(".product-policies").html(
        '<p><a target="_blank" href="/pages/shipping-terms-dhl-russia">Tax and duties may apply</a></p>'
      );
    } else if (x == "IN") {
      $(".product-policies").html(
        '<p><a target="_blank" href="/pages/shipping-terms-dhl-russia">Tax and duties may apply</a></p>'
      );
    } else if (countriesEU.includes(x)) {
      $(".product-policies").html("<p>VAT & Duties included</p>");
    } else {
      $(".product-policies").html("<p>Taxes & Duties may apply</p>");
    }
  }
}

$(".product-block").on("mouseover", function () {
  let df = $(this).find(".featured_media-media");
  let ifr = df.find("iframe").attr("src");
  if (ifr && ifr.includes("&autoplay=1&mute=1")) {
  } else {
    if (df.hasClass("external_video_url-por-wrapper")) {
      let sec = df.find("iframe").attr("src");
      df.find("iframe").attr("src", sec + "&autoplay=1&mute=1");
    }
  }
});

$(".featured_media").each(function () {
  let df = $(this);
  if (df.hasClass("external_video_url-por-wrapper")) {
    let sec = df.find("iframe").attr("src");
    df.find("iframe").attr("src", sec + "&autoplay=1&mute=1");
  }
});

let df = $(".product-media:first-child");
if (df.hasClass("product-media--external-video")) {
  let sec = df.find("iframe").attr("src");
  df.find("iframe").attr("src", sec + "&autoplay=1&mute=1");
}


//Check if Safari
function isSafari() {
  return /^((?!chrome).)*safari/i.test(navigator.userAgent);
}
//Check if MAC
if (navigator.userAgent.indexOf("Mac") > 1) {
  $("html").addClass("isSafari");
}

let gf = $(".nav-right-side").offset().top + $(".nav-right-side").height();

$(".js-ajax-cart-drawer").css("top", "92px");
$("ul.variants-items div input").click(function () {
  $("li.size-header span:nth-child(2)").text("Selected");
  $("li.size-header span:nth-child(3)").text($(this).data("variant-title"));

  var selectedOptions = "";
  $("ul.variants-items div input:checked").each(function (i) {
    if (selectedOptions == "") {
      selectedOptions = $(this).data("title");
    } else {
      selectedOptions = selectedOptions + " / " + $(this).data("title");
    }
  });
  $(".all-variatns option").each(function () {
    let _this = $(this),
      title = _this.data("title");
    if (title == selectedOptions) {
      _this
        .attr("selected", "selected")
        .siblings()
        .removeAttr("selected", "selected");
      _this.prop("selected", true).siblings().prop("selected", false);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  fetchCart();
});
document.addEventListener("product:added", function (data) {
  fetchCart();
  openCartDrawer();
  openCartOverlay();
});

const defaults = {
  cartModal: ".js-ajax-cart-modal", // classname
  cartModalContent: ".js-ajax-cart-modal-content", // classname
  cartModalClose: ".js-ajax-cart-modal-close", // classname
  cartDrawer: ".js-ajax-cart-drawer", // classname
  cartDrawerinner: ".ajax-cart-drawer", // classname
  cartDrawerContent: ".js-ajax-cart-drawer-content", // classname
  cartDrawerClose: ".js-ajax-cart-drawer-close span", // classname
  cartDrawerTrigger: ".js-ajax-cart-drawer-trigger", // classname
  cartOverlay: ".js-ajax-cart-overlay", // classname
  cartCounter: ".js-ajax-cart-counter", // classname
  addToCart: ".js-ajax-add-to-cart", // classname
};
let cartModal = document.querySelector(defaults.cartModal);
let cartModalContent = document.querySelector(defaults.cartModalContent);
let cartModalClose = document.querySelector(defaults.cartModalClose);
let cartDrawer = document.querySelector(defaults.cartDrawer);
let cartDrawerinner = document.querySelector(defaults.cartDrawerinner);
let cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
let cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
let cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
let cartOverlay = document.querySelector(defaults.cartOverlay);
let cartCounter = document.querySelector(defaults.cartCounter);
let addToCart = document.querySelectorAll(defaults.addToCart);
let htmlSelector = document.documentElement;

/**
 * Checks if the Shopify cookie/consent banner (#shopify-pc__banner) is visible
 * and syncs the body lock by adding or removing the is-locked class on html.
 */
function updateBodyLockForCookieBanner() {
  const banner = document.querySelector('#shopify-pc__banner');
  const isVisible = banner && banner.offsetHeight > 0 && window.getComputedStyle(banner).display !== 'none';
  const pageOverlay = document.querySelector('.pageOverlay');
  if (isVisible) {
    //htmlSelector.classList.add('is-locked');
    pageOverlay.classList.add('is-visible');
  } else {
    //htmlSelector.classList.remove('is-locked');
    pageOverlay.classList.remove('is-visible');
  }
}

function initCookieBannerBodyLock() {
  updateBodyLockForCookieBanner();
  const bodyObserver = new MutationObserver(() => {
    updateBodyLockForCookieBanner();
    const banner = document.querySelector('#shopify-pc__banner');
    if (banner && !banner._bodyLockObserved) {
      banner._bodyLockObserved = true;
      const bannerObserver = new MutationObserver(updateBodyLockForCookieBanner);
      bannerObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:consent:updated', updateBodyLockForCookieBanner);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieBannerBodyLock);
} else {
  initCookieBannerBodyLock();
}

$("body").on("click", ".uploadkit-ok-button", function () {
  $(this).parents(".overlay_popup_upload").css("display", "none");
});
$(".nav-cart").click(function (event) {
  event.preventDefault();

  // document.body.style.overflow = "auto";
  // document
  //   .querySelector("favorites-drawer")
  //   .setAttribute("aria-expanded", "false");
  // document.querySelector('.pageOverlay')
  //   .classList.remove('is-visible');

 
  fetchCart();

  if(!cartDrawer.classList.contains('js-menu__expanded')){
    openCartDrawer();
    openCartOverlay();
  } else {
    closeCartDrawer();
    closeCartOverlay();
  }
  
});

function addToCarst(variant_id, prop) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: variant_id,
      properties: {
        Colour: prop,
      },
    },
    success: addToCartOk,
    error: addToCartFail,
  });
}

$("body").on("click", ".js-ajax-add-to-cart", function (event) {
  event.preventDefault();
  var uploadImg = $(".uploadkit-thumbnails").html();
  if (uploadImg) {
    let data = $(this).parents(".uploadkit-form").serialize();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: data,
      success: addToCartOk,
      error: addToCartFail,
    });
  } else {
    $(".overlay_popup_upload").css("display", "block");
  }
});

$("body").on("click", ".ajax-cart-drawer__buttons a", function (e) {
 // e.stopImmediatePropagation();
});
$("body").on("click", ".js-qtyplus", function (e) {
  e.stopImmediatePropagation();
  var variantId = $(this).parent().attr("variant-id");
  var qty = parseInt($(this).parent().find(".qty").val()) + 1;

  cartRemoveItem($(this).parents(".cartItem").attr("data-line"), qty);
});

$("body").on("click", ".js-qtyminus", function (e) {
  e.stopImmediatePropagation();
  var variantId = $(this).parent().attr("variant-id");
  var qty = parseInt($(this).parent().find(".qty").val()) - 1;

  cartRemoveItem($(this).parents(".cartItem").attr("data-line"), qty);
});

$("body").on("click", ".js-remove a", function (e) {
  new gTagEvents().removeFromCart(e);
  e.stopImmediatePropagation();
  var variantId = $(this).attr("item-id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: variantId,
      quantity: 0,
    },
    dataType: "json",
    async: "false",
    success: function (data) {
      console.log(data);
      fetchCart();
    },
    error: function () {
      console.log("error");
    },
  });
});

$(".site-header__Cstmcart").on("click", function (e) {
  e.stopImmediatePropagation();
  openCartDrawer();
  openCartOverlay();
});

function fetchCart(callback) {
  fetch("/cart.js", { credentials: "same-origin" })
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        //onCartUpdate(cart);
        renderCart(cart);
      }
    });

  $.getJSON("/cart.json", function (results) {});
}
function cartRemoveItem(line, quantity) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      fetchCart(cart);
    },
  });
}
function onCartUpdate(id, qty) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: id,
      quantity: qty,
    },
    dataType: "json",
    async: "false",
    success: function (data) {
      console.log(data);
      fetchCart();
    },
    error: function () {
      console.log("error");
    },
  });
}
function addToCarst_multi(variant_id) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      items: variant_id,
    },
    success: addToCartOk,
    error: addToCartFail,
  });
}


function addToCartOk() {

  if (window.location.pathname.includes('products')){
    new gTagEvents().addToCart();
  }

  openCartDrawer();
  openCartOverlay();
  fetchCart();
}
function addToCartFail() {
  openCartOverlay();
  cartModalContent.innerHTML =
    "The product you are trying to add is out of stock.";
  openAddModal();
}

function getCheckoutData(cart) {
  return {
    event: "begin_checkout",
    ecommerce: {
      value: cart.total_price / 100,
      items: cart.items.map((item, index) => ({
        item_id: item.sku,
        id: item.id,
        item_name: item.title,
        index: index + 1,
        item_brand: item.vendor,
        item_category: item.product_type,
        item_variant: item.variant_title,
        price: item.price / 100,
        google_business_vertical: "retail",
        quantity: item.quantity
      }))
    }
  };
}
function updateCheckoutButton(cart) {
  const checkoutButton = document.querySelector('[data-action="begin-checkout"]');
  if (checkoutButton) {
    const checkoutData = getCheckoutData(cart);
    checkoutButton.dataset.settings = JSON.stringify(checkoutData);
  }
}

function formatPriceJS(priceInCents, currencyIso) { let price = Math.round(priceInCents / 100).toString();
if (price.length === 4) { return price.slice(0,1)+' '+price.slice(1)+' '+currencyIso; } else if (price.length>4) { return price.slice(0,2)+' '+price.slice(2)+' '+currencyIso; } else { return price+' '+currencyIso; } }

function renderCart(cart) {
  if (cart.items.length > 1) {
    $(".hide.you-may-also-like").addClass("hidden");
    $(".hide.you-may-also-like").removeClass("not-hidden");
    $(".ajax-cart-drawer__content").removeClass("drawer__content_height");
  } else {
    $(".hide.you-may-also-like").addClass("not-hidden");
    $(".hide.you-may-also-like").removeClass("hidden");

    $(".ajax-cart-drawer__content").addClass("drawer__content_height");
  }

  // $(".ajax-cart-drawer__buttons").css("max-width", $("#main-nav").outerWidth());
  if (cart.item_count > 0) {
    //console.log(cart);
    var cartAllItems = [];
    var cartAllItems2 = [];

    let currencyIso = window.Shopify.currency.active || 'EUR'; // ili uzmi iz cart.currency.iso_code
    
    $(".hide.you-may-also-like").removeClass("cart_is_empty");
    var itemCount = cart.item_count;
    $(".site-control .cart div").text(itemCount);
    var totalPrice = cart.total_price;
    let totalPriceFormatted = formatPriceJS(cart.total_price, currencyIso);
    $(".subTotal_price").html(totalPriceFormatted);
    $(".ajax-cart-drawer__buttons").css("display", "block");
    $(".ajax-empty_cart").css("display", "none");
    $("#CartCount").removeClass("hide");
    clearCartDrawer();

    cart.items.forEach(function (item, index) {
      var id = item.id;
      var price = item.line_price;
      var properties = item.properties;
      let propertiesHtm = "";

      let removeSettings = {
        value: item.final_line_price / 100,
        item_id: item.sku,
        item_name: item.title.replace(/"/g, ' '), 
        price: item.line_price / 100,
        quantity: item.quantity
      }

      let formattedPrice = formatPriceJS(item.line_price, currencyIso);


      for (var property in properties) {
        if (property != "_Uploaded photo (direct link)") {
          if (properties[property]) {
            propertiesHtm +=
              "<p><span>" +
              property +
              ": </span><span>" +
              properties[property] +
              "</span></p>";
          }
        }
      }
      let options = item.options_with_values;
      var hml2,
        hml = [];

      for (let i = 0; i < options.length; i++) {
        hml2 =
          "<h4>" +
          item.options_with_values[i].name +
          ": " +
          item.options_with_values[i].value +
          "</h4>";
        hml.push(hml2);
      }
      let productImage =
        '<div  class="ajax-cart-item__image"><img src="' +
        item.image +
        '" alt="Product image"></div>';
      let qty =
        '<div class="qty_selector" variant-id="' +
        id +
        '"><span class="js-change-quantity js-qtyminus" field="quantity"> - </span><label hidden for="quantity"></label><input type="text" id="quantity" name="quantity" value="' +
        item.quantity +
        '" min="1" class="product-form__input qty" pattern="[0-9]*"><span class="js-change-quantity js-qtyplus" field="quantity"> + </span></div>';
      let productTitle =
        '<div class="item_title-qty"><div class="ajax-cart-item__title">' +
        item.product_title +
        '</div><div class="ajax-cart-item__price"><span itemprop="price" content="">' +
        formattedPrice +
        '</span></div><div class="options">' +
        hml +
        '</div><div class="ajax_properties">' +
        propertiesHtm +
        '</div><div class="price_qty_box"><div class="ajax-cart-item__quantity">' +
        qty +
        '</div></div><div class="js-remove"><a data-action="remove-item" tabindex="0" role="button" javascropt:void(0); item-id="' +
        id +
        '">Remove</a></div></div>';
      let anchor = '<a href="' + item.url + '" aria-label="Product link"></a>';
      let concatProductInfo =
        '<div class="cartItem" data-remove=\'' + JSON.stringify(removeSettings) + '\' data-line="' +
        (index + 1) +
        '">' +
        productImage +
        productTitle +
        anchor +
        "</div>";


      cartDrawerContent.innerHTML =
        cartDrawerContent.innerHTML + concatProductInfo;
      $(".qty").on("input", function (e) {
        var variantId = $(this).parent().attr("variant-id");
        var qty = parseInt($(this).val());
        cartRemoveItem($(this).parents(".cartItem").attr("data-line"), qty);
      });
      document.body.querySelector('.ajax-cart__modal').removeAttribute('data-observed');

      $(".collection--grid-items").each(function () {
        var d = $(this),
          val = d.data("title");
        if (item.product_title == val) {
          d.remove();
          cartAllItems.push(d.data("title"));
        }
      });
    });
    updateCheckoutButton(cart);
  } else {
    clearCartDrawer();
    $(".ajax-cart-drawer__buttons").css("display", "none");
    $(".ajax-empty_cart").css("display", "block");
    $(".hide.you-may-also-like").addClass("cart_is_empty");
    $(".ajax-cart-drawer__content").css("height", "auto");
    $(".site-control .cart div").text("0");
  }
}
function openAddModal() {
  cartModal.classList.add("is-open");
}

cartModalClose.addEventListener("click", function () {
  closeAddModal();
  closeCartOverlay();
});

function closeAddModal() {
  cartModal.classList.remove("is-open");
}
function openCartDrawer() {
  setProperty();
  $("body").css("overflow", "hidden");
  cartDrawer.classList.add("js-menu__expanded");
  //cartDrawerinner.classList.add('js-menu__expanded');

  cartDrawer.dispatchEvent(new CustomEvent('cart-drawer:open', {
    bubbles: true
  }));
  trapFocus(cartDrawer);
}
function closeCartDrawer() {
  $("body").css("overflow", "visible");
  cartDrawer.classList.remove("js-menu__expanded");
  //       cartDrawerinner.classList.remove('js-menu__expanded');
  removeTrapFocus(cartDrawer);
}
function clearCartDrawer() {
  cartDrawerContent.innerHTML = "";
}

function setProperty(){
  const headerEl = document.querySelector("#site-control");
  if(headerEl.classList.contains("announcement-hidden")){
    document.documentElement.style.setProperty(
      "--header-height",
      headerEl.clientHeight + "px"
    );
  } else if (headerEl.classList.contains("has-announcement")){
    document.documentElement.style.setProperty(
      "--header-height",
      headerEl.clientHeight + "px"
    );
  } else {
    document.documentElement.style.setProperty(
      "--header-height",
      headerEl.clientHeight + "px"
    );
  }
}

function openCartOverlay() {
  cartOverlay.classList.add("ajax_overlay_is-open");
  $(".js-ajax-cart-overlay").fadeIn();
  htmlSelector.classList.add("is-locked");
}
function closeCartOverlay() {
  closeAddModal();
  cartOverlay.classList.remove("ajax_overlay_is-open");
  htmlSelector.classList.remove("is-locked");
  $(".js-ajax-cart-overlay").fadeOut();
}
cartDrawerClose.addEventListener("click", function () {
  closeCartDrawer();
  closeCartOverlay();
});
//dodati overflow na body di treba, cart is empty stanje
cartOverlay.addEventListener("click", function () {
  closeCartDrawer();
  closeCartOverlay();
});

document.addEventListener('favorite-product:open', handleCart);
document.addEventListener('search:open', handleCart);
document.addEventListener('account-drawer:open', handleCart);
document.addEventListener('menu:open', handleCart);

// Close mobile menu when other drawers open
document.addEventListener('cart-drawer:open', closeMobileMenuIfOpen);
document.addEventListener('favorite-product:open', closeMobileMenuIfOpen);
document.addEventListener('search:open', closeMobileMenuIfOpen);
document.addEventListener('account-drawer:open', closeMobileMenuIfOpen);

function handleCart(){
  closeCartDrawer();
  closeCartOverlay();
}

function closeMobileMenuIfOpen(){
  // Check if page-menu is currently open
  if ($("body").attr("data-modal-id") === "page-menu" || $("#page-menu").hasClass("reveal")) {
    closeThemeModal(true);
  }
}

// This button will increment the value
$("body").on("click", ".js-qtyplus", function (e) {
  e.preventDefault();
  fieldName = $(this).attr("field");
  var currentVal = parseInt(
    $(this)
      .parent()
      .find("input[name=" + fieldName + "]")
      .val()
  );
  if (!isNaN(currentVal)) {
    $(this)
      .parent()
      .find("input[name=" + fieldName + "]")
      .val(currentVal + 1);
  } else {
    $(this)
      .parent()
      .find("input[name=" + fieldName + "]")
      .val(0);
  }
});
// This button will decrement the value till 0
$("body").on("click", ".js-qtyminus", function (e) {
  e.preventDefault();
  fieldName = $(this).attr("field");
  var currentVal = parseInt(
    $(this)
      .parent()
      .find("input[name=" + fieldName + "]")
      .val()
  );
  if (!isNaN(currentVal) && currentVal > 0) {
    $(this)
      .parent()
      .find("input[name=" + fieldName + "]")
      .val(currentVal - 1);
  } else {
    $(this)
      .parent()
      .find("input[name=" + fieldName + "]")
      .val(0);
  }
});

// $(window).resize(function () {
//   $(".ajax-cart-drawer__buttons").css("max-width", $("#main-nav").outerWidth());
// });

//     $(".js-ajax-cart-drawer,#favorites").css("top",$(".nav-right-side").offset().top + 30)

/* Built with Barry v1.0.7 */
function Delegate(e) {
  (this.listenerMap = [{}, {}]),
    e && this.root(e),
    (this.handle = Delegate.prototype.handle.bind(this)), 
    (this._removedListeners = []);
}
function matchesTag(e, t) {
  return e.toLowerCase() === t.tagName.toLowerCase();
}
function matchesRoot(e, t) {
  return this.rootElement === window
    ? t === document || t === document.documentElement || t === window
    : this.rootElement === t;
}
function matchesId(e, t) {
  return e === t.id;
}
(Delegate.prototype.root = function (e) {
  const t = this.listenerMap;
  let n;
  if (this.rootElement) {
    for (n in t[1])
      t[1].hasOwnProperty(n) &&
        this.rootElement.removeEventListener(n, this.handle, !0);
    for (n in t[0])
      t[0].hasOwnProperty(n) &&
        this.rootElement.removeEventListener(n, this.handle, !1);
  }
  if (!e || !e.addEventListener)
    return this.rootElement && delete this.rootElement, this;
  for (n in ((this.rootElement = e), t[1]))
    t[1].hasOwnProperty(n) &&
      this.rootElement.addEventListener(n, this.handle, !0);
  for (n in t[0])
    t[0].hasOwnProperty(n) &&
      this.rootElement.addEventListener(n, this.handle, !1);
  return this;
}),
  (Delegate.prototype.captureForType = function (e) {
    return (
      -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e)
    );
  }),
  (Delegate.prototype.on = function (e, t, n, r) {
    let o, i, s, a;
    if (!e) throw new TypeError("Invalid event type: " + e);
    if (
      ("function" == typeof t && ((r = n), (n = t), (t = null)),
      void 0 === r && (r = this.captureForType(e)),
      "function" != typeof n)
    )
      throw new TypeError("Handler must be a type of Function");
    return (
      (o = this.rootElement),
      (i = this.listenerMap[r ? 1 : 0])[e] ||
        (o && o.addEventListener(e, this.handle, r), (i[e] = [])),
      t
        ? /^[a-z]+$/i.test(t)
          ? ((a = t), (s = matchesTag))
          : /^#[a-z0-9\-_]+$/i.test(t)
          ? ((a = t.slice(1)), (s = matchesId))
          : ((a = t), (s = Element.prototype.matches))
        : ((a = null), (s = matchesRoot.bind(this))),
      i[e].push({ selector: t, handler: n, matcher: s, matcherParam: a }),
      this
    );
  }),
  (Delegate.prototype.off = function (e, t, n, r) {
    let o, i, s, a, h;
    if (
      ("function" == typeof t && ((r = n), (n = t), (t = null)), void 0 === r)
    )
      return this.off(e, t, n, !0), this.off(e, t, n, !1), this;
    if (((s = this.listenerMap[r ? 1 : 0]), !e)) {
      for (h in s) s.hasOwnProperty(h) && this.off(h, t, n);
      return this;
    }
    if (!(a = s[e]) || !a.length) return this;
    for (o = a.length - 1; o >= 0; o--)
      (i = a[o]),
        (t && t !== i.selector) ||
          (n && n !== i.handler) ||
          (this._removedListeners.push(i), a.splice(o, 1));
    return (
      a.length ||
        (delete s[e],
        this.rootElement &&
          this.rootElement.removeEventListener(e, this.handle, r)),
      this
    );
  }),
  (Delegate.prototype.handle = function (e) {
    let t, n;
    const r = e.type;
    let o,
      i,
      s,
      a,
      h,
      l = [];
    if (!0 === e.ftLabsDelegateIgnore) return;
    switch (
      (3 === (h = e.target).nodeType && (h = h.parentNode),
      h.correspondingUseElement && (h = h.correspondingUseElement),
      (o = this.rootElement),
      (i = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)))
    ) {
      case 1:
        l = this.listenerMap[1][r];
        break;
      case 2:
        this.listenerMap[0] &&
          this.listenerMap[0][r] &&
          (l = l.concat(this.listenerMap[0][r])),
          this.listenerMap[1] &&
            this.listenerMap[1][r] &&
            (l = l.concat(this.listenerMap[1][r]));
        break;
      case 3:
        l = this.listenerMap[0][r];
    }
    let p,
      f = [];
    for (n = l.length; h && n; ) {
      for (t = 0; t < n && (s = l[t]); t++)
        h.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          h.tagName.toLowerCase()
        ) > -1 &&
        h.hasAttribute("disabled")
          ? (f = [])
          : s.matcher.call(h, s.matcherParam, h) && f.push([e, h, s]);
      if (h === o) break;
      if (
        ((n = l.length),
        (h = h.parentElement || h.parentNode) instanceof HTMLDocument)
      )
        break;
    }
    for (t = 0; t < f.length; t++)
      if (
        !(this._removedListeners.indexOf(f[t][2]) > -1) &&
        !1 === (a = this.fire.apply(this, f[t]))
      ) {
        (f[t][0].ftLabsDelegateIgnore = !0), f[t][0].preventDefault(), (p = !1);
        break;
      }
    return p;
  }),
  (Delegate.prototype.fire = function (e, t, n) {
    return n.handler.call(t, e, t);
  }),
  (Delegate.prototype.destroy = function () {
    this.off(), this.root();
  });


  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class InfiniteScroll {
    constructor(container, restoreState) {
        this.containerSelector = container;
        this.treshold = 650;
        this.handleScrollListener = this.handleScroll.bind(this);
        this.currentPage = 1; 
        
        if (restoreState === true && sessionStorage.getItem('pageState')) {
          const promises = this.generateFetchPromises(false);
          this.renderData(promises, true);
        } else {
          this.initialize();
        }

        document.addEventListener('click', (event) => {
            if (event.target.closest('.product-block')) {
              const scrollPosition = window.scrollY;
              sessionStorage.setItem('scrollPosition', scrollPosition);
              sessionStorage.setItem('currentPage', this.currentPage);
            }
          });
    
        window.addEventListener('popstate', () => {
          this.reinitialize();
        });
    
      }
    
      initialize() {
        document.addEventListener('scroll', this.handleScrollListener);
    
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        const currentPage = sessionStorage.getItem('currentPage');
        
        if (scrollPosition !== null && currentPage !== null) {
          this.currentPage = parseInt(currentPage, 10);
          window.scrollTo(0, parseInt(scrollPosition, 10));
          sessionStorage.removeItem('scrollPosition');
          sessionStorage.removeItem('currentPage');
          this.restoreStatePages(this.currentPage);
        }
    
      }
    
      reinitialize() {
        this.initialize();
      }
    
      restoreStatePages(currentPage) {
        const promises = this.generateFetchPromises(false, currentPage);
        this.renderData(promises, true);
      }
  
    handleScroll() {
      this.paginationElement = document.querySelector('#infiniteScroll');
      if (!this.paginationElement) return;
        const top = this.paginationElement.getBoundingClientRect().top - this.treshold;
    
        const bottom = this.paginationElement.getBoundingClientRect().bottom + this.treshold;
        
        if (top <= window.innerHeight && bottom >= 0) {
            this.nextPageLinkElement = this.paginationElement.querySelector('a');
            
            if (this.nextPageLinkElement) {
                this.destroy();
                const nextPageUrl = this.nextPageLinkElement.href;
            
                const promises = this.generateFetchPromises(nextPageUrl);
                this.renderData(promises);
            }
        }
    }
  
    destroy() {
      // Remove the event listener when the instance is no longer needed
      document.removeEventListener('scroll', this.handleScrollListener);
    }
  
      generateFetchPromises(nextPageUrl, restorePage) {
        const promises = [];
        const limit = restorePage || this.currentPage;
  
        if(!nextPageUrl){
          const hasSearchParameters = window.location.search.length > 0;
       
          for (let i = 2; i <= limit; i++) {
            let url;
        
            // Build the URL based on the condition
            if (hasSearchParameters) {
              url = `${window.location.href}&page=${i}`;
            } else {
              url = `${window.location.href}?page=${i}`;
            }
  
            promises.push(fetch(url, {
              credentials: "same-origin",
              method: "GET",
            }));
          }
        } else {
          //const url = `${nextPageUrl}`;
    
          promises.push(fetch(nextPageUrl, {
            credentials: "same-origin",
            method: "GET",
          }));
          this.currentPage++;
        }
  
        return promises;
      }
    
  
    async renderData(promises, restoreContent) {
      try {
        const responses = await Promise.all(promises);
        const contents = await Promise.all(responses.map(response => response.text()));
        let isLastPromise = false;
        contents.forEach((content, index) => {
        
            isLastPromise = index === contents.length - 1;
         
            this.appendContent(content, isLastPromise, restoreContent);
        });
      } catch (error) {
        console.error('Error fetching or parsing data:', error);
      }
    }
  
  
    appendContent(content, lastPromise, restoreContent){
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      const contentToAdd = doc.querySelector(this.containerSelector);
    
  
      this.mainContainer = document.querySelector(this.containerSelector);
      this.paginationElement = document.querySelector('#infiniteScroll');
      if (this.paginationElement){
        this.paginationElement.remove();
      }
  
      this.mainContainer.insertAdjacentHTML('beforeend', contentToAdd.innerHTML);
      this.paginationElement = document.querySelector('#infiniteScroll');
      if(lastPromise){
        this.initialize();
      }
  
      if(lastPromise && restoreContent){
        this.restoreScroll();
      }
  
      document.dispatchEvent(
        new CustomEvent("pagination:finished", { bubbles: true })
      );
   
    }
    restoreScroll() {
      const selector = `${this.containerSelector} [data-id='${sessionStorage.getItem('pageStateProduct')}']`;
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth', // You can use 'auto' for instant scrolling
          block: 'start',     // You can use 'center' or 'end' for different alignments
        });
      }
    }
  }

  class CollectionGrid extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
       
        this.bindEvents();

        // document.addEventListener("DOMContentLoaded", function() {
        //     var endlessScroll = new Ajaxinate({
        //       container: '#mainCollectionHolder',
        //       pagination: '#collectionPagination'
        //     });
        //   });

        if( window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1){
            new InfiniteScroll('#CollectionProductGrid');
            // if ('scrollRestoration' in history) {
            //   history.scrollRestoration = 'manual';
            // }
            
          } else {
      
            new InfiniteScroll('#CollectionProductGrid');
            sessionStorage.removeItem('pageState');
            sessionStorage.removeItem('pageStateProduct');
          }

    }

    bindEvents() {
        this.delegateElement.on(
          'click',
          '[data-action="mobile-tap"]',
          this.setLastClick.bind(this)
        );

        document.addEventListener('scroll', this.urlChange.bind(this));
    }

    urlChange(){
      const element = document.querySelectorAll('.product-list');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            const pageNum = entry.target.getAttribute('data-paginate');
            const url = this.element.querySelector('.collection-grid').getAttribute('data-next');
       
            const page_num = url.split('=');
            const new_link = page_num[0] + '=' + pageNum;
            window.history.replaceState(null,"",new_link);
          }
        })
      });

      for(let i=0; i<element.length; i++){
        const el = element[i];
        observer.observe(el);
      }
    }

    setLastClick(event){
      const url = window.location.href;
      const page_num = url.split('?');
      window.history.replaceState(null,"",page_num[0]);
        let dataPage = event.target.dataset.page;
        let dataPageProduct = event.target.dataset.id;
        if(!event.target.dataset.page){
          dataPage = event.target.closest('[data-page]').dataset.page;
          dataPageProduct = event.target.closest('[data-page]').dataset.id;
        }
        sessionStorage.setItem('pageState', dataPage);
        sessionStorage.setItem('pageStateProduct', dataPageProduct);
    }
}
customElements.define("main-collection-grid", CollectionGrid);


  class CollectionFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.filterData = [];
        this.domDelegate = new Delegate(this.element);
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      
        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 50);
        var drawers = this.element.querySelectorAll('.Drawer--wrapper');
        drawers.forEach((item, i) => {
            new Drawer(item);
        });
        
        this.bindEvents();
    }

    bindEvents(){
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.debounceListener = this.debouncedOnSubmit.bind(this); 
        
        this.domDelegate.on('keypress', '[data-accesability="checkbox"]', this.selectCheckbox.bind(this));
        this.domDelegate.on('click', '[data-action="submit"]', this.debounceListener);
        this.domDelegate.on('change', '[data-action="submit"]', this.debounceListener);
        this.domDelegate.on('click', '[data-action="open-filters"]', this.toggleFilter.bind(this));
        window.addEventListener('popstate', this.onHistoryChange.bind(this));

        document.addEventListener('filters:rerendered', this.handleOpenFilters.bind(this));

        this.domDelegate.on('change', '.sortBy_Element[data-action="submit"]', this.sendSortData.bind(this));
        this.domDelegate.on('click', '.filterElement[data-action="submit"]', this.sendFilterData.bind(this));
    }

    sendSortData(){
      document.dispatchEvent(new CustomEvent("sort:changed", { bubbles: true }));
    }

    sendFilterData(){
      requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent("filter:changed", { bubbles: true }));
      });

    }

    handleOpenFilters(){
      const shouldOpen = this.filtersOpen !== false; // default: open unless explicitly closed
      if (shouldOpen) {
        $('.openFilterTitle').show();
        $('.closedFilterTitle').hide();
        $('.filterMainWrapper').css("display", "block");
      } else {
        $('.closedFilterTitle').show();
        $('.openFilterTitle').hide();
        $('.filterMainWrapper').css("display", "none");
      }
    }

    toggleFilter(){
      if($(".filterMainWrapper").is(":hidden"))
      {
        this.filtersOpen = true;
        $('.openFilterTitle').show();
        $('.closedFilterTitle').hide();
        this.element.dispatchEvent(
        new CustomEvent("filters:sort:open", {
            bubbles: true
          })
        );
      }else{
        this.filtersOpen = false;
        $('.closedFilterTitle').show();
        $('.openFilterTitle').hide();
        this.element.dispatchEvent(
        new CustomEvent("filters:sort:close", {
          bubbles: true
        })
      );
      }
      $('.filterMainWrapper').slideToggle();
      
      
    }

    selectCheckbox() {
        event.preventDefault();
        if (event.keyCode === 13) {
            const checkbox = this.element.querySelector('#' + event.target.getAttribute('for'));
            if (checkbox.checked) {
                checkbox.removeAttribute('checked');
                if (new Responsive().matchesBreakpoint('pocket')) {
                    this.onSubmitHandler(event);
                }
            } else {
                checkbox.setAttribute('checked', 'true');
                if (new Responsive().matchesBreakpoint('pocket')) {
                    this.onSubmitHandler(event);
                }
            }
        }
    }

    onSubmitHandler(event) {
  
        const formData = new FormData(event.target.closest('form'));
        const searchParams = Array.from(formData)
        .map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value))
        .join('&');
        this.renderPage(searchParams, event);

        

    }

    onActiveFilterClick(event) {
        event.preventDefault();
        this.toggleActiveFacets();
        this.renderPage(new URL(event.currentTarget.href).searchParams.toString());

    }

    onHistoryChange(event) {
        const searchParams = event.state ? event.state.searchParams : "";
        this.renderPage(searchParams, null, false);
    }

    toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    renderPage(searchParams, event, updateURLHash = true) {
      CollectionFiltersForm.searchParamsPrev = searchParams;

      const searchTerm = this.element.querySelector('[data-terms]');
      var term ="";
      if(searchTerm){
        term = searchTerm.dataset.terms;
        term = `&q=${term}&type=product`;
      }

      const sections = this.getSections();
        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}${term}`;
            const filterDataUrl = element => element.url === url;

            this.filterData.some(filterDataUrl) ?
                this.renderSectionFromCache(filterDataUrl, event) :
                this.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) this.updateURLHash(searchParams);
    }

    renderSectionFromFetch(url, event) {
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                this.filterData = [...this.filterData, { html, url }];
                this.renderFilters(html, event);
                this.renderProductGrid(html);

            });
    }

    renderSectionFromCache(filterDataUrl, event) {
        const html = this.filterData.find(filterDataUrl).html;
        this.renderFilters(html, event);
        this.renderProductGrid(html);
    }

    renderProductGrid(html) {
   
      const target = document.querySelector('.collection-template');
      theme.unloadInfiniteScroll(target);
        document.getElementById('CollectionProductGrid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductGrid').innerHTML;
        theme.loadInfiniteScroll(target);

      }



    renderFilters(html, event) {
        var _this = this;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        var filterElement = parsedHTML.querySelector('.filterMainWrapper');
        var oldFilterElement = this.element.querySelector('.filterMainWrapper');
        this.element.querySelector('#CollectionFiltersForm').replaceChild(filterElement, oldFilterElement);

        var filterElement = parsedHTML.querySelector('.filtersHeader');
        var oldFilterElement = this.element.querySelector('.filtersHeader');
        this.element.querySelector('#CollectionFiltersForm').replaceChild(filterElement, oldFilterElement);

        this.renderActiveFacets(parsedHTML);
        this.element.dispatchEvent(
            new CustomEvent("filters:rerendered", {
              bubbles: true
            })
          );

    }

    renderActiveFacets(html) {
        const activeFacetsElement = html.querySelector('.activeFacets');
        if (!activeFacetsElement) return;
        document.querySelector(".activeFacets").innerHTML = activeFacetsElement.innerHTML;
        this.toggleActiveFacets(false);
    }


    updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

    }

    getSections() {
        return [
            {
                id: 'CollectionProductGrid',
                section: document.getElementById('CollectionSection').dataset.id,
            }
        ]
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : CollectionFiltersForm.searchParamsInitial;
        if (searchParams === CollectionFiltersForm.searchParamsPrev) return;
        CollectionFiltersForm.renderPage(searchParams, null, false);
      }
      window.addEventListener('popstate', onHistoryChange);
    }
}


CollectionFiltersForm.filterData = [];
CollectionFiltersForm.searchParamsInitial = window.location.search.slice(1);
CollectionFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('collection-filters-form', CollectionFiltersForm);
CollectionFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        this.querySelector('a').addEventListener('click', (event) => {
            event.preventDefault();
            const form = this.closest('collection-filters-form');
            form.onActiveFilterClick(event);
            document.dispatchEvent(new CustomEvent('filter:sort:removed', { bubbles: true }));
        });
    }
}

customElements.define('facet-remove', FacetRemove); 


class Popup {
  constructor(element) {
      this.element = element;
      this.delegateElement = new Delegate(this.element);
      this.pageOverlayElement = document.querySelector(".pageOverlay");
      this.bindEvents();
  }
  bindEvents() {
      this.delegateElement.on(
          "click",
          '[data-action="open-modal"]',
          this.openModal.bind(this)
      );
      this.delegateElement.on(
          "click",
          '[data-action="close-modal"]',
          this.closeModal.bind(this)
      );
      
      this.onClickOutsideListener = this.closeModal.bind(this);

  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );

    this.activeModal.setAttribute("aria-hidden", "false");
  }

  closeModal() {
    this.activeModal = document.body.querySelector('.Popup[aria-hidden="false"]');
    this.activeModal.setAttribute("aria-hidden", "true");
  }

}

class Dropdown {
  constructor() {
    this.element = this;
    this.domDelegate = new Delegate(document.body);
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
  }

  openDropdown(elem) {
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    DropdownButton.setAttribute("aria-expanded", "true");
    DropdownContent.setAttribute("aria-hidden", "false");

  }

  closeDropdown(elem) {
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    DropdownButton.setAttribute("aria-expanded", "false");
    DropdownContent.setAttribute("aria-hidden", "true");
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}

new Dropdown();

class geoPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.assignVariables();

    if (this.testMode) this.displayGeoPopup();
    else this.getLocation();
  }

  assignVariables() {
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(this.element);
    this.DropdownButton = this.element.querySelector(".Dropdown--Button");
    this.DropdownContent = this.element.querySelector(".Dropdown--Content");
    this.dropdownContent = this.DropdownContent.getAttribute('aria-hidden');
    this.submitButton = this.element.querySelector('.confirm--button');
    this.modal = document.querySelector('#modal-destination').getAttribute('aria-hidden');

    this.cookieBanner = document.querySelector('#shopify-pc__banner');
    this.cookieBtn = document.querySelector('#shopify-pc__banner__btn-accept');
    this.cookieSettings = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
    this.geoPopup = document.querySelector('geo-popup');
    this.geoPopup.style.display = 'none'; // Geo popup je sakriven na početku
    this.focusableElement = this.geoPopup.querySelector('.section-geolocation-popup');
    this.pageOverlay = document.querySelector('.popup__overlay');
    this.testMode = this.element.querySelector("[data-test-mode]")?.dataset.testMode === "true";
    
    this.options = JSON.parse(document.querySelector('.section-geolocation-popup').getAttribute('data-settings'));
    new Popup(this.element);
  }

  connectedCallback() { 
    this.domDelegate.on(
      "click",
      "[data-action=selectbox-link]",
      this.selectboxLink.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=open-modal]",
      this.toggleModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=close-modal]",
      this.closeModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=close-popup]",
      this.closePopup.bind(this)
    )
    
  }

  getLocation() {
    let storedCountryCode = localStorage.getItem('MyLocation');
    
    if (!this.options || !this.options.hide_countries) {
      console.error('Opcije nisu pravilno definisane ili hide_countries ne postoji.');
      return;
    }
  
    const hideCountries = this.options.hide_countries.map(country => country.toLowerCase());

    // Provera da li je prošlo manje od 14 dana od poslednjeg prikazivanja popupa
    const lastShown = localStorage.getItem('geoPopupLastShown');
    if (lastShown) {
        const lastShownDate = new Date(lastShown);
        const now = new Date();
        const diffInDays = (now - lastShownDate) / (1000 * 60 * 60 * 24);
        
        if (diffInDays < this.options['dismiss']) {
            return;
        }
    }
  
    // Ako je zemlja već sačuvana u localStorage
    if (storedCountryCode) {
      this.checkCookieAndShowPopup(storedCountryCode, hideCountries);
    } else {
      // Ako nije, napravimo API poziv da dobijemo `countryCode`
      var xhr = new XMLHttpRequest();
      xhr.open('GET', 'http://api.ipstack.com/check?access_key=de6f494b748eeabcfb39eff9bc60c7c5&fields=country_code');
      xhr.onload = () => {
        if (xhr.status === 200) {
          var location = JSON.parse(xhr.responseText);
          let countryCode = location.country_code.toLowerCase();
          localStorage.setItem("MyLocation", countryCode);
          this.checkCookieAndShowPopup(countryCode, hideCountries);
        } else {
          console.error('Greška u dobijanju lokacije iz API-ja');
        }
      };
      xhr.send();
    }
  }
  
  checkCookieAndShowPopup(countryCode, hideCountries) {
    if (hideCountries.includes(countryCode)) return this.geoPopup.style.display = 'none';

    // Ponovo inicijalizuj cookieBanner ako je null
    if (!this.cookieBanner) {
      this.cookieBanner = document.querySelector('#shopify-pc__banner');
      this.cookieBtn = document.querySelector('#shopify-pc__banner__btn-accept');
      this.cookieSettings = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
    }

    // if cookie banner is closed - show geo popup
    if (!this.cookieBanner || window.getComputedStyle(this.cookieBanner).display !== 'block') return this.displayGeoPopup();
      
    this.geoPopup.style.display = 'none';
    this.addCookieClosedEvents();
  }

  // when cookie banner is closed - show geo popup
  addCookieClosedEvents() {
    this.cookieBtn.addEventListener('click', () => {
      this.displayGeoPopup();
    });
      
    this.cookieSettings.addEventListener('click', () => {
      setTimeout(() => {
        this.cookieBtns = document.querySelectorAll('#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-decline');
        this.cookieBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            this.displayGeoPopup();
          });
        });
      }, 200);
    });
  }
  
  displayGeoPopup() {    
    setTimeout(()=> {            
      this.geoPopup.style.display = 'block';
      window.requestAnimationFrame(() => this.geoPopup.setAttribute("aria-hidden", "false"));
      this.showOverlay();

      if (!this.testMode) {
        // Sačuvaj datum kada je popup prikazan
        localStorage.setItem('geoPopupLastShown', new Date().toISOString());
      }
      
      bodyScrollLock.disableBodyScroll(this.geoPopup, bodyScrollLockOptions);
      trapFocus(this.focusableElement);
    }, this.options['timeout'] || 5000);
  }

  showOverlay() {
    this.pageOverlay.classList.add('is-visible');
    this.pageOverlay.style.zIndex = '99';

    this.bindClosePopup = this.closePopup.bind(this);
    this.pageOverlay.addEventListener("click", this.bindClosePopup);
  }

  hideOverlay() {
    this.pageOverlay.classList.remove('is-visible');
    this.pageOverlay.removeEventListener("click", this.bindClosePopup);
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  closePopup(){
    this.geoPopup.setAttribute("aria-hidden", "true");

    setTimeout(() => {
      this.geoPopup.style.display = 'none';
      removeTrapFocus(this.focusableElement);
    }, 300);

    this.hideOverlay();
    
  }

  closeModal(){
    this.geoPopup.setAttribute("aria-hidden", "false")
  }

  toggleModal(){
    if(this.modal == 'true'){
      this.geoPopup.setAttribute("aria-hidden", "true")
    } else {
      this.geoPopup.setAttribute("aria-hidden", "false")
    }
  }

  toggleDropdown(){
    if(this.dropdownContent == 'true'){
      this.submitButton.innerHTML = theme.strings.select
    } else {
      this.submitButton.innerHTML = theme.strings.confirm
    }
  }

  selectboxLink(event, target){
    var link = event.target.getAttribute("data-link");
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");

    var titleElement = this.element.querySelector(".dropdown--title");
    if (titleElement) {
        titleElement.innerHTML = dataName;
    }

    this.submitButton.setAttribute('href', link);

    this.DropdownButton.setAttribute("aria-expanded", "false");
    this.DropdownContent.setAttribute("aria-hidden", "true");

    this.submitButton.innerHTML = theme.strings.confirm;
  }
}

customElements.define('geo-popup', geoPopup); 

class Klaviyo extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      new Popup(this.element);
            
      this.bindEvents();
    }

  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="sendToKlaviyo"]',
        this.klaviyoSubmit.bind(this)
    );

    this.delegateElement.on(
        "mouseover",
        '[data-action="show-popup"]',
        this.togglePopup.bind(this)
    );
  }

  togglePopup(){
    var getPopup = document.querySelector('.popupSubscribe');
      
    if (getPopup.classList.contains('visiblePopup')) {
      getPopup.addEventListener('mouseleave', () => getPopup.classList.remove('visiblePopup'));
    } else {
      getPopup.classList.add('visiblePopup');
    }

  }

  
  klaviyoSubmit(){
    event.preventDefault();
   
    const formElement = event.target.closest("form"),
    email = formElement.querySelector('[name="email"]').value,
    errorMsg = this.element.querySelector('.error_message'),
    errorMsg2 = this.element.querySelector('.error_message2'),
    inputEl = this.element.querySelector('.cursor');
 
    const listid = this.element.querySelector('#listid').value;
 
    const inputs = this.element.querySelectorAll('.segmentInput');
    let gender = ""
    inputs.forEach((item) =>{
      if (item.checked){
        gender = gender + item.dataset.segment + ",";
      } 
      item.addEventListener('click', function(){
        errorMsg2.style.display = 'none';
      })
    });

    errorMsg.addEventListener('click', function(){
      errorMsg.style.display = 'none';
      inputEl.style.display = 'block';
    })

    var ischecked = $('input[type=checkbox]:checked').length;
    if (ischecked > 0){
      errorMsg2.style.display = 'none';

      const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
      if (email == '' ) {
        errorMsg.style.display = 'block';
        inputEl.style.display = 'none';
        return false;
      } else {
        errorMsg.style.display = 'none';
        inputEl.style.display = 'block';
        var settings = {
        "async": true,
        "crossDomain": true,
        "url": url,
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": listid,
          "$fields": "$gender, $source",
          "email": email,
          "$gender": gender,
          "$source": "Header_New"
        }
        }

      
        
        $.ajax(settings).done(function (response) {


        if(response.success){
          var link = document.querySelector('.popupLink');
          // link.getAttribute('href')
          console.log(link)
            formElement.innerHTML = `<div class="PopupThanksMsg">${theme.strings.popup_success}</div>` + `<div class="popupThanksLink"><a href="${link}">${theme.strings.popup_explore}</a></div>`;
          
        }
        });
      }
    } else {
      errorMsg2.style.display = 'block';
    }
    
    
  }
  

}
customElements.define("klaviyo-handle", Klaviyo);

class KlaviyoF extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      new Popup(this.element);
            
      this.bindEvents();
    }

  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="sendToKlaviyo"]',
        this.klaviyoSubmit.bind(this)
    );

    this.delegateElement.on(
        "mouseover",
        '[data-action="show-popup"]',
        this.togglePopup.bind(this)
    );
   
  }

  togglePopup(){
    var getPopup = document.querySelector('.popupSubscribe');
      
    if (getPopup.classList.contains('visiblePopup')) {
      getPopup.addEventListener('mouseleave', () => getPopup.classList.remove('visiblePopup'));
    } else {
      getPopup.classList.add('visiblePopup');
    }

  }

  
  klaviyoSubmit(){
    event.preventDefault();
   
    const formElement = event.target.closest("form"),
    email = formElement.querySelector('[name="email"]').value,
    errorMsg = this.element.querySelector('.error_message'),
    errorMsg2 = this.element.querySelector('.error_message2'),
    inputEl = this.element.querySelector('.cursor');
 
    const listid = this.element.querySelector('#listid').value;
 
    const inputs = this.element.querySelectorAll('.segmentInput');
    let gender = ""
    inputs.forEach((item) =>{
      if (item.checked){
        gender = gender + item.dataset.segment + ",";
      } 
      item.addEventListener('click', function(){
        errorMsg2.style.display = 'none';
      })
    });

    errorMsg.addEventListener('click', function(){
      errorMsg.style.display = 'none';
      inputEl.style.display = 'block';
    })

    var ischecked = $('input[type=checkbox]:checked').length;
    if (ischecked > 0){
      errorMsg2.style.display = 'none';

      const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
      if (email == '' ) {
        errorMsg.style.display = 'block';
        inputEl.style.display = 'none';
        return false;
      } else {
        errorMsg.style.display = 'none';
        inputEl.style.display = 'block';
        var settings = {
        "async": true,
        "crossDomain": true,
        "url": url,
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": listid,
          "$fields": "$gender, $source",
          "email": email,
          "$gender": gender,
          "$source": "Footer_New"
        }
        }

      
        
        $.ajax(settings).done(function (response) {


        if(response.success){
          var link = document.querySelector('.popupLink');
          // link.getAttribute('href')
          console.log(link)
            formElement.innerHTML = `<div class="PopupThanksMsg">${theme.strings.popup_success}</div>` + `<div class="popupThanksLink"><a href="${link}">${theme.strings.popup_explore}</a></div>`;
          
        }
        });
      }
    } else {
      errorMsg2.style.display = 'block';
    }
    
    
  }
  

}
customElements.define("klaviyo-handle-footer", KlaviyoF);

class homeSlideshow extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);

      const reverted = this.element.querySelector('[reverted="true"]');
      var _this = this;
      var intervalId;
      var $this = $(this.element);
      const windowSreen = $( window ).width() - 300;
    
      function doSomethingRepeatedly(e, swiper){
        console.log('here');
        if (e.pageX < 300) {
          const index = swiper.activeIndex - 1;
          swiper.slideTo(index, 3000, true);
  
        } else if(e.pageX > windowSreen){
          const index = swiper.activeIndex + 1;
          swiper.slideTo(index, 3000, true);

        }
  
      }

      if(reverted) {
      const swiper = new Swiper(this.element.querySelector('.swiper'), {
        slidesPerView: 5.6,
        spaceBetween: 0,
        autoplay: {
          delay: 0,
          reverseDirection: true,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        freeMode: {
          enabled: false,
          momentum: false,
          momentumBounce: false,

        },
        speed: 8000,
        loopedSlides: 16,
        loop: true,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
        grabCursor: true,
        mousewheelControl: true,
        keyboardControl: true,
        // Responsive breakpoints
        breakpoints: {
        
          // when window width is <= 1025px
          1024: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        on: {
          init: function (){
            
            const homeSwiper = $('.swiper-slide', $this);
            $(homeSwiper).hover(function(e){
              var intervalDelay = 500;
              intervalId = setInterval(doSomethingRepeatedly(e, swiper), intervalDelay);
      
      }, function () {
        clearInterval(intervalId);
      });
          }
        }
      });
 


    } else {
      const swiper = new Swiper(this.element.querySelector('.swiper'), {
        slidesPerView: "5.6",
        spaceBetween: 0,
        autoplay: {
          delay: 1,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        freeMode: {
          enabled: false,
          momentum: false,
          momentumBounce: false,

        },
        speed: 8000,
        loop: true,
        loopedSlides: 16,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
        grabCursor: true,
        mousewheelControl: true,
        keyboardControl: true,
        // Responsive breakpoints
        breakpoints: {
        
          // when window width is <= 1025px
          1024: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        on: {
          init: function (){
            
            const homeSwiper = $('.swiper-slide', $this);
            $(homeSwiper).hover(function(e){
              var intervalDelay = 500;
              intervalId = setInterval(doSomethingRepeatedly(e, swiper), intervalDelay);
      
      }, function () {
        clearInterval(intervalId);
      });
          }
        }
      });

    }
    

    }

   
}
customElements.define("home-slider", homeSlideshow);

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;

      case "desktop":
        return window.matchMedia("screen and (min-width: 1439px)").matches;

      case "large-desktop":
        return window.matchMedia("screen and (min-width: 1919px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }

    if (window.matchMedia("screen and (min-width: 1439px)").matches) {
      return "desktop";
    }

    if (window.matchMedia("screen and (min-width: 1919px)").matches) {
      return "large-desktop";
    }
  }
}

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    this.trueObserver = false;
    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 || 
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.createObserver();
    }
  }

  bindEvents() {
    window.removeEventListener("swiper:slide-changed", this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
   
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInicialization();
    } else {
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {

    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
      if (event.detail.currentIndex == this.elementPosition) {
        if (!this.element.getAttribute("loaded")) {
          var node = document.createElement("div");
          node.appendChild(
            this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
          );
          this.element.appendChild(node.firstElementChild).focus();
          this.element.setAttribute("loaded", true);
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options['viewport']) {
              this.videoPlayer.play();
              this.createObserver();
            }
          }
        } else {
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options['viewport']) {
              this.videoPlayer.play();
              this.createObserver();
            }
          }
        }
      } else if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
        this.videoPlayer.pause();
      }
    
  }

  videoPlayerInicialization() {
    var _this = this;
    if (!this.element.getAttribute("loaded")) {
      var node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      var isMobile = true;
    } else {
      var isMobile = false;
    }


    let img_plh = "",
        aspect_ratio = "",
        src = "",
        host = "html5",
        autoplay =  this.options['viewport'];
  
    if (isMobile) {

      img_plh = this.options["plh_mob"];
      if (this.options["aspect_mob"]) {
        aspect_ratio = this.options["aspect_mob"];
      } else {
        aspect_ratio = "9:16";
      }
      if (this.options["control_var"]) {
        if (this.options["videom"].includes('youtube')){
          host = 'youtube';
        } else if(this.options["videom"].includes('vimeo')) {
          host = 'vimeo';
        } 
          src = this.options["videom"];
        
      } else if (this.options["video_inside_media"]) {
        const sources = this.options["videod"]["sources"];;
        let topQuality = null;
        sources.forEach(obj => {
        if(obj.format === 'mp4'){
          if(!topQuality) topQuality = obj;
          if(topQuality.height < obj.height) topQuality=obj;
        }
        });
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality['url'] + "#t=0.001";
      } else {
        const aspectRatioHeight = Math.floor(100 / this.options["videom"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == 'youtube'){
          src =
          "https://www.youtube.com/watch?v=" +
          this.options["videom"]["external_id"];
        }else{
          src = this.options["videom"]["external_id"];

        }
        autoplay = false;
      }
  
    } else {

      img_plh = this.options["plh_desk"];
      if (this.options["aspect_desk"]) {
        aspect_ratio = this.options["aspect_desk"];
      } else {
        aspect_ratio = "16:9";
      }

      if (this.options["control_var"]) {
        if (this.options["videom"].includes('youtube')){
          host = 'youtube';
        } else if(this.options["videom"].includes('vimeo')) {
          host = 'vimeo';
        } 
        src = this.options["videod"];
      } else if (this.options["video_inside_media"]) {
        const sources = this.options["videod"]["sources"];;
        let topQuality = null;
        sources.forEach(obj => {
        if(obj.format === 'mp4'){
          if(!topQuality) topQuality = obj;
          if(topQuality.height < obj.height) topQuality=obj;
        }
        });
        src = topQuality['url'] + "#t=0.001";
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == 'youtube'){
          src =
          "https://www.youtube.com/watch?v=" +
          this.options["videod"]["external_id"];
          
        }else{
          src = this.options["videod"]["external_id"];
        }
      }
 
    }
    if (host == "youtube") {
      var type = "video/youtube";
    } else if(host == "vimeo") {
      var type = "video/vimeo";
    } else {
      var type = "video/mp4";
    }

    if(!this.options['plh']){
      img_plh = false;
    }

    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: autoplay,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: img_plh,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: true,
        pictureInPictureToggle: false,
        volumeControl: false,
        progressControl: {
          seekBar: false,
        },
        fullscreenToggle: true,
        playbackRateMenuButton: false,
      },
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };
 
    var videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";
      if (_this.trueObserver == false && _this.options['pause']) {
        _this.createObserver();
      }
      
    });
  }


  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
    });

    const target = this.element;
    observer.observe(target);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if(this.options['muted']){
            this.videoPlayer.muted('true');
          }
          this.videoPlayer.play();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class DomHelper {
  constructor() {}
  getSiblings(element, filter) {
    var includeSelf =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }
  outerWidthWithMargin(element) {
    var width = element.offsetWidth,
      style = getComputedStyle(element);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);

    return width;
  }
  outerHeightWithMargin(element) {
    var height = element.offsetHeight,
      style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
  }
}



class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.carousel = this.element.querySelectorAll(".MenuSlideshow");
    var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.domHelper = new DomHelper();

    // if (this.options.sticky) {
    //   this.toggleSticky();
    // }
    this.bindEvents();
    this.setProperty();
    this.menuOverlapHandler();
    
  }

  setProperty(){
    this.headerEl = document.querySelector('#site-control');
    document.documentElement.style.setProperty(
      "--header-height",
      this.headerEl.clientHeight + "px"
    );
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".Header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".HeaderWrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
    
      menuItems.closest(".header").appendChild(menuItems);
    
    }
    
    // document.documentElement.style.setProperty(
    //   "--header-height",
    //   _this.element.clientHeight + "px"
    // );
    menuItems.style.opacity = 1;
  }


  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function() {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    document.addEventListener('scroll', this.setProperty.bind(this));
    
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this), true
    );

    document.addEventListener(
      "scroll", 
      this.setProperty.bind(this), true
    );
    
  }

  updateMenuPosition(target){    
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${target.getBoundingClientRect().top + target.offsetHeight + 3}px`
    );
  }

  openMenu(event, target) {
    
    this.element.dispatchEvent(
      new CustomEvent("menu:open", { bubbles: true })
    );

    if (event.type === "mouseenter" && target !== event.target) {return;}
    this.updateMenuPosition(target);
    target.setAttribute("aria-expanded", "true");

    this.domHelper
      .getSiblings(target, '[aria-expanded="true"]')
      .forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
      });
     
    var parentItem = event.target.querySelector('.mainLinks');
    var menuLinks = event.target.querySelector('.mainMenu--LinkHolder');
    
    const positionLeft = parentItem.offsetLeft; 
    menuLinks.style.marginLeft = positionLeft - 32 + 'px';

    let handleLinks = event.target.querySelectorAll('.mainMenu--MultipleItems');
    let handleLinksLinks = event.target.querySelectorAll('.mainMenu--MultipleItems_Content');
    let sublinkList = event.target.querySelector('.mainMenu--MultipleItems_subLink--wrapper');
    let mainMenu = event.target.querySelector('.mainMenu--Links');
    let menuContent = event.target.querySelectorAll('.mainMenu--MultipleItems_subLink--wrapper');
    
    let linkItem = document.querySelector('.mainMenu--MultipleItems[arria-expanded="true"]');
    if(linkItem){
      linkItem.setAttribute('arria-expanded', 'false');
    }
    mainMenu.style.minHeight = 'unset';

    handleLinks.forEach(function (item){
      let itemHandle = item.getAttribute('handle');
      item.addEventListener("mouseover", showLinks);
      
      function showLinks(){
        let linkItem = document.querySelector('.mainMenu--MultipleItems[arria-expanded="true"]');
        if(linkItem){
          linkItem.setAttribute('arria-expanded', 'false');
        }

        item.setAttribute('arria-expanded', 'true');

        menuContent.forEach((element) => {
          let elementHeight = element.querySelector('.MultipleItems_Content--wrapper');
          let computedStyle = window.getComputedStyle(element);
          if (computedStyle.display === 'grid') {
            mainMenu.style.minHeight = elementHeight.offsetHeight + 96 + 'px'
          } 
        })
              
      
      };

      
    });
   
  }

  closeMenu(event, target) {

    if (event.type === "mouseleave" && target !== event.target){return;}

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
        item.addEventListener("mouseleave", hideLinks);

        let handleLinksLinks = event.target.querySelectorAll('.mainMenu--MultipleItems_Content');
   
        function hideLinks(){
          handleLinksLinks.forEach(function (link){
            link.style.display = 'none';
            link.style.visibility = 'hidden';
          })
        }
     
    });

    

  }

}
customElements.define("header-component", Header);


class marketDropdown extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.domDelegate = new Delegate(document.body); 
      
      this.getPosition();
     // this.checkLocation();

    }


    connectedCallback() {
      this.domDelegate.on("click", '[data-action="link-item"]', this.checkLocation.bind(this));
    }

    disconnectedCallback() {
      this.domDelegate.destroy();
    }

    getPosition(){
      let parentItem = this.element.querySelector('.dropdown--deskButton');
      var childElement = this.element.querySelectorAll('.dropdown-list__item');

      if (!parentItem || !childElement) return;

      var leftPosition = parentItem.getBoundingClientRect().left;
     
      childElement.forEach(function (child){
        child.style.marginLeft = leftPosition - 32 + 'px';
      })
      
    }

    checkLocation(event) {
      event.preventDefault();
      event.stopPropagation();

      const link = event.target.getAttribute('data-url');
      if (!link) return;

      const currentUrl = new URL(window.location.href);
      let targetUrl;

      try {
        targetUrl = new URL(link, window.location.origin);
      } catch (err) {
        console.error('Invalid data-url:', link);
        return;
      }

      const targetCurrency = targetUrl.searchParams.get('currency');

      // Uzimamo trenutni path (product, collection, etc)
      const cleanPath = currentUrl.pathname;

      // Gradimo novi URL:
      const redirectUrl = new URL(targetUrl.origin);
      redirectUrl.pathname = cleanPath;

      const isMarketChange = targetUrl.origin !== currentUrl.origin;

      // Zadržavamo query parametre,
      // ali brišemo currency ako menjamo market
      currentUrl.searchParams.forEach((value, key) => {
        if (key === 'currency' && isMarketChange) return;
        redirectUrl.searchParams.set(key, value);
      });

      // Ako link ima currency → overwrite
      if (targetCurrency) {
        redirectUrl.searchParams.set('currency', targetCurrency);
      }

      // Hash ako postoji
      redirectUrl.hash = currentUrl.hash;

      window.location.href = redirectUrl.href;
    }
  
}
customElements.define("market-dropdown", marketDropdown);

class searchBar extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.searchElement = this;
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.searchInputElement = this.element.querySelector('[name="q"]');
      this.queryMap = {};
      this.searchResultsElement = this.element.querySelector(".SearchInitial");
      this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
      this.searchButton = this.element.querySelector(".compact");
                  
      this.bindEvents();
    }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 300);
    this.searchInputElement.addEventListener("input", this._onInputListener);
   
    // this.delegateElement.on(
    //     "click",
    //     '[data-action="search-string"]',
    //     this.onInput.bind(this)
    // );

    // Clear input when form is submitted
    const searchForm = this.element.querySelector('.search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', this.clearInputOnSubmit.bind(this));
    }

    document.addEventListener('favorite-product:open', this.closeSearch.bind(this));
    document.addEventListener('cart-drawer:open', this.closeSearch.bind(this));
    document.addEventListener('account-drawer:open', this.closeSearch.bind(this));
    document.addEventListener('menu:open', this.closeSearch.bind(this));
    document.addEventListener('search:open', this.focusSearchInput.bind(this));
  }

  closeSearch(){
    let searchModal = document.querySelector('#search-modal');
    searchModal.classList.remove("-in");
    searchModal.classList.remove("reveal");
    this.resetSearch();
  }

  focusSearchInput() {
    // Clear the input when opening the search modal
    if (this.searchInputElement) {
      this.searchInputElement.value = '';
    }
    // Focus the input with a delay to ensure modal is ready and keyboard opens on mobile
    // Using setTimeout to allow the modal animation to start and browser to process the focus
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
        // On mobile, sometimes we need to click to trigger keyboard, so we simulate a click
        if (window.innerWidth < 1025 || /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          this.searchInputElement.click();
        }
      }
    }, 150);
  }

  clearInputOnSubmit(event) {
    // Clear the input field after form submission
    // Use setTimeout to ensure it happens after navigation starts
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.value = '';
      }
    }, theme.SEARCH_CLEAR_INPUT_DELAY_MS);
  }

  debounce(fn, delay) {
    var _this0 = this;
    var timer = null;
    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  onInput(event) {
    event.preventDefault();
    const el = document.querySelector(".SearchInput").value;
    let modal = document.querySelector('#search-modal');
 
    if(el.length > 0){
      modal.style.background = '#fff';
      // this.searchButton.removeAttribute('disabled');
    }else{
      modal.style.background = 'rgba(255,255,255,.95)'
    }
    
    this.lastInputValue = event.target.value;
   
    var passTrough = false;
    var _this = this;
    
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.searchElement.querySelector(".SearchInput");
      passTrough = true;
      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;

          
    } else {
      if (event.keyCode === 13) {
        return;
      }
      if (this.lastInputValue === "") {
        this.resetSearch();
        return;
      }
    }

    var queryOptions = {
      method: "GET",
      credentials: "same-origin",
    };
    const url = `${theme.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=product`;

    var queries = [
      fetch(
        url,
        queryOptions
      )
    ];
    this.queryMap[this.lastInputValue] = true;

    Promise.all(queries).then(function (responses) {
      if (_this.lastInputValue !== event.target.value && passTrough == false) {
        return;
      }
      delete _this.queryMap[event.target.value];

      Promise.all(
        responses.map(function (response) {
        return response.text();
        })).then(function (contents) {

        //resultExists determines if there is any other results like products, articles or pages

        var resultExistsObject = [],
        resultExists = document.createElement('div');

        contents.forEach((item, i) => {
          
            if(item.includes('js-noresult')){
              resultExistsObject.push(false);
            }else{
              resultExistsObject.push(true);
            }

        });

          if(resultExistsObject.includes(true)){
            resultExists = true;
          }else{
            resultExists = false;
          }

        _this.loadData(resultExists, contents);

      });
    });

  }

   loadData(resultExists, data){

    switch(resultExists){
      case true:
        let content = "";
        let tempContent = "";
        let block = document.createElement('div');
        data.forEach((item, i) => {
          console.log(item.resources);
          if (i < 0) {
            block.innerHTML += item;

          } else {
            tempContent += item;
          }

        });

      content =  tempContent;
      this.searchResultsElement.innerHTML =
      `<div class='SearchLayout--2items'>${content}</div>`
      this.searchResultsElement.style.display = "flex";
      
      break;

      case false:
        let tempElement = document.createElement("div");
        tempElement.innerHTML = data[1];
        tempElement = tempElement.querySelector("template").content.firstElementChild.cloneNode(true);
        this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResults'); 
        this.searchResultsElement.style.display = "flex";
        // this.searchButton.setAttribute('disabled', 'true');
      break;
    }

    this.searchResultsElement.setAttribute("aria-hidden", "false");
    this.searchResultsElement.style.opacity = 1;

  }

  layouts(string1, string2, string3, type){
    var template = '';
    switch(type){

        case 'noResults':
        template =
        `<div class="SearchLayout__Section Search--Recommendations-noResults">${string1}</div>\n`;
        break;
    }

    return template;
  }
    
  resetSearch() {
    let initialProducts = this.searchResultsElement.querySelector('.SearchLayout--2items');
    let noProducts = this.searchResultsElement.querySelector('.SearchInitial--FirstView')
    this.searchResultsElement.style.display = "";
    if (initialProducts) { initialProducts.style.opacity = 0; }
    if (noProducts) { noProducts.style.opacity = 0; }
    const el = document.querySelector(".SearchInput");
    el.value = ""
  }

}
customElements.define("search-bar", searchBar);
class hideAnnouncement extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      if (this.getCookie('annoucement_bar_cookie')) {
        this.element.style.display = 'none';
      }
      this.bindEvents();
    }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="closeAnnouncement"]', this.hideAnnouncement.bind(this));
  }

  hideAnnouncement(event){
    event.preventDefault();
    event.stopPropagation();
    this.element.style.display = 'none';
    
    let expires = 30 * 86400
    document.cookie = 'annoucement_bar_cookie=true; max-age=' + expires;
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }

    return false;
  }
}

customElements.define("hide-announcement", hideAnnouncement);

class HomeGallery extends HTMLElement {
  constructor() {
      super();
       
      this.gallery = $(".section-gallery.home-section-gallery .cc-gallery .gallery__row");
      this.gallery.on("swipe", this.handleSlideChange.bind(this));

      this.gallery.each((index, elem) => {
        elem.dispatchEvent(new Event('swipe'))
      })
    }

  handleSlideChange() {
    const target = event.target.closest(".gallery__row");
    if (!target) return;

    const dots = target.querySelector(".slick-dots");
    console.log(target.querySelector(".slick-active"));
    let activeSlideContent = target.querySelector(".slick-active .video-container") ? 
      target.querySelector(".slick-active .video-container") : target.querySelector(".slick-active img");
                  
    // wrapper has top padding of 25
    // 12px from bottom of the image
    if(!dots) return;
    dots.style.top = activeSlideContent.offsetHeight + 25 - 12 + "px";
    dots.style.bottom = "0px";
  }
}

customElements.define("home-gallery", HomeGallery);

class HomePageGallery extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.section = this.element.querySelector('.section-homepage_gallery');
    
    if (new Responsive().matchesBreakpoint('large-desktop')) {
      this.menuItem = document.querySelector('.headerLinks:nth-child(4)');
    } else if (new Responsive().matchesBreakpoint('lap-and-up')) {
      this.menuItem = document.querySelector('.headerLinks:nth-child(3)');
    }

    this.handleMargins();
      
  }

  handleMargins() {
    if (this.menuItem) {
      this.margin = this.menuItem.offsetLeft;
      this.section.style.marginLeft = this.margin + 'px';
      this.section.style.marginRight = this.margin + 'px';
    } 
  }
}

customElements.define("homepage-gallery", HomePageGallery);

class KlaviyoPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    new Popup(this.element);
  }

  connectedCallback() {
    this.delegateElement.on("click", '[data-action="sendToKlaviyo"]', this.klaviyoSubmit.bind(this));
    this.delegateElement.on("click", ".error_message", this.hideErrorMessage.bind(this));
    this.delegateElement.on("click", ".segmentInput", this.hideSegmentErrorMessage.bind(this));
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
  }

  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }


  klaviyoSubmit(event) {
    event.preventDefault();

    const formElement = event.target.closest("form");
    const email = formElement.querySelector('[name="email"]').value.trim();
    const listId = this.element.querySelector("#listid").value;
    const selectedSegments = this.getSelectedSegments();
    const errorMsg = this.element.querySelector(".error_message");
    const errorMsg2 = this.element.querySelector(".error_message2");

    if (!selectedSegments.length) {
      errorMsg2.style.display = "block";
      return;
    }

    if (!this.validateEmail(email)) {
      errorMsg.style.display = "block";
      return;
    }

    this.sendToKlaviyo(email, listId, selectedSegments.join(","))
      .then((response) => {
        if (response.success) {
          this.showSuccessMessage(formElement);
        }
      })
      .catch((error) => {
        console.error("Klaviyo error:", error);
      });
  }

  getSelectedSegments() {
    const selected = [];
    const inputs = this.element.querySelectorAll(".segmentInput");

    inputs.forEach((input) => {
      if (input.checked) {
        selected.push(input.dataset.segment);
      }
    });

    return selected;
  }

  async sendToKlaviyo(email, listId, gender) {
    const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    const data = new URLSearchParams({
      g: listId,
      $fields: "$gender, $source",
      email,
      $gender: gender,
      $source: "Shopify pop-up",
    });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data.toString(),
    });

    return await response.json();
  }

  hideErrorMessage(event) {
    const errorMsg = event.currentTarget;
    const inputEl = this.element.querySelector(".cursor");
    errorMsg.style.display = "none";
    if (inputEl) inputEl.style.display = "block";
  }

  hideSegmentErrorMessage() {
    const errorMsg2 = this.element.querySelector(".error_message2");
    errorMsg2.style.display = "none";
  }

  showSuccessMessage(formElement) {
    const link = this.element.querySelector(".popupLink")?.getAttribute("href") || "#";

    formElement.innerHTML = `
      <div class="PopupThanksMsg">${theme.strings.popup_success}</div>
      <div class="popupThanksLink"><a href="${link}">${theme.strings.popup_explore}</a></div>
    `;
  }
}

customElements.define("klaviyo-popup", KlaviyoPopup);


class NewsletterModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.assignVariables();

    if (this.testMode) this.displayPopup();
    else this.handleDisplayPopup();
  }

  assignVariables() {
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document.body); 

    this.cookieBanner = document.querySelector('#shopify-pc__banner');
    this.newsletterPopup = document.querySelector('newsletter-modal');
    this.newsletterPopup.classList.remove('popup-visible'); 
    this.focusableElement = this.newsletterPopup.querySelector('.section-popup_newsletter');
    this.pageOverlay = document.querySelector('.popup__overlay');
    this.testMode = this.element.querySelector("[data-test-mode]")?.dataset.testMode === "true";

    this.options = JSON.parse(this.focusableElement.getAttribute('data-settings'));
    new Popup(this.element);
  }

  connectedCallback() {
    this.delegateElement.on(
      "click",
      "[data-action=close-popup]",
      this.closePopup.bind(this)
    );

    this.domDelegate.on(
      'click',
      '#shopify-pc__banner__btn-accept',
      this.displayPopup.bind(this)
    );

    this.domDelegate.on(
      'click',
      '#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-decline',
      this.displayPopup.bind(this)
    );
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
    this.domDelegate.destroy();
  }

  handleDisplayPopup() {
    console.log('handleDisplayPopup start');

    if (!this.options) {
      console.error('Opcije nisu pravilno definisane.');
      return;
    }

    const lastShown = localStorage.getItem('newsletterPopupLastShown');
    if (lastShown) {
      const lastShownDate = new Date(lastShown);
      const now = new Date();
      const diffInDays = (now - lastShownDate) / (1000 * 60 * 60 * 24);

      if (diffInDays < this.options['dismiss']) {
        return;
      }
    }

    setTimeout(() => {
      if (!document.querySelector('#shopify-pc__banner')) {
        this.displayPopup();
      }
    }, 2000);
  }

  closePopup() {
    this.newsletterPopup.setAttribute("aria-hidden", "true");

    setTimeout(() => {
      this.newsletterPopup.style.display = 'none';
      removeTrapFocus(this.focusableElement);
    }, 300);

    this.hideOverlay();
  }

  displayPopup() {
    console.log('display popup');

    setTimeout(() => {
      this.newsletterPopup.classList.add('popup-visible');
      window.requestAnimationFrame(() => this.newsletterPopup.setAttribute("aria-hidden", "false"));
      this.showOverlay();
      this.el = this.element.querySelector('.section-popup_newsletter');
      this.el.classList.add('modal-visible');

      if (!this.testMode) {
        localStorage.setItem('newsletterPopupLastShown', new Date().toISOString());
      }

      bodyScrollLock.disableBodyScroll(this.newsletterPopup, bodyScrollLockOptions);
      trapFocus(this.focusableElement);
    }, this.options['timeout'] || 5000);
  }

  showOverlay() {
    this.pageOverlay.classList.add('is-visible');
    
    this.bindClosePopup = this.closePopup.bind(this);
    this.pageOverlay.addEventListener("click", this.bindClosePopup);
  }

  hideOverlay() {
    this.pageOverlay.classList.remove('is-visible');
    this.pageOverlay.removeEventListener("click", this.bindClosePopup);
    bodyScrollLock.clearAllBodyScrollLocks();
  }
}

customElements.define("newsletter-modal", NewsletterModal);


class StickyForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.footerEl = document.querySelector('#shopify-section-footer');
    console.log(this.footerEl)
  }

  connectedCallback(){
    const observer = new IntersectionObserver (
      (entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting) {
            this.element.style.transform = 'translateY(100%)';
          } else {
            this.element.style.transform = 'translateY(0%)';
          }
        })
      },
      {
        root: null,
        treshold: 0
      }
    );

    observer.observe(this.footerEl);
  }
}

customElements.define("sticky-form", StickyForm);

const depictGridState = new WeakMap();

function scheduleDepictGridRecalc(grid) {
  let state = depictGridState.get(grid);

  if (!state) {
    state = { rafId: null, lastMax: 0 };
    depictGridState.set(grid, state);
  }
  
  if (state.rafId != null) return;

  state.rafId = requestAnimationFrame(() => {
    state.rafId = null;
    const containers = grid.querySelectorAll('product-card.product-card-depict');
    let maxHeight = 0;

    for (let i = 0; i < containers.length; i++) {
      const h = parseFloat(containers[i].getAttribute('data-height'), 10) || 0;
      if (h > maxHeight) maxHeight = h;
    }

    if (maxHeight !== state.lastMax) {
      state.lastMax = maxHeight;
      grid.style.setProperty('--depict-row-gap', `${maxHeight}px`);
    }
  });
}

class ProductCard extends HTMLElement {
  constructor(){
    super();
    this.element = this;
    this.swiper = null;
    this.initialized = false;
  }

  connectedCallback(){
    this.checkIfDepict();
    this.initObserver();
  }

  checkIfDepict() {
    const parent = this.element.parentElement;
    if (!parent.querySelector('.depict-content-block')) return;

    this.element.classList.add('product-card-depict');
    parent.classList.add('collection-grid-depict');

    this.bindDepictEvents();
  }

  bindDepictEvents() {
    // Runs on both mobile and desktop; getTotalHeight picks .not_mobile vs .not_desktop by viewport
    const linkContainer = this.element.querySelector('.product-link-container');
    const connectedDesktop = this.element.querySelector('.productCard--Connected.not_mobile');
    const connectedMobile = this.element.querySelector('.productCard--Connected.not_desktop');
    if (!linkContainer) return;
    let lastHeight = 0;

    const getTotalHeight = () => {
      const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
      const connected = isDesktop ? connectedDesktop : connectedMobile;
      let h = linkContainer.getBoundingClientRect().height;
      if (connected) h += connected.getBoundingClientRect().height;
      return h;
    };

    const updateHeight = () => {
      const linkHeight = linkContainer.getBoundingClientRect().height;
      this.element.style.setProperty('--product-link-container-height', `${linkHeight}px`);
      const height = getTotalHeight();
      if (height !== lastHeight) {
        lastHeight = height;
        this.element.setAttribute('data-height', height);
        const grid = this.element.closest('.collection-grid-depict');
        if (grid) scheduleDepictGridRecalc(grid);
      }
    };

    this._depictUpdateHeight = updateHeight;
    this.depictResizeObserver = new ResizeObserver(updateHeight);
    this.depictResizeObserver.observe(linkContainer);
    if (connectedDesktop) this.depictResizeObserver.observe(connectedDesktop);
    if (connectedMobile) this.depictResizeObserver.observe(connectedMobile);
    this._depictMql = window.matchMedia('(min-width: 1025px)');
    this._depictMql.addEventListener('change', updateHeight);
    requestAnimationFrame(updateHeight);
  }

  initObserver() {
    const swiperEl = this.element.querySelector('.pc__swiper');
    if (!swiperEl) return;

    // Use Intersection Observer to only init when visible (Safari optimization)
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.initialized) {
          this.initSwiper();
          observer.disconnect(); // Only init once
        }
      });
    }, {
      rootMargin: '50px' // Init slightly before visible
    });

    observer.observe(this.element);
  }

  initSwiper() {
    const swiperEl = this.element.querySelector('.pc__swiper');
    if (!swiperEl || this.initialized) return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
      touchReleaseOnEdges: true,
      autoHeight: false,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
    this.initialized = true;
  }

  disconnectedCallback(){
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
      this.initialized = false;
    }

    if (this.depictResizeObserver) {
      this.depictResizeObserver.disconnect();
      this.depictResizeObserver = null;
    }
    if (this._depictMql) {
      this._depictMql.removeEventListener('change', this._depictUpdateHeight);
      this._depictMql = null;
    }
  }
}

customElements.define("product-card", ProductCard);